'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var React = require('react');

var React__default = _interopDefault(React);

var cn = _interopDefault(require('classnames'));

var reactRouterDom = require('react-router-dom');

var recompose = require('recompose');

var styled = require('@quid-private/react-emotion');

var styled__default = _interopDefault(styled);

var debounce = _interopDefault(require('lodash.debounce'));

var reactPopper = require('react-popper');

require('popper.js');

var compareAsc = _interopDefault(require('date-fns/compare_asc'));

var chunk = _interopDefault(require('lodash.chunk'));

var addMonths = _interopDefault(require('date-fns/add_months'));

var getDaysInMonth = _interopDefault(require('date-fns/get_days_in_month'));

var pick = _interopDefault(require('lodash.pick'));

var deprecated = require('@quid-private/quid-styles/lib/deprecated');

var approx = _interopDefault(require('approximate-number'));

var Color = _interopDefault(require('color'));

var Downshift = _interopDefault(require('downshift'));

var styles = _interopDefault(require('@quid-private/quid-styles'));

var reactVirtualized = require('react-virtualized');

var scroll = _interopDefault(require('smooth-move'));

var throttle = _interopDefault(require('lodash.throttle'));

var PropTypes = _interopDefault(require('prop-types'));

var reactDom = require('react-dom');

var ResizeAware = require('react-resize-aware');

var ResizeAware__default = _interopDefault(ResizeAware);

var Infinite = _interopDefault(require('react-infinite'));

var omit = _interopDefault(require('lodash.omit'));

var withContext = require('with-context');

var AnimateHeight = _interopDefault(require('react-animate-height'));

var reactFlipToolkit = require('react-flip-toolkit');

var parse = _interopDefault(require('date-fns/parse'));

var nanoid = _interopDefault(require('nanoid'));

var MarkdownToJsx = _interopDefault(require('markdown-to-jsx'));

var ReactModal = _interopDefault(require('react-modal'));

var Transition = _interopDefault(require('react-transition-group/Transition'));

var reactTransitionGroup = require('react-transition-group');

var kebabCase = _interopDefault(require('lodash.kebabcase'));

var styles$1 = {
  "BasicPanel": "quid-react-components__src-components-BasicPanel-__BasicPanel",
  "BasicPanel--column": "quid-react-components__src-components-BasicPanel-__BasicPanel--column",
  "BasicPanel--row": "quid-react-components__src-components-BasicPanel-__BasicPanel--row"
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var defineProperty = function defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var toConsumableArray = function toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
};

function BasicPanel(_ref) {
  var flexDirection = _ref.flexDirection,
      className = _ref.className,
      props = objectWithoutProperties(_ref, ['flexDirection', 'className']);
  return React__default.createElement('div', _extends({
    className: cn(styles$1.BasicPanel, flexDirection && styles$1['BasicPanel--' + flexDirection], className)
  }, props));
}

var styles$2 = {
  "Breadcrumb__arrow": "quid-react-components__src-components-Breadcrumb-__Breadcrumb__arrow",
  "Breadcrumb__item": "quid-react-components__src-components-Breadcrumb-__Breadcrumb__item",
  "Breadcrumb__item--active": "quid-react-components__src-components-Breadcrumb-__Breadcrumb__item--active",
  "Breadcrumb__item--emphasized": "quid-react-components__src-components-Breadcrumb-__Breadcrumb__item--emphasized",
  "Breadcrumb__item--disabled": "quid-react-components__src-components-Breadcrumb-__Breadcrumb__item--disabled",
  "Breadcrumb": "quid-react-components__src-components-Breadcrumb-__Breadcrumb"
};

function NavLink(_ref) {
  var to = _ref.to,
      _ref$external = _ref.external,
      external = _ref$external === undefined ? false : _ref$external,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === undefined ? false : _ref$disabled,
      activeClassName = _ref.activeClassName,
      props = objectWithoutProperties(_ref, ['to', 'external', 'disabled', 'activeClassName']);

  if (external || disabled) {
    return React__default.createElement('a', _extends({
      href: !disabled ? to : undefined
    }, props));
  } else {
    return React__default.createElement(reactRouterDom.NavLink, _extends({
      exact: true,
      to: to,
      activeClassName: activeClassName
    }, props));
  }
} // Provided a component name, and a component
// this function is going to assign a `staticName` property
// to make it recognizable from the outside
//
// Especially useful in case of wrapped components


function exposeName(name) {
  return function nameIt(Component) {
    Component.staticName = name;
    return Component;
  };
}

function getName(child) {
  // if a ReactComponent is passed, we read it directly
  // if it's a ReactElement, we have to access its `type`
  return child.type ? child.type.staticName : child.staticName;
}

var enhance = recompose.compose(recompose.setDisplayName('Icon'), exposeName('Icon'), recompose.defaultProps({
  squared: true
}), recompose.mapProps(function (props) {
  return _extends({}, props, {
    children: props.name
  });
}));
var _ref = 'display:inline-flex;align-items:center;justify-content:center;height:0.93em;width:0.93em;';
var Icon =
/*#__PURE__*/
styled__default('i', {
  target: 'e1s7budd0'
})('font-family:\'quid-icons\' !important;speak:none;font-style:normal;font-weight:normal;font-variant:normal;text-transform:none;line-height:inherit;word-break:normal;letter-spacing:0;font-feature-settings:\'liga\';font-variant-ligatures:discretionary-ligatures;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;', function (props) {
  return props.squared &&
  /*#__PURE__*/
  styled.css(_ref);
}, ';');
var Icon$1 = enhance(Icon); // This is mostly to avoid async troubles during tests, but it also
// prevents to make asynchronous the callback when the delay is set to 0
// and it should actually be synchronous

function conditionalDebounce(callback, delay) {
  if (delay > 0) {
    return debounce(callback, delay);
  }

  return callback;
}

var MouseOutside = function (_Component) {
  inherits(MouseOutside, _Component);

  function MouseOutside() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, MouseOutside);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = MouseOutside.__proto__ || Object.getPrototypeOf(MouseOutside)).call.apply(_ref, [this].concat(args))), _this), _this.onMouseMoveOutsideDelayed = undefined, _this.isTargetOutside = function (target) {
      return (// $FlowFixMe HTMLDocument isn't supported (https://github.com/facebook/flow/issues/2839)
        (target instanceof HTMLElement || target instanceof HTMLDocument) && _this.container instanceof HTMLElement && !_this.container.contains(target) && document.contains(target)
      );
    }, _this.handleClickOutside = function (evt) {
      if (_this.props.onClickOutside && _this.isTargetOutside(evt.target)) {
        _this.props.onClickOutside(evt);
      }
    }, _this.handleMouseMoveOutside = conditionalDebounce(function (evt) {
      if (_this.props.onMouseMoveOutside && _this.isTargetOutside(evt.target)) {
        _this.props.onMouseMoveOutside(evt);
      }
    }, _this.props.delay), _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(MouseOutside, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.onClickOutside) {
        document.addEventListener('click', this.handleClickOutside, true);
      }

      if (this.props.onMouseMoveOutside) {
        document.addEventListener('mousemove', this.handleMouseMoveOutside, true);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleClickOutside, true);
      document.removeEventListener('mousemove', this.handleMouseMoveOutside, true);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          tag = _props.tag,
          onClickOutside = _props.onClickOutside,
          onMouseMoveOutside = _props.onMouseMoveOutside,
          delay = _props.delay,
          props = objectWithoutProperties(_props, ['tag', 'onClickOutside', 'onMouseMoveOutside', 'delay']);
      var Tag = tag;
      return React__default.createElement(Tag, _extends({}, props, {
        ref: function ref(el) {
          return el !== null && (_this2.container = el);
        }
      }));
    }
  }]);
  return MouseOutside;
}(React.Component);

MouseOutside.defaultProps = {
  delay: 0,
  tag: 'div'
};
var styles$3 = {
  "Popover": "quid-react-components__src-components-Popover-__Popover",
  "Popover__target": "quid-react-components__src-components-Popover-__Popover__target",
  "Popover__arrow": "quid-react-components__src-components-Popover-__Popover__arrow",
  "Popover__arrow--border": "quid-react-components__src-components-Popover-__Popover__arrow--border"
};

function Popover(props) {
  var id = props.id,
      children = props.children,
      popover = props.popover,
      _props$placement = props.placement,
      placement = _props$placement === undefined ? 'bottom' : _props$placement,
      onOpen = props.onOpen,
      onClose = props.onClose,
      isOpen = props.isOpen,
      _props$closeOnClickOu = props.closeOnClickOutside,
      closeOnClickOutside = _props$closeOnClickOu === undefined ? true : _props$closeOnClickOu,
      _props$targetComponen = props.targetComponent,
      targetComponent = _props$targetComponen === undefined ? false : _props$targetComponen,
      _props$popperModifier = props.popperModifiers,
      popperModifiers = _props$popperModifier === undefined ? {} : _props$popperModifier,
      otherProps = objectWithoutProperties(props, ['id', 'children', 'popover', 'placement', 'onOpen', 'onClose', 'isOpen', 'closeOnClickOutside', 'targetComponent', 'popperModifiers']);

  var modifiers = _extends({
    computeStyle: {
      y: placement.includes('top') ? 'top' : 'bottom',
      x: placement.includes('left') ? 'left' : 'right'
    }
  }, popperModifiers);

  var targetProps = {
    onClick: isOpen ? onClose : onOpen,
    'aria-describedby': id
  };
  return React__default.createElement(reactPopper.Manager, {
    tag: false
  }, React__default.createElement(MouseOutside, _extends({
    tag: 'span',
    onClickOutside: closeOnClickOutside ? onClose : undefined
  }, otherProps), React__default.createElement(reactPopper.Target, _extends({
    className: styles$3.Popover__target,
    component: targetComponent ? targetComponent : 'span'
  }, targetComponent ? targetProps : {}), targetComponent === false && children ? React.cloneElement(children, targetProps) : children), isOpen && React__default.createElement(reactPopper.Popper, {
    placement: placement,
    modifiers: modifiers,
    className: styles$3.Popover,
    role: 'tooltip',
    id: id,
    'data-theme': 'light'
  }, React__default.createElement(reactPopper.Arrow, {
    className: styles$3.Popover__arrow
  }, React__default.createElement('div', {
    className: cn(styles$3.Popover__arrow, styles$3['Popover__arrow--border'])
  })), popover)));
}

var styles$4 = {
  "Tooltip": "quid-react-components__src-components-Tooltip-__Tooltip"
};

var Tooltip = function (_Component) {
  inherits(Tooltip, _Component);

  function Tooltip() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Tooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isOpen: false
    }, _this.timeout = null, _this.clearTimeout = function () {
      return _this.timeout && clearTimeout(_this.timeout);
    }, _this.handleClose = function () {
      _this.clearTimeout();

      _this.timeout = setTimeout(function () {
        return _this.handleInstantClose();
      }, _this.props.delay);
    }, _this.handleInstantClose = function () {
      _this.setState({
        isOpen: false
      });
    }, _this.handleOpen = function () {
      _this.clearTimeout();

      _this.setState({
        isOpen: true
      });
    }, _this.handleToggle = function () {
      return _this.setState(function (_ref2) {
        var isOpen = _ref2.isOpen;
        return {
          isOpen: !isOpen
        };
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Tooltip, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          placement = _props.placement,
          tooltip = _props.tooltip,
          id = _props.id,
          delay = _props.delay,
          props = objectWithoutProperties(_props, ['placement', 'tooltip', 'id', 'delay']);
      return React__default.createElement(MouseOutside, {
        tag: 'span',
        onMouseMoveOutside: this.handleClose,
        onClickOutside: this.handleInstantClose,
        onMouseEnter: this.handleOpen,
        onClick: this.handleToggle
      }, React__default.createElement(Popover, _extends({
        isOpen: this.state.isOpen,
        targetComponent: 'span',
        placement: placement,
        closeOnClickOutside: false,
        delay: delay,
        id: id,
        popover: React__default.createElement('div', {
          className: styles$4.Tooltip
        }, tooltip)
      }, props)));
    }
  }]);
  return Tooltip;
}(React.Component);

Tooltip.defaultProps = {
  placement: 'bottom',
  delay: 250
};

function genItem(_ref, index) {
  var label = _ref.label,
      path = _ref.path,
      _ref$arrowIcon = _ref.arrowIcon,
      arrowIcon = _ref$arrowIcon === undefined ? 'angle_right' : _ref$arrowIcon,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === undefined ? false : _ref$disabled,
      _ref$external = _ref.external,
      external = _ref$external === undefined ? false : _ref$external,
      _ref$emphasized = _ref.emphasized,
      emphasized = _ref$emphasized === undefined ? false : _ref$emphasized,
      _ref$tooltip = _ref.tooltip,
      tooltip = _ref$tooltip === undefined ? '' : _ref$tooltip;
  return [React__default.createElement(NavLink, {
    to: path,
    className: cn(styles$2.Breadcrumb__item, emphasized && styles$2['Breadcrumb__item--emphasized'], disabled && styles$2['Breadcrumb__item--disabled']),
    activeClassName: styles$2['Breadcrumb__item--active'],
    external: external,
    disabled: disabled,
    key: index
  }, tooltip ? React__default.createElement(Tooltip, {
    tooltip: tooltip,
    id: 'breadcrumb-' + index + '-tooltip'
  }, label) : label), React__default.createElement('div', {
    className: styles$2.Breadcrumb__arrow,
    key: index + '_arrow'
  }, React__default.createElement(Icon$1, {
    name: arrowIcon
  }))];
}

function Breadcrumb(_ref2) {
  var items = _ref2.items,
      className = _ref2.className,
      props = objectWithoutProperties(_ref2, ['items', 'className']);
  var processedItems = items.map(genItem).reduce(function (a, b) {
    return a.concat(b);
  }, []).slice(0, -1);
  return React__default.createElement('ul', _extends({
    className: cn(styles$2.Breadcrumb, className)
  }, props), processedItems);
}

var styles$5 = {
  "Button": "quid-react-components__src-components-Button-__Button",
  "Button--primary": "quid-react-components__src-components-Button-__Button--primary",
  "Button--secondary": "quid-react-components__src-components-Button-__Button--secondary",
  "Button--okay": "quid-react-components__src-components-Button-__Button--okay",
  "Button--warning": "quid-react-components__src-components-Button-__Button--warning",
  "Button--hazard": "quid-react-components__src-components-Button-__Button--hazard",
  "Button--transparent": "quid-react-components__src-components-Button-__Button--transparent",
  "Button--small": "quid-react-components__src-components-Button-__Button--small",
  "Button--disabled": "quid-react-components__src-components-Button-__Button--disabled",
  "Button__inner": "quid-react-components__src-components-Button-__Button__inner",
  "Button__icon": "quid-react-components__src-components-Button-__Button__icon",
  "Button__icon--alone": "quid-react-components__src-components-Button-__Button__icon--alone",
  "Button__icon--small": "quid-react-components__src-components-Button-__Button__icon--small",
  "Button__icon--side": "quid-react-components__src-components-Button-__Button__icon--side",
  "Button--groupChild": "quid-react-components__src-components-Button-__Button--groupChild"
};
var IMPORTANCE_SECONDARY = 'secondary';
var SIZE_SMALL = 'small'; // Checks if the given child is an Icon component
// if so, adds some classes to properly style the icon
// inside its parent Button.
// If it doesn't find an icon, it returns the original component.

function enhanceIfIcon(child, key, count, size) {
  if (!React.isValidElement(child)) {
    return child;
  }

  return React.cloneElement(child, {
    key: key,
    className: getName(child) === getName(Icon$1) ? cn(styles$5['Button__icon'], count === 1 && styles$5['Button__icon--alone'], count === 1 && size === 'small' && styles$5['Button__icon--small'], count > 1 && key === 0 && styles$5['Button__icon--side']) : undefined
  });
}

function Button(_ref) {
  var _cn;

  var _ref$type = _ref.type,
      type = _ref$type === undefined ? 'button' : _ref$type,
      text = _ref.text,
      to = _ref.to,
      href = _ref.href,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === undefined ? false : _ref$disabled,
      dataAction = _ref['data-action'],
      _ref$importance = _ref.importance,
      importance = _ref$importance === undefined ? IMPORTANCE_SECONDARY : _ref$importance,
      _ref$transparent = _ref.transparent,
      transparent = _ref$transparent === undefined ? false : _ref$transparent,
      size = _ref.size,
      innerClassName = _ref.innerClassName,
      innerStyle = _ref.innerStyle,
      className = _ref.className,
      style = _ref.style,
      getRef = _ref.getRef,
      children = _ref.children,
      _ref$isGroupChild = _ref.isGroupChild,
      isGroupChild = _ref$isGroupChild === undefined ? false : _ref$isGroupChild,
      props = objectWithoutProperties(_ref, ['type', 'text', 'to', 'href', 'disabled', 'data-action', 'importance', 'transparent', 'size', 'innerClassName', 'innerStyle', 'className', 'style', 'getRef', 'children', 'isGroupChild']); // Button style names

  className = cn(styles$5['Button'], styles$5['Button--' + importance], isGroupChild && styles$5['Button--groupChild'], (_cn = {}, defineProperty(_cn, styles$5['Button--small'], size === SIZE_SMALL), defineProperty(_cn, styles$5['Button--disabled'], disabled), defineProperty(_cn, styles$5['Button--transparent'], transparent), _cn), className);
  var Tag = void 0;

  if (to && !disabled) {
    Tag = reactRouterDom.Link;
  } else if (href || to && disabled) {
    Tag = 'a';
  } else {
    Tag = 'button';
  }

  var tagProps = {};
  tagProps.className = className;
  tagProps.style = style;
  tagProps.ref = getRef;
  tagProps['data-action'] = dataAction;

  if (Tag === 'button') {
    tagProps.type = type;
    tagProps.disabled = disabled;
  }

  if (Tag === reactRouterDom.Link) {
    tagProps.to = to;
  }

  if (Tag === 'a' && !disabled) {
    tagProps.href = href;
  }

  var childrenCount = React.Children.count(children);
  return React__default.createElement(Tag, _extends({}, tagProps, props), React__default.createElement('div', {
    className: cn(styles$5.Button__inner, innerClassName),
    style: innerStyle
  }, text ? text : React.Children.map(children, function (child, key) {
    return enhanceIfIcon(child, key, childrenCount, size);
  })));
}

var Button$1 = exposeName('Button')(Button);
var styles$6 = {
  "ButtonGroup": "quid-react-components__src-components-ButtonGroup-__ButtonGroup",
  "Button": "quid-react-components__src-components-ButtonGroup-__Button",
  "Button--inactive": "quid-react-components__src-components-ButtonGroup-__Button--inactive",
  "Button--active": "quid-react-components__src-components-ButtonGroup-__Button--active",
  "Button--secondary": "quid-react-components__src-components-ButtonGroup-__Button--secondary",
  "Button--first": "quid-react-components__src-components-ButtonGroup-__Button--first",
  "Button--last": "quid-react-components__src-components-ButtonGroup-__Button--last"
};

function ButtonGroup(_ref) {
  var buttonsState = _ref.buttonsState,
      onToggle = _ref.onToggle,
      children = _ref.children,
      _ref$importance = _ref.importance,
      importance = _ref$importance === undefined ? 'primary' : _ref$importance,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 'regular' : _ref$size,
      className = _ref.className,
      props = objectWithoutProperties(_ref, ['buttonsState', 'onToggle', 'children', 'importance', 'size', 'className']);
  return React__default.createElement('div', _extends({
    className: cn(styles$6.ButtonGroup, className)
  }, props), React.Children.map(children, function (child, key) {
    var _ref2 = buttonsState.find(function (_ref3) {
      var name = _ref3.name;
      return name === child.props.name;
    }) || {},
        _ref2$isActive = _ref2.isActive,
        isActive = _ref2$isActive === undefined ? false : _ref2$isActive;

    var isFirst = key === 0;
    var isLast = React.Children.count(children) - 1 === key;
    return React__default.createElement(child.type, _extends({}, child.props, {
      onClick: child.props.disabled ? undefined : function () {
        return onToggle && onToggle(child.props.name);
      },
      name: undefined,
      importance: importance,
      size: size,
      className: cn(child.props.className, styles$6['Button'], isActive ? styles$6['Button--active'] : styles$6['Button--inactive'], isFirst && styles$6['Button--first'], isLast && styles$6['Button--last']),
      key: key
    }));
  }));
}

var styles$7 = {
  "InputText": "quid-react-components__src-components-InputText-__InputText",
  "InputText__input": "quid-react-components__src-components-InputText-__InputText__input",
  "InputText__addon": "quid-react-components__src-components-InputText-__InputText__addon",
  "InputText--large": "quid-react-components__src-components-InputText-__InputText--large",
  "InputText--small": "quid-react-components__src-components-InputText-__InputText--small",
  "InputText__input--withAddon": "quid-react-components__src-components-InputText-__InputText__input--withAddon",
  "InputText__input--alignRight": "quid-react-components__src-components-InputText-__InputText__input--alignRight",
  "InputText__input--noAddonPadding": "quid-react-components__src-components-InputText-__InputText__input--noAddonPadding",
  "InputText__input--focus": "quid-react-components__src-components-InputText-__InputText__input--focus",
  "InputText__input--invalid": "quid-react-components__src-components-InputText-__InputText__input--invalid",
  "InputText__addon--noAddonPadding": "quid-react-components__src-components-InputText-__InputText__addon--noAddonPadding",
  "InputText--groupChild": "quid-react-components__src-components-InputText-__InputText--groupChild"
};

function Addon(_ref) {
  var _ref$noAddonPadding = _ref.noAddonPadding,
      noAddonPadding = _ref$noAddonPadding === undefined ? false : _ref$noAddonPadding,
      style = _ref.style,
      className = _ref.className,
      props = objectWithoutProperties(_ref, ['noAddonPadding', 'style', 'className']);
  return React__default.createElement('div', _extends({
    className: cn(styles$7['InputText__addon'], noAddonPadding && styles$7['InputText__addon--noAddonPadding'], className),
    style: style && {
      borderTopRightRadius: style.borderTopRightRadius,
      borderBottomRightRadius: style.borderBottomRightRadius
    }
  }, props));
}

var setHocDisplayName = function setHocDisplayName(displayName, hoc) {
  if (process.env.NODE_ENV !== 'production') {
    return function (BaseComponent) {
      return recompose.setDisplayName(recompose.wrapDisplayName(BaseComponent, displayName))(hoc(BaseComponent));
    };
  }

  return hoc;
};

var withInvalidHandler = setHocDisplayName('withInvalidHandler', recompose.withStateHandlers({
  _invalid: false
}, {
  _setInvalid: function _setInvalid() {
    return function () {
      return {
        _invalid: true
      };
    };
  },
  _handleChange: function _handleChange(_, props) {
    return function () {
      props.onChange && props.onChange.apply(props, arguments);
      return {
        _invalid: false
      };
    };
  }
}));
var enhance$1 = recompose.compose(exposeName('InputText'), recompose.setDisplayName('InputText'), withInvalidHandler);

function InputText(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === undefined ? 'text' : _ref$type,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 'regular' : _ref$size,
      addon = _ref.addon,
      alignRight = _ref.alignRight,
      noAddonPadding = _ref.noAddonPadding,
      style = _ref.style,
      getInputRef = _ref.getInputRef,
      _ref$isGroupChild = _ref.isGroupChild,
      isGroupChild = _ref$isGroupChild === undefined ? false : _ref$isGroupChild,
      outerClassName = _ref.outerClassName,
      outerStyle = _ref.outerStyle,
      _ref$focus = _ref.focus,
      focus = _ref$focus === undefined ? false : _ref$focus,
      className = _ref.className,
      onChange = _ref.onChange,
      _invalid = _ref._invalid,
      _setInvalid = _ref._setInvalid,
      _handleChange = _ref._handleChange,
      props = objectWithoutProperties(_ref, ['type', 'size', 'addon', 'alignRight', 'noAddonPadding', 'style', 'getInputRef', 'isGroupChild', 'outerClassName', 'outerStyle', 'focus', 'className', 'onChange', '_invalid', '_setInvalid', '_handleChange']);
  var textInput = void 0; // If `addon` is a function, we call it, passing as argument the
  // Addon component, this allows the consumer to extend it (or replace)
  // without relying on strict and complex to maintain prop-based APIs
  // If it's a valid node, simply render it

  var addonContent = typeof addon === 'function' ? addon(Addon) : addon ? React__default.createElement('div', {
    className: cn(styles$7['InputText__addon'], noAddonPadding && styles$7['InputText__addon--noAddonPadding']),
    tabIndex: 0,
    onFocus: function onFocus() {
      return textInput && textInput.focus();
    },
    style: style && {
      borderTopRightRadius: style.borderTopRightRadius,
      borderBottomRightRadius: style.borderBottomRightRadius
    }
  }, addon) : null;
  return React__default.createElement('div', {
    className: cn(styles$7['InputText'], isGroupChild && styles$7['InputText--groupChild'], size === 'large' && styles$7['InputText--large'], size === 'small' && styles$7['InputText--small'], outerClassName),
    style: outerStyle,
    'data-theme': 'light'
  }, React__default.createElement('input', _extends({
    type: type,
    className: cn(styles$7['InputText__input'], !!addon && styles$7['InputText__input--withAddon'], alignRight && styles$7['InputText__input--alignRight'], noAddonPadding && styles$7['InputText__input--noAddonPadding'], focus && styles$7['InputText__input--focus'], _invalid && styles$7['InputText__input--invalid'], className),
    onInvalid: _setInvalid,
    style: style,
    ref: function ref(el) {
      // Call `getInputRef` only if the element and the callback are defined
      el && getInputRef && getInputRef(el); // assign the element to `textInput` only if defined, this local
      // variables is going to be used in the `onFocus` callback

      el && (textInput = el);
    },
    onChange: _handleChange
  }, props)), addonContent);
}

var InputText$1 = enhance$1(InputText);
var compStyles = {
  "ButtonMenu--placeholder": "quid-react-components__src-components-ButtonMenu-__ButtonMenu--placeholder",
  "ButtonMenu": "quid-react-components__src-components-ButtonMenu-__ButtonMenu",
  "ButtonMenu--readOnly": "quid-react-components__src-components-ButtonMenu-__ButtonMenu--readOnly",
  "ButtonMenu--button": "quid-react-components__src-components-ButtonMenu-__ButtonMenu--button",
  "ButtonMenu__iconButton": "quid-react-components__src-components-ButtonMenu-__ButtonMenu__iconButton",
  "ButtonMenu__icon": "quid-react-components__src-components-ButtonMenu-__ButtonMenu__icon",
  "ButtonMenu__buttonInner": "quid-react-components__src-components-ButtonMenu-__ButtonMenu__buttonInner"
};
/**
 * @component
 */

function ButtonMenu(_ref) {
  var _ref$readOnly = _ref.readOnly,
      readOnly = _ref$readOnly === undefined ? false : _ref$readOnly,
      _ref$transparent = _ref.transparent,
      transparent = _ref$transparent === undefined ? false : _ref$transparent,
      value = _ref.value,
      placeholder = _ref.placeholder,
      _ref$styles = _ref.styles,
      styles$$1 = _ref$styles === undefined ? compStyles : _ref$styles,
      _ref$iconName = _ref.iconName,
      iconName = _ref$iconName === undefined ? 'caret_down' : _ref$iconName,
      onClick = _ref.onClick,
      className = _ref.className,
      props = objectWithoutProperties(_ref, ['readOnly', 'transparent', 'value', 'placeholder', 'styles', 'iconName', 'onClick', 'className']);
  var content = void 0;

  if (!transparent) {
    content = React__default.createElement(InputText$1, _extends({
      className: cn(styles$$1.ButtonMenu, readOnly && styles$$1['ButtonMenu--readOnly'], className),
      readOnly: readOnly,
      value: value,
      placeholder: placeholder,
      onClick: onClick,
      addon: function addon(Addon) {
        return iconName && React__default.createElement(Addon, {
          tabIndex: 0,
          className: styles$$1.ButtonMenu__iconButton,
          onClick: onClick
        }, React__default.createElement(Icon$1, {
          className: styles$$1.ButtonMenu__icon,
          squared: false,
          name: iconName
        }));
      }
    }, props));
  } else {
    content = React__default.createElement(Button$1, _extends({
      transparent: true,
      className: cn(styles$$1.ButtonMenu, transparent && styles$$1['ButtonMenu--button'], !value && styles$$1['ButtonMenu--placeholder'], className),
      innerClassName: styles$$1.ButtonMenu__buttonInner,
      onClick: onClick
    }, props), value || placeholder, iconName && React__default.createElement(Icon$1, {
      className: styles$$1.ButtonMenu__icon,
      squared: false,
      name: iconName
    }));
  }

  return content;
}

var styles$8 = {
  "Calendar": "quid-react-components__src-components-Calendar-__Calendar",
  "Calendar__year": "quid-react-components__src-components-Calendar-__Calendar__year",
  "Calendar__header": "quid-react-components__src-components-Calendar-__Calendar__header",
  "Calendar__nav": "quid-react-components__src-components-Calendar-__Calendar__nav",
  "Calendar__calendar": "quid-react-components__src-components-Calendar-__Calendar__calendar",
  "Calendar__table": "quid-react-components__src-components-Calendar-__Calendar__table",
  "Calendar__days": "quid-react-components__src-components-Calendar-__Calendar__days",
  "Calendar__action": "quid-react-components__src-components-Calendar-__Calendar__action",
  "Calendar__select": "quid-react-components__src-components-Calendar-__Calendar__select"
};
var styles$9 = {
  "Header": "quid-react-components__src-components-Calendar-Header-__Header",
  "Header__rest": "quid-react-components__src-components-Calendar-Header-__Header__rest",
  "Header__year": "quid-react-components__src-components-Calendar-Header-__Header__year"
};
var localeOptions = {
  weekday: 'short',
  month: 'long',
  day: 'numeric'
};
var empty = React__default.createElement('span', null, '\xA0');

function Header(_ref) {
  var year = _ref.year,
      month = _ref.month,
      day = _ref.day;
  var date = typeof year === 'number' && typeof month === 'number' && typeof day === 'number' && new Date(year, month, day);
  return React__default.createElement('div', {
    className: styles$9.Header
  }, React__default.createElement('div', {
    className: styles$9.Header__year
  }, year ? year : empty), React__default.createElement('div', {
    className: styles$9.Header__rest
  }, date && !isNaN(date) ? date.toLocaleDateString('en-us', localeOptions) : 'Invalid Date'));
}

var styles$10 = {
  "Cell--current": "quid-react-components__src-components-Calendar-Cell-__Cell--current",
  "Cell--selected": "quid-react-components__src-components-Calendar-Cell-__Cell--selected",
  "Cell__button--selected": "quid-react-components__src-components-Calendar-Cell-__Cell__button--selected",
  "Cell--header": "quid-react-components__src-components-Calendar-Cell-__Cell--header",
  "Cell": "quid-react-components__src-components-Calendar-Cell-__Cell",
  "Cell__button": "quid-react-components__src-components-Calendar-Cell-__Cell__button",
  "Cell__button--disabled": "quid-react-components__src-components-Calendar-Cell-__Cell__button--disabled"
};

function Cell(_ref) {
  var isCurrent = _ref.isCurrent,
      isSelected = _ref.isSelected,
      isHeader = _ref.isHeader,
      onClick = _ref.onClick,
      children = _ref.children,
      className = _ref.className,
      disabled = _ref.disabled,
      props = objectWithoutProperties(_ref, ['isCurrent', 'isSelected', 'isHeader', 'onClick', 'children', 'className', 'disabled']);
  return React__default.createElement('td', _extends({
    className: cn(styles$10['Cell'], isCurrent && styles$10['Cell--current'], isHeader && styles$10['Cell--header'], className)
  }, props), React__default.createElement('button', {
    type: 'button',
    onClick: onClick,
    disabled: disabled || isNaN(children),
    className: cn(styles$10['Cell__button'], isSelected && styles$10['Cell__button--selected'], disabled && styles$10['Cell__button--disabled'])
  }, children));
}

function Row(_ref) {
  var days = _ref.days,
      outerDate = _ref.date,
      selected = _ref.selected,
      onSelect = _ref.onSelect,
      maxDate = _ref.maxDate,
      minDate = _ref.minDate,
      props = objectWithoutProperties(_ref, ['days', 'date', 'selected', 'onSelect', 'maxDate', 'minDate']);
  return React__default.createElement('tr', props, days.map(function (day, key) {
    var date = new Date(outerDate.valueOf());
    date.setDate(day);
    var isCurrent = new Date(Date.now()).toDateString() === date.toDateString();
    var isSelected = selected && selected.toDateString() === date.toDateString(); // Disable the cell if the corresponding date is outside the minDate and maxDate

    var isTooLate = maxDate ? compareAsc(maxDate, date) === -1 : false;
    var isTooEarly = minDate ? compareAsc(date, minDate) === -1 : false;
    var disabled = isTooLate || isTooEarly;
    return React__default.createElement(Cell, {
      key: day || 'idx-' + key,
      onClick: function onClick() {
        return onSelect(date);
      },
      isCurrent: isCurrent,
      isSelected: isSelected,
      disabled: disabled
    }, day);
  }));
}

function loop(times) {
  return new Array(times).fill();
}

var DAYS_LABELS = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
var MONTHS_LABELS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
var WEEK_LENGTH = 7;
var MIN_ROWS = 6;
var MIN_CELLS = WEEK_LENGTH * MIN_ROWS;

var Calendar = function (_Component) {
  inherits(Calendar, _Component);

  function Calendar() {
    classCallCheck(this, Calendar);
    return possibleConstructorReturn(this, (Calendar.__proto__ || Object.getPrototypeOf(Calendar)).apply(this, arguments));
  }

  createClass(Calendar, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          innerRef = _props.innerRef,
          current = _props.current,
          onChangeCurrent = _props.onChangeCurrent,
          onSelect = _props.onSelect,
          onCancel = _props.onCancel,
          selected = _props.selected,
          className = _props.className,
          minDate = _props.minDate,
          maxDate = _props.maxDate,
          props = objectWithoutProperties(_props, ['innerRef', 'current', 'onChangeCurrent', 'onSelect', 'onCancel', 'selected', 'className', 'minDate', 'maxDate']); // Selected date

      var selectedDate = void 0,
          selectedYear = void 0,
          selectedMonth = void 0,
          selectedDay = void 0;

      if (selected) {
        selectedYear = selected.getFullYear();
        selectedMonth = selected.getMonth();
        selectedDay = selected.getDate();
        selectedDate = new Date(selectedYear, selectedMonth, selectedDay);
      } // Current date


      var year = current.getFullYear();
      var month = current.getMonth();
      var day = current.getDate(); // Calendar info

      var firstDay = new Date(year, month, 1);
      var startingDay = firstDay.getDay();
      var monthLength = getDaysInMonth(current);
      var monthName = MONTHS_LABELS[month]; // Create cells of days

      var days = loop(startingDay).fill().concat(loop(monthLength).map(function (_, i) {
        return i + 1;
      })).concat(loop(MIN_CELLS - (startingDay + monthLength))); // Split cells in rows

      var rows = chunk(days, WEEK_LENGTH);
      return React__default.createElement('div', _extends({
        className: cn(styles$8.Calendar, className),
        ref: innerRef,
        tabIndex: -1,
        'data-context': 'calendar'
      }, props), React__default.createElement(Header, {
        year: selectedYear,
        month: selectedMonth,
        day: selectedDay
      }), React__default.createElement('div', {
        className: styles$8['Calendar__calendar']
      }, React__default.createElement('table', {
        className: styles$8['Calendar__table']
      }, React__default.createElement('thead', null, React__default.createElement('tr', null, React__default.createElement('th', {
        colSpan: WEEK_LENGTH
      }, React__default.createElement('div', {
        className: styles$8['Calendar__header']
      }, React__default.createElement(Button$1, {
        className: styles$8['Calendar__nav'],
        'data-action': 'previous-month',
        transparent: true,
        onClick: function onClick() {
          return onChangeCurrent(addMonths(new Date(year, month, day), -1));
        }
      }, React__default.createElement(Icon$1, {
        name: 'chevron_left'
      })), React__default.createElement('span', {
        className: styles$8['Calendar__year']
      }, monthName, ' ', year), React__default.createElement(Button$1, {
        className: styles$8.Calendar__nav,
        'data-action': 'next-month',
        transparent: true,
        onClick: function onClick() {
          return onChangeCurrent(addMonths(new Date(year, month, day), +1));
        }
      }, React__default.createElement(Icon$1, {
        name: 'chevron_right'
      }))))), React__default.createElement('tr', null, DAYS_LABELS.map(function (weekDay, index) {
        return React__default.createElement(Cell, {
          key: index,
          isHeader: true
        }, weekDay);
      }))), React__default.createElement('tbody', {
        className: styles$8['Calendar__days']
      }, rows.map(function (days, index) {
        return React__default.createElement(Row, {
          key: index,
          days: days,
          date: new Date(year, month),
          selected: !isNaN(selectedDate) ? selectedDate : undefined,
          onSelect: _this2.props.onSelect,
          minDate: minDate,
          maxDate: maxDate
        });
      })))));
    }
  }]);
  return Calendar;
}(React.Component);

Calendar.defaultProps = {
  current: new Date()
};
var styles$11 = {
  "Separator": "quid-react-components__src-components-Separator-__Separator",
  "Separator--horizontal": "quid-react-components__src-components-Separator-__Separator--horizontal",
  "Separator--vertical": "quid-react-components__src-components-Separator-__Separator--vertical"
};

function Separator(_ref) {
  var _ref$orientation = _ref.orientation,
      orientation = _ref$orientation === undefined ? 'horizontal' : _ref$orientation,
      className = _ref.className,
      props = objectWithoutProperties(_ref, ['orientation', 'className']);
  return React__default.createElement('hr', _extends({
    className: cn(styles$11.Separator, styles$11['Separator--' + orientation], className)
  }, props));
}

var styles$12 = {
  "Card": "quid-react-components__src-components-Card-__Card",
  "Card__column": "quid-react-components__src-components-Card-__Card__column",
  "Card__side": "quid-react-components__src-components-Card-__Card__side",
  "Card__side--left": "quid-react-components__src-components-Card-__Card__side--left",
  "Card__separator": "quid-react-components__src-components-Card-__Card__separator",
  "Card__header": "quid-react-components__src-components-Card-__Card__header",
  "Card__headerRow": "quid-react-components__src-components-Card-__Card__headerRow",
  "Card__body": "quid-react-components__src-components-Card-__Card__body",
  "Card--skeleton": "quid-react-components__src-components-Card-__Card--skeleton"
};
var CARD_SIDE = 'Card.Side';

function Card(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = objectWithoutProperties(_ref, ['children', 'className']); // Get all the child components except for Card.Side that will
  // be treated differently

  var childrenArray = React.Children.toArray(children).filter(function (child) {
    return getName(child) !== CARD_SIDE;
  }); // Find any Card.Side component with the `left` prop set to `true`

  var cardSideLeft = React.Children.toArray(children).filter(function (child) {
    return getName(child) === CARD_SIDE && child.props.align === 'left';
  }); // Find any Card.Side component with the `right` prop set to `true`

  var cardSideRight = React.Children.toArray(children).filter(function (child) {
    return getName(child) === CARD_SIDE && child.props.align === 'right';
  });
  var header = childrenArray[0];
  var body = childrenArray.slice(1);
  var separator = body.length ? React__default.createElement(Separator, {
    className: styles$12.Card__separator
  }) : null; // We are going to compose the children found to properly lay them
  // in the card component

  return React__default.createElement('article', _extends({
    'data-theme': 'light',
    className: cn(styles$12.Card, className)
  }, props), cardSideLeft, React__default.createElement('main', {
    className: styles$12.Card__column
  }, header, separator, body), cardSideRight);
}

Card.Header = function (_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      props = objectWithoutProperties(_ref2, ['children', 'className']);
  return React__default.createElement('header', _extends({
    className: cn(className, styles$12.Card__header)
  }, props), React.Children.map(children, function (child) {
    return React__default.createElement('div', {
      className: styles$12.Card__headerRow
    }, child);
  }));
};

Card.Body = function (_ref3) {
  var className = _ref3.className,
      props = objectWithoutProperties(_ref3, ['className']);
  return React__default.createElement('div', _extends({
    className: cn(className, styles$12.Card__body)
  }, props));
};

Card.Side = exposeName(CARD_SIDE)(function (_ref4) {
  var align = _ref4.align,
      className = _ref4.className,
      props = objectWithoutProperties(_ref4, ['align', 'className']);
  return React__default.createElement('aside', _extends({
    className: cn(className, styles$12.Card__side, align === 'left' && styles$12['Card__side--left'])
  }, props));
});

Card.Skeleton = function Skeleton(_ref5) {
  var dataTheme = _ref5['data-theme'],
      children = _ref5.children;
  return React__default.createElement('div', {
    'data-theme': dataTheme,
    className: cn(styles$12.Card, styles$12['Card--skeleton'])
  }, children);
};

var styles$13 = {
  "Carousel": "quid-react-components__src-components-Carousel-Dot-__Carousel",
  "Carousel__scroller": "quid-react-components__src-components-Carousel-Dot-__Carousel__scroller",
  "Carousel__scroller--noPadding": "quid-react-components__src-components-Carousel-Dot-__Carousel__scroller--noPadding",
  "Carousel__list": "quid-react-components__src-components-Carousel-Dot-__Carousel__list",
  "Carousel__navButton": "quid-react-components__src-components-Carousel-Dot-__Carousel__navButton",
  "Carousel__navButton--right": "quid-react-components__src-components-Carousel-Dot-__Carousel__navButton--right",
  "Carousel__navButton--left": "quid-react-components__src-components-Carousel-Dot-__Carousel__navButton--left",
  "CarouselDot": "quid-react-components__src-components-Carousel-Dot-__CarouselDot",
  "CarouselDot--stacked2": "quid-react-components__src-components-Carousel-Dot-__CarouselDot--stacked2",
  "CarouselDot__button": "quid-react-components__src-components-Carousel-Dot-__CarouselDot__button",
  "CarouselDot__icon": "quid-react-components__src-components-Carousel-Dot-__CarouselDot__icon",
  "CarouselDot--stacked1": "quid-react-components__src-components-Carousel-Dot-__CarouselDot--stacked1",
  "CarouselDot--colorful": "quid-react-components__src-components-Carousel-Dot-__CarouselDot--colorful",
  "CarouselDot__button--active": "quid-react-components__src-components-Carousel-Dot-__CarouselDot__button--active",
  "CarouselDot__inner": "quid-react-components__src-components-Carousel-Dot-__CarouselDot__inner"
};

function CarouselDot(_ref) {
  var id = _ref.id,
      index = _ref.index,
      color = _ref.color,
      icon = _ref.icon,
      label = _ref.label,
      isActive = _ref.isActive,
      onClick = _ref.onClick,
      shift = _ref.shift,
      shiftLevel = _ref.shiftLevel,
      isVisible = _ref.isVisible,
      isColorful = _ref.isColorful;
  return React__default.createElement('li', {
    className: cn(styles$13['CarouselDot'], isColorful && styles$13['CarouselDot--colorful'], shiftLevel === 2 && styles$13['CarouselDot--stacked2'], shiftLevel === 1 && styles$13['CarouselDot--stacked1']),
    style: {
      transform: 'translateX(' + shift + 'px)',
      opacity: isVisible ? 1 : 0
    }
  }, React__default.createElement('button', {
    className: cn(styles$13['CarouselDot__button'], isActive && styles$13['CarouselDot__button--active']),
    tabIndex: isVisible ? 0 : -1,
    style: {
      color: color
    },
    title: label,
    'data-action': 'go-to-id',
    'data-value': id,
    onClick: function (_onClick) {
      function onClick() {
        return _onClick.apply(this, arguments);
      }

      onClick.toString = function () {
        return _onClick.toString();
      };

      return onClick;
    }(function () {
      return onClick(id);
    })
  }, React__default.createElement('div', {
    className: styles$13.CarouselDot__inner
  }, !!icon && React__default.createElement(Icon$1, {
    className: styles$13.CarouselDot__icon,
    name: icon
  }))));
}

var styles$14 = {
  "Carousel": "quid-react-components__src-components-Carousel-__Carousel",
  "Carousel__scroller": "quid-react-components__src-components-Carousel-__Carousel__scroller",
  "Carousel__scroller--noPadding": "quid-react-components__src-components-Carousel-__Carousel__scroller--noPadding",
  "Carousel__list": "quid-react-components__src-components-Carousel-__Carousel__list",
  "Carousel__navButton": "quid-react-components__src-components-Carousel-__Carousel__navButton",
  "Carousel__navButton--right": "quid-react-components__src-components-Carousel-__Carousel__navButton--right",
  "Carousel__navButton--left": "quid-react-components__src-components-Carousel-__Carousel__navButton--left"
};

function NavButton(_ref) {
  var disabled = _ref.disabled,
      onClick = _ref.onClick,
      icon = _ref.icon,
      direction = _ref.direction,
      className = _ref.className,
      props = objectWithoutProperties(_ref, ['disabled', 'onClick', 'icon', 'direction', 'className']);
  return React__default.createElement(Button$1, _extends({
    className: cn(styles$14['Carousel__navButton'], direction === 'left' && styles$14['Carousel__navButton--left'], direction === 'right' && styles$14['Carousel__navButton--right'], className),
    importance: 'secondary',
    size: 'small',
    onClick: onClick,
    disabled: disabled
  }, props), React__default.createElement(Icon$1, {
    name: icon
  }));
}

var ITEM_WIDTH = 1.857; // em

var LEFT = 37; // left keycode

var RIGHT = 39; // right keycode

var dependentStateProps = ['fontSize', 'width', 'widthInItems', 'maxWidthInItems', 'items', 'activeId'];

var Carousel = function (_Component) {
  inherits(Carousel, _Component);

  function Carousel() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Carousel);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      firstVisibleIndex: 0,
      visibleItemsCount: 0,
      scrollerWidth: 0,
      activeIndex: 0,
      itemWidth: 0
    }, _this.isIndexVisible = function (index, firstVisibleIndex, visibleItemsCount) {
      return firstVisibleIndex <= index && firstVisibleIndex + visibleItemsCount > index;
    }, _this.getActiveIndex = function (items, activeId) {
      return items.findIndex(function (item) {
        return item.id === activeId;
      });
    }, _this.updateDependentState = function (_ref2) {
      var fontSize = _ref2.fontSize,
          width = _ref2.width,
          widthInItems = _ref2.widthInItems,
          maxWidthInItems = _ref2.maxWidthInItems,
          items = _ref2.items,
          activeId = _ref2.activeId;

      var activeIndex = _this.getActiveIndex(items, activeId);

      var firstVisibleIndex = _this.state.firstVisibleIndex || activeIndex; // Compute the item width starting from the font size since we use EM units

      var itemWidth = ITEM_WIDTH * fontSize;
      var scrollerWidth = void 0;
      var visibleItemsCount = void 0;

      if (!widthInItems) {
        // Count the number of visible items in the given width
        visibleItemsCount = Math.floor(width / itemWidth); // Adjust the given width to make it fit an exact number of items

        scrollerWidth = visibleItemsCount * itemWidth;
      } else {
        visibleItemsCount = widthInItems;
        scrollerWidth = widthInItems * itemWidth;
      }

      if (maxWidthInItems) {
        scrollerWidth = Math.min(maxWidthInItems * itemWidth, scrollerWidth);
      } // Find next firstVisibleIndex


      var diff = _this.state.activeIndex - activeIndex;
      var direction = diff > 0 ? 1 : -1;

      while (!_this.isIndexVisible(activeIndex, firstVisibleIndex, visibleItemsCount)) {
        firstVisibleIndex -= direction;
      } // This avoids to set a `firstVisibleIndex` high enough to leave unused space
      // on the right of the carousel


      firstVisibleIndex = Math.min(items.length - visibleItemsCount, firstVisibleIndex);

      _this.setState({
        itemWidth: itemWidth,
        visibleItemsCount: visibleItemsCount,
        scrollerWidth: scrollerWidth,
        activeIndex: activeIndex,
        firstVisibleIndex: firstVisibleIndex
      });
    }, _this.handleKeyDown = function (_ref3) {
      var which = _ref3.which;
      var onChange = _this.props.onChange;

      if (which === LEFT) {
        onChange(_this.getPrevItem());
      }

      if (which === RIGHT) {
        onChange(_this.getNextItem());
      }
    }, _this.getPrevItem = function () {
      var prevIndex = _this.state.activeIndex - 1;
      return _this.props.items[prevIndex < 0 ? 0 : prevIndex].id;
    }, _this.getNextItem = function () {
      var max = _this.props.items.length - 1;
      var nextIndex = _this.state.activeIndex + 1;
      return _this.props.items[nextIndex <= max ? nextIndex : max].id;
    }, _this.getFirstItem = function () {
      return _this.props.items[0].id;
    }, _this.getLastItem = function () {
      return _this.props.items.slice(-1)[0].id;
    }, _temp), possibleConstructorReturn(_this, _ret);
  } // These computations must be performed on each props update because we
  // need these values to correctly perform the operations later


  createClass(Carousel, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.updateDependentState(pick(this.props, dependentStateProps));
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.updateDependentState(pick(nextProps, dependentStateProps));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          items = _props.items,
          onChange = _props.onChange,
          style = _props.style,
          fontSize = _props.fontSize,
          allowJump = _props.allowJump,
          noNavArrows = _props.noNavArrows,
          colorful = _props.colorful,
          activeId = _props.activeId,
          widthInItems = _props.widthInItems,
          maxWidthInItems = _props.maxWidthInItems,
          className = _props.className,
          props = objectWithoutProperties(_props, ['items', 'onChange', 'style', 'fontSize', 'allowJump', 'noNavArrows', 'colorful', 'activeId', 'widthInItems', 'maxWidthInItems', 'className']);
      var _state = this.state,
          activeIndex = _state.activeIndex,
          scrollerWidth = _state.scrollerWidth,
          firstVisibleIndex = _state.firstVisibleIndex,
          visibleItemsCount = _state.visibleItemsCount,
          itemWidth = _state.itemWidth;
      var lastVisibleIndex = firstVisibleIndex + visibleItemsCount;
      var offsetLeft = visibleItemsCount <= items.length ? itemWidth * firstVisibleIndex : 0;
      var firstId = this.getFirstItem();
      var prevId = this.getPrevItem();
      var nextId = this.getNextItem();
      var lastId = this.getLastItem();
      return React__default.createElement('nav', _extends({
        className: cn(styles$14.Carousel, className),
        style: _extends({}, style, {
          fontSize: fontSize
        }),
        tabIndex: 0,
        onKeyDown: this.handleKeyDown
      }, props), allowJump && React__default.createElement(NavButton, {
        onClick: function onClick() {
          return onChange(firstId);
        },
        'data-action': 'go-to-id',
        'data-value': firstId,
        disabled: activeIndex === 0,
        icon: 'angle_double_left',
        direction: 'left'
      }), !noNavArrows && React__default.createElement(NavButton, {
        onClick: function onClick() {
          return onChange(prevId);
        },
        'data-action': 'go-to-id',
        'data-value': prevId,
        disabled: activeIndex === 0,
        icon: 'chevron_left',
        direction: 'left'
      }), React__default.createElement('div', {
        className: cn(styles$14.Carousel__scroller, noNavArrows && styles$14['Carousel__scroller--noPadding']),
        style: {
          width: scrollerWidth
        }
      }, React__default.createElement('ul', {
        className: styles$14.Carousel__list,
        style: {
          transform: 'translateX(' + offsetLeft * -1 + 'px)'
        }
      }, items.map(function (dotProps, index) {
        var shift = 0;
        var shiftLevel = 0;
        var isVisible = true;

        var isIndexVisible = _this2.isIndexVisible(index, firstVisibleIndex, visibleItemsCount);

        if (!isIndexVisible) {
          if (index >= firstVisibleIndex - 2 && index < firstVisibleIndex) {
            shiftLevel = firstVisibleIndex - index;
            shift = shiftLevel * itemWidth / 2;
          } else if (index >= lastVisibleIndex && index < lastVisibleIndex + 2) {
            shiftLevel = (lastVisibleIndex - index - 1) * -1;
            shift = shiftLevel * -(itemWidth / 2);
          } else {
            isVisible = false;
          }
        }

        return React__default.createElement(CarouselDot, _extends({}, dotProps, {
          index: index,
          key: index,
          isActive: activeIndex === index,
          onClick: onChange,
          shift: shift,
          shiftLevel: shiftLevel,
          isVisible: isVisible,
          isColorful: colorful
        }));
      }))), !noNavArrows && React__default.createElement(NavButton, {
        onClick: function onClick() {
          return onChange(nextId);
        },
        'data-action': 'go-to-id',
        'data-value': nextId,
        disabled: activeIndex === items.length - 1,
        icon: 'chevron_right',
        direction: 'right'
      }), allowJump && React__default.createElement(NavButton, {
        onClick: function onClick() {
          return onChange(lastId);
        },
        'data-action': 'go-to-id',
        'data-value': lastId,
        disabled: activeIndex === items.length - 1,
        icon: 'angle_double_right',
        direction: 'right'
      }));
    }
  }]);
  return Carousel;
}(React.Component);

Carousel.defaultProps = {
  width: 200,
  widthInItems: null,
  //    < these take precedence over width
  maxWidthInItems: null,
  // < ^
  fontSize: 13,
  // Don't override it using CSS because the component needs to know it
  allowJump: false,
  // Jumps are the buttons that move to first/last item
  noNavArrows: false,
  // if true hides the navigation arrows
  colorful: false
};
var styles$15 = {
  "CircularMetricPoint": "quid-react-components__src-components-CircularMetricPoint-__CircularMetricPoint",
  "CircularMetricPoint__label": "quid-react-components__src-components-CircularMetricPoint-__CircularMetricPoint__label"
};
var defaultBackgroundColor = Color(deprecated.light.selected).alpha(0.3).string(); // Above this number the shortened value is going
// to be too long to be visualized in the widget

var MAX_SAFE_VALUE = 999999999999999;

function CircularMetricPoint(_ref) {
  var _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === undefined ? defaultBackgroundColor : _ref$backgroundColor,
      _ref$radius = _ref.radius,
      radius = _ref$radius === undefined ? 50 : _ref$radius,
      value = _ref.value;

  if (value > MAX_SAFE_VALUE) {
    throw new Error('CircularMetricPoint supports values up to `' + MAX_SAFE_VALUE + '`, you provided `' + value + '`');
  }

  return React__default.createElement('div', {
    className: styles$15.CircularMetricPoint,
    style: {
      width: radius,
      height: radius,
      backgroundColor: backgroundColor,
      fontSize: radius + 'px'
    }
  }, React__default.createElement('div', {
    className: styles$15.CircularMetricPoint__label
  }, approx(value).toUpperCase()));
}

function ClickOutside(props) {
  // eslint-disable-next-line no-console
  console.warn('ClickOutside is deprecated, replace it with MouseOutside from @quid-private/react-components!');
  return React__default.createElement(MouseOutside, props);
}

var styles$16 = {
  "ColorPalettePicker": "quid-react-components__src-components-ColorPalettePicker-__ColorPalettePicker",
  "ColorPalettePicker__color": "quid-react-components__src-components-ColorPalettePicker-__ColorPalettePicker__color",
  "ColorPalettePicker__input": "quid-react-components__src-components-ColorPalettePicker-__ColorPalettePicker__input",
  "ColorPalettePicker__color--disabled": "quid-react-components__src-components-ColorPalettePicker-__ColorPalettePicker__color--disabled",
  "ColorPalettePicker__hex": "quid-react-components__src-components-ColorPalettePicker-__ColorPalettePicker__hex"
};
var styles$17 = {
  "InputColor": "quid-react-components__src-components-InputColor-__InputColor",
  "InputColor__button": "quid-react-components__src-components-InputColor-__InputColor__button",
  "InputColor__color": "quid-react-components__src-components-InputColor-__InputColor__color",
  "InputColor__icon": "quid-react-components__src-components-InputColor-__InputColor__icon",
  "InputColor__icon--disabled": "quid-react-components__src-components-InputColor-__InputColor__icon--disabled",
  "InputColor__hex": "quid-react-components__src-components-InputColor-__InputColor__hex"
};
var styles$18 = {
  "InputGroup": "quid-react-components__src-components-InputGroup-__InputGroup",
  "InputGroup__input": "quid-react-components__src-components-InputGroup-__InputGroup__input"
}; // This list specifies to which children inside an <InputGroup /> the
// `isGroupChild` property is passed.

var validChildren = ['InputText', 'Button'];

function addIsGroupChildProp(child, key) {
  if (validChildren.includes(getName(child))) {
    return React.cloneElement(child, {
      isGroupChild: true
    });
  }

  return child;
}
/**
 * @component
 * @return {React.Component}
 */


function InputGroup(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = objectWithoutProperties(_ref, ['children', 'className']);
  return React__default.createElement('div', _extends({
    className: cn(styles$18.InputGroup, className)
  }, props), React.Children.map(children, addIsGroupChildProp));
}

var InputColor = function (_Component) {
  inherits(InputColor, _Component);

  function InputColor() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, InputColor);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = InputColor.__proto__ || Object.getPrototypeOf(InputColor)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      color: ''
    }, _this.getColor = function (_ref2) {
      var color = _ref2.target.value;

      _this.setState({
        color: color.toUpperCase()
      });

      _this.props.onChange(color.toUpperCase());
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(InputColor, [{
    key: 'render',
    value: function render() {
      var color = this.state.color;
      var _props = this.props,
          onChange = _props.onChange,
          inputClassName = _props.inputClassName,
          disabled = _props.disabled,
          size = _props.size,
          className = _props.className,
          props = objectWithoutProperties(_props, ['onChange', 'inputClassName', 'disabled', 'size', 'className']);
      return React__default.createElement(InputGroup, _extends({
        className: cn(styles$17.InputColor, className)
      }, props), React__default.createElement(InputText$1, {
        type: 'text',
        className: cn(styles$17.InputColor__hex, inputClassName),
        value: color,
        onChange: this.getColor,
        placeholder: 'Custom',
        minLength: 4,
        maxLength: 7,
        disabled: disabled,
        size: size
      }), React__default.createElement('label', {
        className: styles$17.InputColor__button
      }, React__default.createElement(Icon$1, {
        squared: false,
        name: 'tint',
        className: cn(styles$17['InputColor__icon'], disabled && styles$17['InputColor__icon--disabled']),
        style: {
          color: color
        }
      }), React__default.createElement('input', {
        className: styles$17['InputColor__color'],
        type: 'color',
        onChange: this.getColor,
        disabled: disabled
      })));
    }
  }]);
  return InputColor;
}(React.Component);

InputColor.defaultProps = {
  disabled: false
};

function rgbToHex(color) {
  return Color(color).hex();
}

var grayPalette = deprecated.common.grayPalette,
    nodePalette = deprecated.common.nodePalette;

function ColorPalettePicker(_ref) {
  var _ref$colors = _ref.colors,
      colors = _ref$colors === undefined ? [grayPalette.black, grayPalette.gray5, grayPalette.gray3, grayPalette.gray2, grayPalette.white, nodePalette.red, nodePalette.orange, nodePalette.yellow, nodePalette.green, nodePalette.sky, nodePalette.purple, nodePalette.pink] : _ref$colors,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === undefined ? false : _ref$disabled,
      onChange = _ref.onChange;
  return React__default.createElement('div', {
    className: styles$16.ColorPalettePicker
  }, colors.map(function (color, index) {
    var hex = rgbToHex(color);
    return React__default.createElement('button', {
      key: hex,
      className: cn(styles$16['ColorPalettePicker__color'], disabled && styles$16['ColorPalettePicker__color--disabled']),
      style: {
        color: hex
      },
      onClick: function onClick() {
        return !disabled && onChange(hex);
      }
    });
  }), React__default.createElement(InputColor, {
    className: styles$16.ColorPalettePicker__input,
    inputClassName: styles$16.ColorPalettePicker__hex,
    onChange: onChange,
    disabled: disabled
  }));
}

var styles$19 = {
  "Menu": "quid-react-components__src-components-ContextMenu-__Menu",
  "ContextMenu": "quid-react-components__src-components-ContextMenu-__ContextMenu",
  "ContextMenu__trigger": "quid-react-components__src-components-ContextMenu-__ContextMenu__trigger",
  "ContextMenu__sub": "quid-react-components__src-components-ContextMenu-__ContextMenu__sub",
  "Menu--sub": "quid-react-components__src-components-ContextMenu-__Menu--sub",
  "Item": "quid-react-components__src-components-ContextMenu-__Item",
  "Item__button": "quid-react-components__src-components-ContextMenu-__Item__button",
  "Item__button--disabled": "quid-react-components__src-components-ContextMenu-__Item__button--disabled",
  "Item--focus": "quid-react-components__src-components-ContextMenu-__Item--focus",
  "Item--active": "quid-react-components__src-components-ContextMenu-__Item--active",
  "Item--disabled": "quid-react-components__src-components-ContextMenu-__Item--disabled",
  "Item--tall": "quid-react-components__src-components-ContextMenu-__Item--tall",
  "Item__inner": "quid-react-components__src-components-ContextMenu-__Item__inner",
  "Item__text": "quid-react-components__src-components-ContextMenu-__Item__text",
  "Item__side": "quid-react-components__src-components-ContextMenu-__Item__side",
  "Item__caret": "quid-react-components__src-components-ContextMenu-__Item__caret",
  "Heading": "quid-react-components__src-components-ContextMenu-__Heading",
  "Divider": "quid-react-components__src-components-ContextMenu-__Divider"
};
var styles$20 = {
  "InputCheckbox": "quid-react-components__src-components-InputCheckbox-__InputCheckbox",
  "InputCheckbox__input": "quid-react-components__src-components-InputCheckbox-__InputCheckbox__input",
  "InputCheckbox__icon": "quid-react-components__src-components-InputCheckbox-__InputCheckbox__icon",
  "InputCheckbox__icon--off": "quid-react-components__src-components-InputCheckbox-__InputCheckbox__icon--off",
  "InputCheckbox__icon--on": "quid-react-components__src-components-InputCheckbox-__InputCheckbox__icon--on",
  "InputCheckbox__icon--disabled": "quid-react-components__src-components-InputCheckbox-__InputCheckbox__icon--disabled"
};
var CHECKBOX_OFF = 'square_o';
var CHECKBOX_ON = 'check_square';

function InputCheckbox(_ref) {
  var className = _ref.className,
      style = _ref.style,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === undefined ? false : _ref$disabled,
      _ref$readOnly = _ref.readOnly,
      readOnly = _ref$readOnly === undefined ? false : _ref$readOnly,
      props = objectWithoutProperties(_ref, ['className', 'style', 'disabled', 'readOnly']);
  return React__default.createElement('label', {
    className: cn(styles$20.InputCheckbox, className),
    style: style
  }, React__default.createElement('input', _extends({
    className: styles$20.InputCheckbox__input,
    type: 'checkbox',
    disabled: disabled,
    readOnly: readOnly
  }, props)), React__default.createElement(Icon$1, {
    name: CHECKBOX_OFF,
    className: cn(styles$20['InputCheckbox__icon'], styles$20['InputCheckbox__icon--off'], (disabled || readOnly) && styles$20['InputCheckbox__icon--disabled'])
  }), React__default.createElement(Icon$1, {
    name: CHECKBOX_ON,
    className: cn(styles$20['InputCheckbox__icon'], styles$20['InputCheckbox__icon--on'], (disabled || readOnly) && styles$20['InputCheckbox__icon--disabled'])
  }));
}

var InputCheckbox$1 = exposeName('InputCheckbox')(InputCheckbox);
var styles$21 = {
  "InputRadio": "quid-react-components__src-components-InputRadio-__InputRadio",
  "InputRadio__input": "quid-react-components__src-components-InputRadio-__InputRadio__input",
  "InputRadio__icon": "quid-react-components__src-components-InputRadio-__InputRadio__icon",
  "InputRadio__icon--off": "quid-react-components__src-components-InputRadio-__InputRadio__icon--off",
  "InputRadio__icon--on": "quid-react-components__src-components-InputRadio-__InputRadio__icon--on",
  "InputRadio__icon--disabled": "quid-react-components__src-components-InputRadio-__InputRadio__icon--disabled"
};
var RADIO_OFF = 'circle_o';
var RADIO_ON = 'dot_circle_o';

function InputRadio(_ref) {
  var className = _ref.className,
      style = _ref.style,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === undefined ? false : _ref$disabled,
      _ref$offIcon = _ref.offIcon,
      offIcon = _ref$offIcon === undefined ? RADIO_OFF : _ref$offIcon,
      _ref$onIcon = _ref.onIcon,
      onIcon = _ref$onIcon === undefined ? RADIO_ON : _ref$onIcon,
      props = objectWithoutProperties(_ref, ['className', 'style', 'disabled', 'offIcon', 'onIcon']);
  return React__default.createElement('label', {
    className: cn(styles$21.InputRadio, className),
    style: style
  }, React__default.createElement('input', _extends({
    className: styles$21.InputRadio__input,
    type: 'radio',
    disabled: disabled
  }, props)), React__default.createElement(Icon$1, {
    name: offIcon,
    className: cn(styles$21['InputRadio__icon'], styles$21['InputRadio__icon--off'], disabled && styles$21['InputRadio__icon--disabled'])
  }), React__default.createElement(Icon$1, {
    name: onIcon,
    className: cn(styles$21['InputRadio__icon'], styles$21['InputRadio__icon--on'], disabled && styles$21['InputRadio__icon--disabled'])
  }));
}

var InputRadio$1 = exposeName('InputRadio')(InputRadio);
var styles$22 = {
  "Text": "quid-react-components__src-components-Text-__Text",
  "Text--xlarge": "quid-react-components__src-components-Text-__Text--xlarge",
  "Text--large": "quid-react-components__src-components-Text-__Text--large",
  "Text--normal": "quid-react-components__src-components-Text-__Text--normal",
  "Text--title": "quid-react-components__src-components-Text-__Text--title",
  "Text--body": "quid-react-components__src-components-Text-__Text--body",
  "Text--caption": "quid-react-components__src-components-Text-__Text--caption",
  "Text--bold": "quid-react-components__src-components-Text-__Text--bold",
  "Text--regular": "quid-react-components__src-components-Text-__Text--regular",
  "Text--secondary": "quid-react-components__src-components-Text-__Text--secondary",
  "Text--disabled": "quid-react-components__src-components-Text-__Text--disabled",
  "Text--link": "quid-react-components__src-components-Text-__Text--link",
  "Text--highlighted": "quid-react-components__src-components-Text-__Text--highlighted",
  "Text--italic": "quid-react-components__src-components-Text-__Text--italic",
  "Card": "quid-react-components__src-components-Text-__Card",
  "Skeleton": "quid-react-components__src-components-Text-__Skeleton",
  "Skeleton__text": "quid-react-components__src-components-Text-__Skeleton__text",
  "pulse": "quid-react-components__src-components-Text-__pulse"
}; // For ease of use, you can directly use Text.H1, Text.Span, Text.P etc...

var TAGS = ['H1', 'H2', 'H3', 'H4', 'H5', 'Span', 'P'];

function Text(_ref) {
  var _ref$tag = _ref.tag,
      Tag = _ref$tag === undefined ? 'span' : _ref$tag,
      type = _ref.type,
      className = _ref.className,
      props = objectWithoutProperties(_ref, ['tag', 'type', 'className']);
  return React__default.createElement(Tag, _extends({
    className: cn(styles$22.Text, type && type.split(' ').map(function (t) {
      return styles$22['Text--' + t];
    }), className)
  }, props));
}

TAGS.forEach(function (tag) {
  return Text[tag] = function (props) {
    return React__default.createElement(Text, _extends({
      tag: tag.toLowerCase()
    }, props));
  };
});

Text.Skeleton = function (props) {
  var tag = props.tag,
      children = props.children;
  var Tag = tag || 'span';
  return React__default.createElement(Tag, {
    className: styles$22.Skeleton
  }, React.Children.toArray(children).map(function (child) {
    if (typeof child === 'string') {
      return child.split(/ +/g).map(function (fragment, key) {
        return React__default.createElement('span', {
          key: key,
          className: styles$22.Skeleton__text,
          style: {
            width: fragment.length / 1.2 + 'em'
          }
        });
      });
    }

    return child;
  }));
};

TAGS.forEach(function (tag) {
  return Text.Skeleton[tag] = function (props) {
    return React__default.createElement(Text.Skeleton, _extends({
      tag: tag.toLowerCase()
    }, props));
  };
});

function Item(_ref) {
  var _ref$isActive = _ref.isActive,
      isActive = _ref$isActive === undefined ? false : _ref$isActive,
      children = _ref.children,
      onClick = _ref.onClick,
      onMouseOver = _ref.onMouseOver,
      icon = _ref.icon,
      _ref$checkbox = _ref.checkbox,
      checkbox = _ref$checkbox === undefined ? false : _ref$checkbox,
      _ref$radio = _ref.radio,
      radio = _ref$radio === undefined ? false : _ref$radio,
      checked = _ref.checked,
      defaultChecked = _ref.defaultChecked,
      name = _ref.name,
      _ref$tall = _ref.tall,
      tall = _ref$tall === undefined ? false : _ref$tall,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === undefined ? false : _ref$disabled,
      dataAction = _ref['data-action'],
      dataValue = _ref['data-value'],
      className = _ref.className,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === undefined ? 'li' : _ref$tag,
      props = objectWithoutProperties(_ref, ['isActive', 'children', 'onClick', 'onMouseOver', 'icon', 'checkbox', 'radio', 'checked', 'defaultChecked', 'name', 'tall', 'disabled', 'data-action', 'data-value', 'className', 'tag']);
  var isInput = radio || checkbox;
  var InteractionTarget = isInput ? 'label' : 'button';
  var iconElement = !!icon && React__default.createElement(Icon$1, {
    name: icon
  });
  var inputProps = {
    checked: checked,
    defaultChecked: defaultChecked,
    name: name,
    disabled: disabled
  };
  var checkboxElement = checkbox && React__default.createElement(InputCheckbox$1, inputProps);
  var radioElement = radio && React__default.createElement(InputRadio$1, inputProps);
  return React__default.createElement(Tag, _extends({
    className: cn(styles$19['Item'], isActive && styles$19['Item--active'], tall && styles$19['Item--tall'], disabled && styles$19['Item--disabled'], className)
  }, props), React__default.createElement(InteractionTarget, {
    className: cn(styles$19['Item__button'], disabled && styles$19['Item__button--disabled']),
    onClick: onClick,
    onMouseOver: onMouseOver,
    'data-action': dataAction,
    'data-value': dataValue,
    disabled: !isInput ? disabled : undefined
  }, React__default.createElement('div', {
    className: styles$19.Item__inner
  }, (isInput || iconElement) && React__default.createElement(Text.Span, {
    type: cn({
      disabled: disabled
    }),
    className: styles$19.Item__side
  }, checkboxElement || radioElement || iconElement), React__default.createElement(Text.Span, {
    type: cn({
      disabled: disabled
    }),
    className: styles$19.Item__text
  }, children))));
}

function ContextMenu(_ref) {
  var _ref$isSubMenu = _ref.isSubMenu,
      isSubMenu = _ref$isSubMenu === undefined ? false : _ref$isSubMenu,
      children = _ref.children,
      className = _ref.className,
      props = objectWithoutProperties(_ref, ['isSubMenu', 'children', 'className']);
  return React__default.createElement('ul', _extends({
    className: cn(styles$19.Menu, isSubMenu && styles$19['Menu--sub'], className)
  }, props), children);
}

function Heading(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = objectWithoutProperties(_ref, ['children', 'className']);
  return React__default.createElement(Text.H1, _extends({
    type: 'bold',
    className: cn(styles$19.Heading, className)
  }, props), children);
}

function Divider() {
  return React__default.createElement('li', null, React__default.createElement('hr', {
    className: styles$19.Divider
  }));
}

function genHandleToggle(onToggle) {
  return function (isOpen) {
    onToggle && onToggle(isOpen);
  };
}

function genHandleClose(onToggle, isOpen) {
  return function () {
    isOpen !== false && onToggle && onToggle(false);
  };
}

function genHandleOpen(onToggle, isOpen) {
  return function () {
    isOpen !== true && onToggle && onToggle(true);
  };
}

function makeChildrenClickable(children, onClick) {
  return React.cloneElement(children, {
    onClick: onClick
  });
}

function ContextMenu$1(_ref) {
  var _ref$isSubMenu = _ref.isSubMenu,
      isSubMenu = _ref$isSubMenu === undefined ? false : _ref$isSubMenu,
      menu = _ref.menu,
      _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === undefined ? false : _ref$isOpen,
      onToggle = _ref.onToggle,
      children = _ref.children,
      _ref$placement = _ref.placement,
      placement = _ref$placement === undefined ? 'right-start' : _ref$placement,
      _ref$closeDelay = _ref.closeDelay,
      closeDelay = _ref$closeDelay === undefined ? 300 : _ref$closeDelay,
      _ref$closeOnMouseOut = _ref.closeOnMouseOut,
      closeOnMouseOut = _ref$closeOnMouseOut === undefined ? false : _ref$closeOnMouseOut,
      _ref$closeOnChildrenC = _ref.closeOnChildrenClick,
      closeOnChildrenClick = _ref$closeOnChildrenC === undefined ? true : _ref$closeOnChildrenC,
      className = _ref.className,
      popperClassName = _ref.popperClassName,
      popperModifiers = _ref.popperModifiers,
      _ref$popperPositionFi = _ref.popperPositionFixed,
      popperPositionFixed = _ref$popperPositionFi === undefined ? false : _ref$popperPositionFi,
      menuRef = _ref.menuRef,
      props = objectWithoutProperties(_ref, ['isSubMenu', 'menu', 'isOpen', 'onToggle', 'children', 'placement', 'closeDelay', 'closeOnMouseOut', 'closeOnChildrenClick', 'className', 'popperClassName', 'popperModifiers', 'popperPositionFixed', 'menuRef']);
  var handleOpen = genHandleOpen(onToggle, isOpen);
  var handleClose = genHandleClose(onToggle, isOpen);
  var handleToggle = genHandleToggle(onToggle);
  var shouldRenderItem = isSubMenu || !React.isValidElement(children) || typeof children === 'string';
  return React__default.createElement(reactPopper.Manager, {
    tag: false
  }, React__default.createElement(MouseOutside, {
    className: cn(styles$19.ContextMenu, isSubMenu && styles$19.ContextMenu__sub, className),
    onMouseMoveOutside: isSubMenu || closeOnMouseOut ? handleClose : undefined,
    onClickOutside: handleClose,
    delay: closeDelay,
    tag: isSubMenu ? 'li' : 'div'
  }, React__default.createElement(reactPopper.Target, {
    className: styles$19.ContextMenu__trigger
  }, shouldRenderItem ? React__default.createElement(Item, _extends({
    tag: isSubMenu ? 'div' : 'li',
    onMouseEnter: handleOpen,
    onClick: function onClick() {
      return handleToggle(!isOpen);
    }
  }, props), children, ' ', React__default.createElement(Icon$1, {
    className: styles$19.Item__caret,
    name: 'caret_right'
  })) : // $FlowFixMe
  makeChildrenClickable(children, function () {
    return handleToggle(closeOnChildrenClick ? !isOpen : true);
  })), React__default.createElement(reactPopper.Popper, {
    placement: placement,
    positionFixed: popperPositionFixed,
    className: popperClassName,
    modifiers: popperModifiers,
    innerRef: menuRef
  }, isOpen && menu)));
} // User can access these sub-components directly from the default exported
// ContextMenu component
// Usage:
// ```
// import { ContextMenu } from '@quid-private/react-components';
// <ContextMenu />
// <ContextMenu.Divider />
// <ContextMenu.Item />
// <ContextMenu.Menu />
// ```


ContextMenu$1.Divider = Divider;
ContextMenu$1.Item = Item;
ContextMenu$1.Menu = ContextMenu;
ContextMenu$1.Heading = Heading;
/**
 * Filters items where filter value is not included
 */

function filterItems(items, filter) {
  if (filter) {
    return items.filter(function (_ref) {
      var label = _ref.label;
      return label.toLowerCase().indexOf(filter.toLowerCase()) !== -1;
    });
  } else {
    return items;
  }
}
/**
 * Checks if the id is in the items
 */


function includesId(items, searchId) {
  return items.findIndex(function (_ref2) {
    var id = _ref2.id;
    return id === searchId;
  }) !== -1;
}
/**
 * Iterates trough selectedItems and checks if any of items exist there
 */


function isItemInCategorySelected(selectedItems, items) {
  for (var x = 0; x < selectedItems.length; x++) {
    if (includesId(items, selectedItems[x].id)) {
      return true;
    }
  }

  return false;
}

function splitStringByValue(heystack, needle) {
  var minLenght = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;
  var textSlices = [];
  var needleLength = needle.length;
  var lowHeystack = heystack.toLowerCase();
  var lowNeedle = needle.toLowerCase();
  var startIndex = 0;
  var index = 0;

  while ((index = lowHeystack.indexOf(lowNeedle, startIndex)) > -1) {
    textSlices.push({
      value: heystack.slice(startIndex, index),
      highlight: false
    });
    startIndex = index + needleLength;
    textSlices.push({
      value: heystack.slice(index, startIndex),
      highlight: true
    });
  }

  if (textSlices.length === 0 || minLenght > needle.length) {
    textSlices = [];
    textSlices.push({
      value: heystack,
      highlight: false
    });
  } else if (startIndex < heystack.length) {
    textSlices.push({
      value: heystack.slice(startIndex, heystack.length),
      highlight: false
    });
  }

  return textSlices;
}
/**
 * This return a function that will call all the given functions with
 * the arguments with which it's called. It does a null-check before
 * attempting to call the functions and can take any number of functions.
 */


function callAll() {
  for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    fns.forEach(function (fn) {
      if (fn) {
        fn.apply(undefined, args);
      }
    });
  };
}

function HighlightValue(_ref) {
  var highlight = _ref.highlight,
      value = _ref.value,
      valueToHighlight = _ref.valueToHighlight;

  if (highlight && valueToHighlight.length && value.length) {
    var splittedText = splitStringByValue(value, valueToHighlight, 1);
    return React__default.createElement('span', null, splittedText.map(function (chunk$$1, index) {
      return chunk$$1.highlight ? React__default.createElement(Text, {
        key: index,
        tag: 'span',
        type: 'bold'
      }, chunk$$1.value) : chunk$$1.value;
    }));
  }

  return value;
}

var Items =
/*#__PURE__*/
styled__default('ul', {
  target: 'e1dij63s0'
})('display:flex;flex-direction:column;flex-grow:1;');
var _ref$1 = 'background-color:var(--highlighted);';
var _ref2 = 'background-color:var(--gray1);';
var _ref3 = '&:not(:last-child){border-bottom:1px solid var(--gray2);}';
var Item$1 =
/*#__PURE__*/
styled__default('li', {
  target: 'e1dij63s1'
})('display:flex;flex-direction:row;cursor:pointer;padding:0.74em 0.74em;', function (props) {
  return props.isSelected &&
  /*#__PURE__*/
  styled.css(_ref$1);
}, ';', function (props) {
  return props.isHighlighted &&
  /*#__PURE__*/
  styled.css(_ref2);
}, ';', function (props) {
  return props.twoColumn && props.categoryId &&
  /*#__PURE__*/
  styled.css(_ref3);
}, ';');
var AutoCompleteItem = 'div';

function DropdownItems(_ref4) {
  var twoColumn = _ref4.twoColumn,
      items = _ref4.items,
      getItemProps = _ref4.getItemProps,
      inputValue = _ref4.inputValue,
      highlightedIndex = _ref4.highlightedIndex,
      selectedItems = _ref4.selectedItems,
      categoryId = _ref4.categoryId,
      highlight = _ref4.highlight,
      props = objectWithoutProperties(_ref4, ['twoColumn', 'items', 'getItemProps', 'inputValue', 'highlightedIndex', 'selectedItems', 'categoryId', 'highlight']);
  return React__default.createElement(Items, null, items.map(function (item, index) {
    var itemIndex = item.hasOwnProperty('index') ? item.index : index;
    var isHighlighted = itemIndex === highlightedIndex;
    var isSelected = includesId(selectedItems, item.id);
    var isDisabled = !!item.disabled;
    return React__default.createElement(Item$1, _extends({
      key: item.id,
      isHighlighted: isHighlighted,
      isSelected: isSelected,
      categoryId: categoryId,
      twoColumn: twoColumn
    }, getItemProps({
      index: itemIndex,
      item: {
        id: item.id,
        label: item.label
      },
      disabled: isDisabled
    })), React__default.createElement(AutoCompleteItem, null, React__default.createElement(Text, {
      tag: 'span',
      type: isDisabled ? 'disabled' : ''
    }, React__default.createElement(HighlightValue, {
      highlight: highlight,
      value: item.label,
      valueToHighlight: inputValue
    }))));
  }));
}

var Categories =
/*#__PURE__*/
styled__default('div', {
  target: 'ejnznh10'
})('display:flex;flex-direction:row;&:not(:last-child){border-bottom:1px solid var(--gray2);}');
var Category =
/*#__PURE__*/
styled__default('main', {
  target: 'ejnznh11'
})('display:flex;flex-direction:', function (props) {
  return props.twoColumn ? 'row' : 'column';
}, ';flex-grow:1;');
var _ref$2 = 'background-color:var(--highlighted);';
var _ref2$1 = 'background-color:var(--gray1);';
var _ref3$1 = '&:first-child{border-right:1px solid var(--gray2);}';
var Divider$1 =
/*#__PURE__*/
styled__default('section', {
  target: 'ejnznh12'
})('display:flex;flex-grow:', function (props) {
  return props.twoColumn ? '1' : '0';
}, ';flex-basis:', function (props) {
  return props.twoColumn ? '50%' : 'auto';
}, ';', function (props) {
  return props.isSelected &&
  /*#__PURE__*/
  styled.css(_ref$2);
}, ';', function (props) {
  return props.isHighlighted &&
  /*#__PURE__*/
  styled.css(_ref2$1);
}, ';', function (props) {
  return props.twoColumn &&
  /*#__PURE__*/
  styled.css(_ref3$1);
}, ';');
var GroupTitle =
/*#__PURE__*/
styled__default('h3', {
  target: 'ejnznh13'
})('font-weight:bold;display:flex;padding:0.74em 0.74em;');

function DropdownCategories(_ref4) {
  var items = _ref4.items,
      categories = _ref4.categories,
      inputValue = _ref4.inputValue,
      getItemProps = _ref4.getItemProps,
      twoColumn = _ref4.twoColumn,
      highlightedIndex = _ref4.highlightedIndex,
      highlight = _ref4.highlight,
      selectedItems = _ref4.selectedItems;
  var sortedItems = categories.map(function (category) {
    return items.filter(function (item) {
      return item.categoryId === category.id;
    });
  }).reduce(function (acc, category) {
    return acc.concat(category);
  }, []); // Add index to our items

  var itemsWithIndex = sortedItems.sort(function (a, b) {
    return String(a.categoryId) < String(b.categoryId) ? -1 : 1;
  }).map(function (item, index) {
    return _extends({}, item, {
      index: index
    });
  }); // put the items inside their categories

  var categoriesedItems = categories.reduce(function (acc, category) {
    // find the items of the current category
    var categoryItems = itemsWithIndex.filter(function (item) {
      return item.categoryId === category.id;
    }); // if no items are available, skip the category

    return categoryItems.length > 0 ? [].concat(toConsumableArray(acc), [_extends({}, category, {
      firstIndex: categoryItems[0].index,
      lastIndex: categoryItems.slice(-1)[0].index,
      items: categoryItems
    })]) : acc;
  }, []);
  return React__default.createElement('div', null, categoriesedItems.map(function (category) {
    var categoryId = category.id;
    var isHighlighted = highlightedIndex !== null && highlightedIndex >= category.firstIndex && highlightedIndex <= category.lastIndex;
    var isSelected = isItemInCategorySelected(selectedItems, category.items);
    return React__default.createElement(Categories, {
      key: categoryId
    }, React__default.createElement(Category, {
      twoColumn: twoColumn
    }, React__default.createElement(Divider$1, {
      isHighlighted: isHighlighted,
      isSelected: isSelected,
      twoColumn: twoColumn
    }, React__default.createElement(GroupTitle, null, React__default.createElement(Text, {
      tag: 'span',
      type: 'bold'
    }, category.label))), React__default.createElement(Divider$1, {
      twoColumn: twoColumn
    }, React__default.createElement(DropdownItems, {
      categoryId: categoryId,
      twoColumn: twoColumn,
      items: category.items,
      getItemProps: getItemProps,
      inputValue: inputValue,
      highlightedIndex: highlightedIndex,
      selectedItems: selectedItems,
      highlight: highlight
    }))));
  }));
}

var List =
/*#__PURE__*/
styled__default('div', {
  target: 'e1gx0t4r0'
})('z-index:1;list-style:none;background-color:var(--white);color:var(--primary);border:1px solid var(--gray2);border-radius:2px;box-shadow:2px 2px 2px var(--gray2);min-width:27.86em;');

function DropdownList(_ref) {
  var items = _ref.items,
      categories = _ref.categories,
      inputValue = _ref.inputValue,
      getItemProps = _ref.getItemProps,
      useFilter = _ref.useFilter,
      filterFn = _ref.filterFn,
      twoColumn = _ref.twoColumn,
      highlightedIndex = _ref.highlightedIndex,
      selectedItems = _ref.selectedItems,
      highlight = _ref.highlight;
  var filteredItems = useFilter ? filterFn(items, inputValue) : items;

  if (filteredItems.length) {
    return React__default.createElement(List, null, categories.length > 0 ? React__default.createElement(DropdownCategories, {
      categories: categories,
      items: filteredItems,
      getItemProps: getItemProps,
      twoColumn: twoColumn,
      inputValue: inputValue,
      highlightedIndex: highlightedIndex,
      selectedItems: selectedItems,
      highlight: highlight
    }) : React__default.createElement(DropdownItems, {
      items: filteredItems,
      getItemProps: getItemProps,
      inputValue: inputValue,
      highlightedIndex: highlightedIndex,
      selectedItems: selectedItems,
      highlight: highlight
    }));
  }

  return null;
}

function InputCreator(_ref) {
  var selectedItems = _ref.selectedItems,
      name = _ref.name,
      multiselect = _ref.multiselect;
  var inputName = name + (multiselect ? '[]' : '');
  return React__default.createElement(React.Fragment, null, selectedItems.map(function (item, index) {
    return React__default.createElement('input', {
      type: 'hidden',
      key: index,
      name: inputName,
      value: item.id
    });
  }));
}

var MultiDownshift = function (_Component) {
  inherits(MultiDownshift, _Component);

  function MultiDownshift() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, MultiDownshift);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = MultiDownshift.__proto__ || Object.getPrototypeOf(MultiDownshift)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      selectedItems: _this.props.selectedItems
    }, _this.stateReducer = function (state, changes) {
      var multiselect = _this.props.multiselect;

      if (multiselect) {
        switch (changes.type) {
          case Downshift.stateChangeTypes.keyDownEnter:
          case Downshift.stateChangeTypes.clickItem:
            return _extends({}, changes, {
              highlightedIndex: state.highlightedIndex,
              isOpen: true
            });

          default:
            return changes;
        }
      } else {
        return changes;
      }
    }, _this.handleSelection = function (selectedItem, downshift) {
      var callOnChange = function callOnChange() {
        var onChange = _this.props.onChange;
        var selectedItems = _this.state.selectedItems;

        if (onChange) {
          onChange(selectedItems, _this.getStateAndHelpers(downshift));
        }
      };

      var multiselect = _this.props.multiselect;

      if (multiselect === true) {
        if (includesId(_this.state.selectedItems, selectedItem.id)) {
          _this.removeItem(selectedItem, callOnChange);
        } else {
          _this.addSelectedItem(selectedItem, callOnChange);
        }
      } else {
        _this.replaceItem(selectedItem, callOnChange);
      }
    }, _this.replaceItem = function (item, cb) {
      _this.setState(function (_ref2) {
        var selectedItems = _ref2.selectedItems;
        return {
          selectedItems: [item]
        };
      }, cb);
    }, _this.removeItem = function (item, cb) {
      _this.setState(function (_ref3) {
        var selectedItems = _ref3.selectedItems;
        return {
          selectedItems: selectedItems.filter(function (_ref4) {
            var id = _ref4.id;
            return id !== item.id;
          })
        };
      }, cb);
    }, _this.addSelectedItem = function (item, cb) {
      _this.setState(function (_ref5) {
        var selectedItems = _ref5.selectedItems;
        return {
          selectedItems: [].concat(toConsumableArray(selectedItems), [item])
        };
      }, cb);
    }, _this.getStateAndHelpers = function (downshift) {
      var selectedItems = _this.state.selectedItems;
      var _this2 = _this,
          removeItem = _this2.removeItem;
      return _extends({
        /* getRemoveButtonProps, */
        removeItem: removeItem,
        selectedItems: selectedItems
      }, downshift);
    }, _temp), possibleConstructorReturn(_this, _ret);
  }
  /*
  TODO for later: figure if this was needed.
  getRemoveButtonProps = ({
    onClick,
    item,
    ...props
  }: {
    onClick: Function,
    item: Object,
  } = {}) => {
    return {
      onClick: (e: Object) => {
        onClick && onClick(e);
        e.stopPropagation();
        this.removeItem(item);
      },
      ...props,
    };
  }; */


  createClass(MultiDownshift, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          multiselect = _props.multiselect,
          children = _props.children,
          selectedItem = _props.selectedItem,
          props = objectWithoutProperties(_props, ['multiselect', 'children', 'selectedItem']);
      return React__default.createElement(Downshift, _extends({}, props, {
        selectedItem: multiselect ? null : selectedItem,
        stateReducer: this.stateReducer,
        onChange: this.handleSelection
      }), function (downshift) {
        return children(_this3.getStateAndHelpers(downshift));
      });
    }
  }]);
  return MultiDownshift;
}(React.Component);

var DropdownContainer =
/*#__PURE__*/
styled__default('div', {
  target: 'e1dm3odw0'
})('display:inline-block;');

function Dropdown(_ref) {
  var _ref$filterFn = _ref.filterFn,
      filterFn = _ref$filterFn === undefined ? filterItems : _ref$filterFn,
      _ref$useFilter = _ref.useFilter,
      useFilter = _ref$useFilter === undefined ? false : _ref$useFilter,
      items = _ref.items,
      _ref$categories = _ref.categories,
      categories = _ref$categories === undefined ? [] : _ref$categories,
      _ref$multiselect = _ref.multiselect,
      multiselect = _ref$multiselect === undefined ? false : _ref$multiselect,
      children = _ref.children,
      _ref$name = _ref.name,
      name = _ref$name === undefined ? 'dropdown' : _ref$name,
      _ref$twoColumn = _ref.twoColumn,
      twoColumn = _ref$twoColumn === undefined ? true : _ref$twoColumn,
      _ref$selectedItems = _ref.selectedItems,
      selectedItems = _ref$selectedItems === undefined ? [] : _ref$selectedItems,
      _ref$initialIsOpen = _ref.initialIsOpen,
      initialIsOpen = _ref$initialIsOpen === undefined ? false : _ref$initialIsOpen,
      _ref$placement = _ref.placement,
      placement = _ref$placement === undefined ? 'top-start' : _ref$placement,
      popperClassName = _ref.popperClassName,
      popperModifiers = _ref.popperModifiers,
      _ref$popperPositionFi = _ref.popperPositionFixed,
      popperPositionFixed = _ref$popperPositionFi === undefined ? false : _ref$popperPositionFi,
      onChange = _ref.onChange,
      onSelect = _ref.onSelect,
      _ref$highlight = _ref.highlight,
      highlight = _ref$highlight === undefined ? false : _ref$highlight,
      props = objectWithoutProperties(_ref, ['filterFn', 'useFilter', 'items', 'categories', 'multiselect', 'children', 'name', 'twoColumn', 'selectedItems', 'initialIsOpen', 'placement', 'popperClassName', 'popperModifiers', 'popperPositionFixed', 'onChange', 'onSelect', 'highlight']);
  return React__default.createElement(reactPopper.Manager, {
    tag: false
  }, React__default.createElement(DropdownContainer, props, React__default.createElement(MultiDownshift, {
    initialSelectedItem: selectedItems.length ? selectedItems[0] : null,
    multiselect: multiselect,
    itemToString: function itemToString(item) {
      return item && item.label ? item.label : '';
    },
    selectedItems: selectedItems,
    initialIsOpen: initialIsOpen,
    onChange: onChange,
    onSelect: onSelect
  }, function (downshift) {
    var openMenu = downshift.openMenu,
        getItemProps = downshift.getItemProps,
        isOpen = downshift.isOpen,
        inputValue = downshift.inputValue,
        highlightedIndex = downshift.highlightedIndex,
        selectedItems = downshift.selectedItems;
    return React__default.createElement('div', null, React__default.createElement(reactPopper.Target, null, children(_extends({}, downshift, {
      getInputProps: function getInputProps() {
        var inputProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var onFocus = inputProps.onFocus,
            onClick = inputProps.onClick,
            additionalProps = objectWithoutProperties(inputProps, ['onFocus', 'onClick']);
        return downshift.getInputProps(_extends({}, additionalProps, {
          onFocus: callAll(onFocus, openMenu),
          onClick: callAll(onClick, openMenu)
        }));
      }
    })), React__default.createElement(InputCreator, {
      multiselect: multiselect,
      selectedItems: selectedItems,
      name: name
    })), isOpen && React__default.createElement(reactPopper.Popper, {
      placement: placement,
      positionFixed: popperPositionFixed,
      className: popperClassName,
      modifiers: popperModifiers,
      style: {
        zIndex: 1
      }
    }, React__default.createElement(DropdownList, {
      twoColumn: twoColumn,
      items: items,
      categories: categories,
      inputValue: inputValue,
      getItemProps: getItemProps,
      useFilter: useFilter,
      filterFn: filterFn,
      highlightedIndex: highlightedIndex,
      selectedItems: selectedItems,
      highlight: highlight
    })));
  })));
}

var compStyles$1 = {
  "EditableTitle__text": "quid-react-components__src-components-EditableTitle-__EditableTitle__text",
  "EditableTitle__input": "quid-react-components__src-components-EditableTitle-__EditableTitle__input",
  "EditableTitle": "quid-react-components__src-components-EditableTitle-__EditableTitle",
  "EditableTitle__outerInput": "quid-react-components__src-components-EditableTitle-__EditableTitle__outerInput",
  "EditableTitle__text--invisible": "quid-react-components__src-components-EditableTitle-__EditableTitle__text--invisible",
  "EditableTitle__text--nowrap": "quid-react-components__src-components-EditableTitle-__EditableTitle__text--nowrap",
  "EditableTitle__edit": "quid-react-components__src-components-EditableTitle-__EditableTitle__edit"
};
var ENTER = 13;
var ESC = 27;

function handleKeyDown(keyCode, newValue, onSave, onCancel) {
  if (keyCode === ENTER) {
    onSave(newValue);
  }

  if (keyCode === ESC) {
    onCancel();
  }
}

function EditableTitle(_ref) {
  var editing = _ref.editing,
      onEditBegin = _ref.onEditBegin,
      onSave = _ref.onSave,
      onCancel = _ref.onCancel,
      value = _ref.value,
      innerClassName = _ref.innerClassName,
      _ref$styles = _ref.styles,
      styles$$1 = _ref$styles === undefined ? compStyles$1 : _ref$styles,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === undefined ? 'Enter title here...' : _ref$placeholder,
      _ref$wrap = _ref.wrap,
      wrap = _ref$wrap === undefined ? false : _ref$wrap,
      className = _ref.className,
      props = objectWithoutProperties(_ref, ['editing', 'onEditBegin', 'onSave', 'onCancel', 'value', 'innerClassName', 'styles', 'placeholder', 'wrap', 'className']);
  return React__default.createElement('h1', _extends({}, props, {
    className: cn(styles$$1.EditableTitle, className)
  }), React__default.createElement('div', {
    className: cn(styles$$1['EditableTitle__text'], editing && styles$$1['EditableTitle__text--invisible'], !wrap && styles$$1['EditableTitle__text--nowrap'], innerClassName)
  }, value || React__default.createElement('span', null, '\xA0')), editing && React__default.createElement(InputText$1, _extends({
    className: styles$$1.EditableTitle__input,
    outerClassName: styles$$1.EditableTitle__outerInput,
    onKeyDown: function onKeyDown(_ref2) {
      var keyCode = _ref2.keyCode,
          newValue = _ref2.currentTarget.value;
      return handleKeyDown(keyCode, newValue, onSave, onCancel);
    },
    onBlur: function onBlur(evt) {
      return onSave(evt.target.value);
    },
    defaultValue: value,
    placeholder: placeholder,
    autoFocus: true
  }, props)), !editing && onEditBegin && React__default.createElement(Button$1, {
    className: styles$$1.EditableTitle__edit,
    importance: 'secondary',
    size: 'small',
    onClick: onEditBegin
  }, React__default.createElement(Icon$1, {
    name: 'pencil'
  })));
}

function nlToBr(text) {
  return text.split(/\n()/g).map(function (str, i) {
    return str ? str : React__default.createElement('br', {
      key: i
    });
  });
}

function isWidthDifferentFn(element, width) {
  return !!element && width !== element.clientWidth;
}

function isNotEmptyString(value) {
  return typeof value === 'string' && value.length > 0;
}

var Ellipsis = function (_Component) {
  inherits(Ellipsis, _Component);

  function Ellipsis() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Ellipsis);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Ellipsis.__proto__ || Object.getPrototypeOf(Ellipsis)).call.apply(_ref, [this].concat(args))), _this), _this.isWidthDifferentFn = isWidthDifferentFn, _this.state = {
      previousChildren: undefined,
      good: 0,
      current: isNotEmptyString(_this.props.children) ? _this.props.children.split(' ').length : 0,
      bad: null
    }, _this.element = undefined, _this.width = 0, _this.updateText = function () {
      var _this2 = _this,
          element = _this2.element,
          _this2$state = _this2.state,
          bad = _this2$state.bad,
          good = _this2$state.good,
          current = _this2$state.current,
          maxHeight = _this2.props.maxHeight;

      if (!element) {
        return;
      }

      var scrollHeight = element.scrollHeight;

      if (scrollHeight > maxHeight) {
        if (bad != null && bad - good === 1) {
          // We have found the good/bad boundary.
          _this.setState({
            current: good
          });
        } else {
          // Too big, so update current to half the distance to the known good.
          _this.setState({
            current: current - (current - good >> 1),
            bad: current
          });
        }
      } else {
        if (bad == null || current === good) {
          // We did it!
          return;
        } // Too small, so update current to half the distance to the known bad.


        _this.setState({
          current: current + (bad - current >> 1),
          good: current
        });
      }
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Ellipsis, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // setState in `componentDidMount` is usually bad practice...
      // In this case this is exactly what we want, we cache original text
      // as `trimmedText` and setting the state we trigger a new render
      // making  the `componentDidUpdate` loop we want begin.
      this.setState({
        previousChildren: this.props.children
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var element = this.element,
          width = this.width,
          children = this.props.children,
          previousChildren = this.state.previousChildren; // If the component size changes, we must force a restart of the component
      // to make sure we show all the possible text in the new available area

      var isWidthDifferent = this.isWidthDifferentFn(element, width);

      if (!!element && isWidthDifferent) {
        this.width = element.clientWidth;
      }

      var isChildrenDifferent = previousChildren !== children; // If `children` has been updated, we need to update `trimmedText` in
      //  the internal component state
      // In both cases, we run the updateText loop to properly trim the text

      if (isChildrenDifferent || isWidthDifferent) {
        this.setState({
          previousChildren: this.props.children,
          current: isNotEmptyString(this.props.children) ? this.props.children.split(' ').length : 0,
          good: 0,
          bad: null
        }, this.updateText);
      } else {
        requestAnimationFrame(this.updateText);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          children = _props.children,
          character = _props.character,
          Tag = _props.tag,
          addTitle = _props.addTitle,
          other = objectWithoutProperties(_props, ['children', 'character', 'tag', 'addTitle']),
          current = this.state.current;
      var tagProps = objectWithoutProperties(other, ['maxHeight']);
      var trimmedText = isNotEmptyString(children) ? children.split(' ').slice(0, current).join(' ') : ''; // Since we can't support `<br />` inside `children`, we support `\n` and we
      // take care to convert them to `<br />` when we render the text.

      var newlinedText = nlToBr(trimmedText); // We don't want to show ellipsis if no text has been trimmed

      var ellipsis = children && children.length !== trimmedText.length && character;
      return React__default.createElement(Tag, _extends({
        ref: function ref(element) {
          return _this3.element = element;
        },
        title: addTitle ? children : null
      }, tagProps), newlinedText, ellipsis);
    }
  }]);
  return Ellipsis;
}(React.Component);

Ellipsis.defaultProps = {
  tag: 'div',
  character: '…',
  children: '',
  addTitle: false
};
var styles$23 = {
  "EntityList__header": "quid-react-components__src-components-EntityList-__EntityList__header",
  "EntityList": "quid-react-components__src-components-EntityList-__EntityList",
  "EntityList__list": "quid-react-components__src-components-EntityList-__EntityList__list",
  "EntityList__entity": "quid-react-components__src-components-EntityList-__EntityList__entity",
  "EntityList__entityButton": "quid-react-components__src-components-EntityList-__EntityList__entityButton",
  "EntityList__entityButton--selected": "quid-react-components__src-components-EntityList-__EntityList__entityButton--selected",
  "EntityList__entityButton--last": "quid-react-components__src-components-EntityList-__EntityList__entityButton--last",
  "EntityList__entityInner": "quid-react-components__src-components-EntityList-__EntityList__entityInner",
  "EntityList__label": "quid-react-components__src-components-EntityList-__EntityList__label",
  "EntityList__label--ellipsis": "quid-react-components__src-components-EntityList-__EntityList__label--ellipsis",
  "EntityList__count": "quid-react-components__src-components-EntityList-__EntityList__count"
};

function EntityList(_ref) {
  var header = _ref.header,
      entities = _ref.entities,
      onSelect = _ref.onSelect,
      className = _ref.className,
      props = objectWithoutProperties(_ref, ['header', 'entities', 'onSelect', 'className']);
  return React__default.createElement('section', _extends({
    className: cn(styles$23.EntityList, className),
    'data-context': 'entity-list'
  }, props), React__default.createElement('h1', {
    className: styles$23.EntityList__header
  }, header), React__default.createElement('ul', {
    className: styles$23.EntityList__list
  }, entities.map(function (entity, index) {
    return React__default.createElement('li', {
      className: styles$23.EntityList__entity,
      key: entity.id
    }, React__default.createElement('button', {
      'data-action': 'select-entity',
      'data-value': entity.label,
      onClick: function onClick(evt) {
        return onSelect && onSelect(entity, evt);
      },
      className: cn(styles$23.EntityList__entityButton, entity.selected && styles$23['EntityList__entityButton--selected'], entities.length - 1 === index && styles$23['EntityList__entityButton--last'])
    }, React__default.createElement('div', {
      className: styles$23.EntityList__entityInner
    }, React__default.createElement('div', {
      className: cn(styles$23.EntityList__label, entity.count !== undefined && styles$23['EntityList__label--ellipsis'])
    }, entity.label), entity.count !== undefined && React__default.createElement('div', {
      className: styles$23.EntityList__count
    }, approx(entity.count)))));
  })));
}

var color = styles.color;
var COLORS = {
  ROW_BACKGROUND: {
    //Odd row background-color
    ODD: color.gray6,
    //Header background-color, even row background-color
    EVEN: color.gray7
  },
  //Row color
  ROW: color.white,
  ROW_INACTIVE: color.gray4,
  //Row border-color when selected
  BORDER: color.gray5,
  //Header border-color
  AQUA: color.aqua,
  //Table box-shadow
  BOX_SHADOW: Color(color.gray2).alpha(0.2).string() //table box shadow

};
var TableRow =
/*#__PURE__*/
styled__default('div', {
  target: 'egtnqwa0'
})('display:flex;align-items:center;cursor:pointer;height:41px;background-color:', function (props) {
  return props.isOdd ? COLORS.ROW_BACKGROUND.ODD : COLORS.ROW_BACKGROUND.EVEN;
}, ';', function (props) {
  return props.isLast && '\n      border-radius: 0 0 5px 5px;\n    ';
}, ' border-left:5px solid transparent;border-bottom:1px solid transparent;border-color:', function (props) {
  return props.isOpen ? COLORS.BORDER : 'transparent';
}, ';padding:0 20px;');
var TICK_WIDTH = 30;
var BASE_PADDING = 20;
var TableHeader =
/*#__PURE__*/
styled__default('div', {
  target: 'e18earj00'
})('display:flex;flex-direction:row;flex-grow:1;padding:10px ', TICK_WIDTH + BASE_PADDING, 'px 10px 20px;background-color:', COLORS.ROW_BACKGROUND.EVEN, ';border-radius:5px 5px 0 0;border-left:5px solid transparent;border-bottom:1px solid ', COLORS.AQUA, ';padding-right:', function (props) {
  return TICK_WIDTH + BASE_PADDING + props.scrollBarWidth + 'px';
}, ';');
var TickHolder =
/*#__PURE__*/
styled__default('div', {
  target: 'e9fo0pd0'
})('display:flex;transition:0.5s ease-in-out;font-size:20px;', function (props) {
  return props.isOpen && 'transform: rotate(180deg);';
});
var EnhancedText =
/*#__PURE__*/
styled__default(function (_ref) {
  var isSorting = _ref.isSorting,
      isInHeader = _ref.isInHeader,
      columnKey = _ref.columnKey,
      sortBy = _ref.sortBy,
      sortOrder = _ref.sortOrder,
      bold = _ref.bold,
      rest = objectWithoutProperties(_ref, ['isSorting', 'isInHeader', 'columnKey', 'sortBy', 'sortOrder', 'bold']);
  return React__default.createElement(Text, rest);
}, {
  target: 'e9fo0pd1'
})(function (props) {
  if (props.isInHeader && props.sortOrder && props.isSorting && props.sortBy && props.sortBy !== props.columnKey) {
    return 'color: ' + COLORS.ROW_INACTIVE + ';';
  }

  return 'color: ' + COLORS.ROW + ';';
}, ' ', function (props) {
  return props.bold && '\n      font-weight: bold;\n    ';
}, ' ', function (props) {
  return props.isSorting && '\n      cursor: pointer;\n    ';
}, ' ', function (props) {
  return !props.isTick && '\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    ';
});
var IconsHolder =
/*#__PURE__*/
styled__default('span', {
  target: 'e9fo0pd2'
})('display:flex;flex-wrap:nowrap;');
var IconHolder =
/*#__PURE__*/
styled__default('span', {
  target: 'e9fo0pd3'
})('display:inline-block;margin:4px 0 0 3px;cursor:pointer;width:14px;line-height:14px;');
var SortIconHolder =
/*#__PURE__*/
styled__default(IconHolder, {
  target: 'e9fo0pd4'
})('flex-shrink:0;');
var IconTop =
/*#__PURE__*/
styled__default(Icon$1, {
  target: 'e9fo0pd5'
})('margin-right:-3px;color:', function (props) {
  return props.active ? 'var(--white)' : 'var(--gray5)';
}, ';');
var IconBottom =
/*#__PURE__*/
styled__default(Icon$1, {
  target: 'e9fo0pd6'
})('margin-left:-10px;color:', function (props) {
  return props.active ? 'var(--white)' : 'var(--gray5)';
}, ';');
var TooltipIcon =
/*#__PURE__*/
styled__default(Icon$1, {
  target: 'e9fo0pd7'
})('color:var(--gray5);&:hover{color:var(--white);}');

var TD = function TD(_ref2) {
  var children = _ref2.children,
      _ref2$isInHeader = _ref2.isInHeader,
      isInHeader = _ref2$isInHeader === undefined ? false : _ref2$isInHeader,
      _ref2$isTick = _ref2.isTick,
      isTick = _ref2$isTick === undefined ? false : _ref2$isTick,
      _ref2$isOpen = _ref2.isOpen,
      isOpen = _ref2$isOpen === undefined ? false : _ref2$isOpen,
      sortBy = _ref2.sortBy,
      sortOrder = _ref2.sortOrder,
      isSorting = _ref2.isSorting,
      columnKey = _ref2.columnKey,
      rowClickedHandler = _ref2.rowClickedHandler,
      align = _ref2.align,
      width = _ref2.width,
      tooltip = _ref2.tooltip,
      _ref2$bold = _ref2.bold,
      bold = _ref2$bold === undefined ? false : _ref2$bold,
      props = objectWithoutProperties(_ref2, ['children', 'isInHeader', 'isTick', 'isOpen', 'sortBy', 'sortOrder', 'isSorting', 'columnKey', 'rowClickedHandler', 'align', 'width', 'tooltip', 'bold']);
  return React__default.createElement('div', props, isTick ? React__default.createElement(TickHolder, {
    isOpen: isOpen
  }, React__default.createElement(Icon$1, {
    name: 'angle_down'
  })) : React__default.createElement(React.Fragment, null, React__default.createElement(EnhancedText, _extends({
    tag: 'span',
    type: isInHeader && 'bold',
    isInHeader: isInHeader,
    sortBy: sortBy,
    sortOrder: sortOrder,
    isSorting: isSorting,
    columnKey: columnKey,
    bold: bold
  }, _extends({}, rowClickedHandler ? {
    onClick: rowClickedHandler
  } : {}, isSorting ? {
    'data-action': 'sort'
  } : {}, typeof children === 'string' || typeof children === 'number' ? {
    title: children
  } : {})), children), (isSorting || tooltip) && React__default.createElement(IconsHolder, null, isSorting && React__default.createElement(SortIconHolder, {
    onClick: rowClickedHandler
  }, React__default.createElement(IconTop, {
    name: 'sort_asc',
    active: sortBy === columnKey && sortOrder === 'asc'
  }), React__default.createElement(IconBottom, {
    name: 'sort_desc',
    active: sortBy === columnKey && sortOrder === 'desc'
  })), tooltip && React__default.createElement(Tooltip, {
    id: 'expt_tooltip',
    delay: 0,
    tooltip: tooltip,
    placement: 'bottom',
    popperModifiers: {
      zIndex: {
        enabled: true,
        order: 840,
        fn:
        /* istanbul ignore next */
        function fn(data) {
          data.styles.zIndex = 2;
          return data;
        }
      }
    }
  }, React__default.createElement(IconHolder, null, React__default.createElement(TooltipIcon, {
    name: 'question_circle'
  }))))));
};

var TableData =
/*#__PURE__*/
styled__default(TD, {
  target: 'e9fo0pd8'
})('display:flex;justify-content:', function (props) {
  if (props.align && ['center', 'left', 'right'].indexOf(props.align) !== -1) {
    if (props.align === 'left') {
      return 'flex-start';
    } else if (props.align === 'right') {
      return 'flex-end';
    }

    return 'center';
  }

  return 'flex-start';
}, ';padding:0 5px;', function (props) {
  return !props.isTick && props.width && '\n    flex-basis: ' + props.width + '%;\n    max-width: ' + props.width + '%;\n  ';
}, ' color:', COLORS.ROW, ';', function (props) {
  return props.isTick && '\n        justify-content: flex-end;\n        flex-basis: 30px;\n      ';
});
var _ref$3 = 'border-radius:0 0 3px 3px;& > *{border-radius:0 0 5px 5px;}';
var ExpandedContainer =
/*#__PURE__*/
styled__default('div', {
  target: 'e10h31ic0'
})(function (props) {
  return props.isLast &&
  /*#__PURE__*/
  styled.css(_ref$3);
});
var styles$24 = {
  "Scroller": "quid-react-components__src-components-Scroller-__Scroller",
  "Scroller__item": "quid-react-components__src-components-Scroller-__Scroller__item"
};

function Scroller(_ref) {
  var className = _ref.className,
      props = objectWithoutProperties(_ref, ['className']);
  return React__default.createElement('div', _extends({
    className: cn(styles$24.Scroller, className)
  }, props));
}

Scroller.Item = function Item(_ref2) {
  var className = _ref2.className,
      props = objectWithoutProperties(_ref2, ['className']);
  return React__default.createElement('div', _extends({
    className: cn(styles$24.Scroller__item, className)
  }, props));
};

var VIRTUAL_LIST_THRESHOLD = 10;
var Container =
/*#__PURE__*/
styled__default('div', {
  target: 'e8apn3d0'
})('height:', function (props) {
  return props.useVirtualList ? '100vh' : 'auto';
}, ';display:flex;flex-direction:column;');
var List$1 =
/*#__PURE__*/
styled__default(reactVirtualized.List, {
  target: 'e8apn3d1'
})('padding:0.71em 0.71em 0.35em;&:focus-mouse{outline:0;}');
var Scroller$1 =
/*#__PURE__*/
styled__default(Scroller, {
  target: 'e8apn3d2'
})('flex:1;min-height:0;background-color:transparent;');

function stringifyIds(list) {
  return list.reduce(function (acc, item) {
    return acc += item.id;
  }, '');
}

var rowRenderer = function rowRenderer(_ref) {
  var items = _ref.items,
      cache = _ref.cache,
      updateRowHeight = _ref.updateRowHeight,
      forceUpdateGrid = _ref.forceUpdateGrid,
      scrollToIndex = _ref.scrollToIndex;
  return function (_ref2) {
    var key = _ref2.key,
        style = _ref2.style,
        parent = _ref2.parent,
        index = _ref2.index;
    /* istanbul ignore next */

    return parent ? React__default.createElement(reactVirtualized.CellMeasurer, {
      cache: cache,
      columnIndex: 0,
      key: key,
      parent: parent,
      rowIndex: index
    }, items[index].render({
      forceUpdateGrid: forceUpdateGrid,
      scrollToIndex: scrollToIndex,
      updateRowHeight: function (_updateRowHeight2) {
        function updateRowHeight(_x) {
          return _updateRowHeight2.apply(this, arguments);
        }

        updateRowHeight.toString = function () {
          return _updateRowHeight2.toString();
        };

        return updateRowHeight;
      }(function (optionalIndex) {
        return updateRowHeight(optionalIndex != null ? optionalIndex : index);
      }),
      style: style
    })) : items[index].render({
      forceUpdateGrid: forceUpdateGrid,
      scrollToIndex: scrollToIndex,
      updateRowHeight: function (_updateRowHeight3) {
        function updateRowHeight(_x2) {
          return _updateRowHeight3.apply(this, arguments);
        }

        updateRowHeight.toString = function () {
          return _updateRowHeight3.toString();
        };

        return updateRowHeight;
      }(function (optionalIndex) {
        return updateRowHeight(optionalIndex != null ? optionalIndex : index);
      }),
      style: style
    });
  };
};

var enhance$2 = recompose.compose(recompose.setDisplayName('VirtualList'), recompose.defaultProps({
  defaultHeight: 10,
  defaultWidth: 100,
  minHeight: 10,
  virtualListThreshold: VIRTUAL_LIST_THRESHOLD
}), recompose.withState('_list', '_setList', undefined), recompose.withState('_cache', '_setCache', function (props) {
  return new reactVirtualized.CellMeasurerCache({
    defaultHeight: props.defaultHeight,
    defaultWidth: props.defaultWidth,
    minHeight: props.minHeight,
    fixedWidth: true
  });
}), recompose.withProps(function (props) {
  return {
    _useVirtualList: props.items.length > props.virtualListThreshold,
    _forceUpdateGrid:
    /* istanbul ignore next */
    function _forceUpdateGrid(index) {
      props._cache.clearAll();

      props._list && props._list.forceUpdateGrid();
    },
    _updateRowHeight:
    /* istanbul ignore next */
    function _updateRowHeight(index) {
      props._cache.clear(index, 0);

      props._list && props._list.forceUpdateGrid();
    },
    _scrollToIndex:
    /* istanbul ignore next */
    function _scrollToIndex(index) {
      props._list.scrollToRow(index);
    }
  };
}), recompose.lifecycle({
  componentDidUpdate: function componentDidUpdate(prevProps) {
    /* istanbul ignore next */
    if (stringifyIds(prevProps.items) !== stringifyIds(this.props.items)) {
      if (this.props._useVirtualList) {
        // If list changed, clear the virtual list cache to make it recompute
        // all the needed measurements
        this.props._cache.clearAll();

        this.props._list && this.props._list.forceUpdateGrid(); // if the virtual list is enabled, scroll to the top
        // when the list changes we want the user to see its first element

        this.props._list && this.props._list.scrollToPosition(0);
      }
    }
  }
}));

var VirtualList = function VirtualList(_ref3) {
  var _useVirtualList = _ref3._useVirtualList,
      _updateRowHeight = _ref3._updateRowHeight,
      _forceUpdateGrid = _ref3._forceUpdateGrid,
      _scrollToIndex = _ref3._scrollToIndex,
      _setList = _ref3._setList,
      getScrollBarWidth = _ref3.getScrollBarWidth,
      items = _ref3.items,
      _cache = _ref3._cache,
      props = objectWithoutProperties(_ref3, ['_useVirtualList', '_updateRowHeight', '_forceUpdateGrid', '_scrollToIndex', '_setList', 'getScrollBarWidth', 'items', '_cache']);
  return React__default.createElement(Container, _extends({}, props, {
    useVirtualList: _useVirtualList
  }), _useVirtualList ? React__default.createElement(reactVirtualized.AutoSizer, null, function (_ref4) {
    var width = _ref4.width,
        height = _ref4.height;
    return React__default.createElement(List$1, {
      onScrollbarPresenceChange:
      /* istanbul ignore next */
      function onScrollbarPresenceChange(scrollBarPresence) {
        if (getScrollBarWidth) {
          if (scrollBarPresence.horizontal === true || scrollBarPresence.vertical === true) {
            getScrollBarWidth(scrollBarPresence.size);
          } else {
            getScrollBarWidth(0);
          }
        }
      },
      innerRef: _setList,
      width: width,
      height: height,
      rowCount: items.length,
      deferredMeasurementCache: _cache,
      rowHeight: _cache.rowHeight,
      rowRenderer: rowRenderer({
        items: items,
        cache: _cache,
        updateRowHeight: _updateRowHeight,
        forceUpdateGrid: _forceUpdateGrid,
        scrollToIndex: _scrollToIndex
      }),
      className: props.virtualListClassName
    });
  }) : React__default.createElement(Scroller$1, null, items.map(function (item, index) {
    return rowRenderer({
      items: items,
      cache: _cache,
      updateRowHeight: _updateRowHeight,
      forceUpdateGrid: _forceUpdateGrid,
      scrollToIndex: _scrollToIndex
    })({
      key: String(index),
      index: index
    });
  })));
};

var VirtualList$1 = enhance$2(VirtualList);
var Table =
/*#__PURE__*/
styled__default('div', {
  target: 'e1hg1dub0'
})('display:flex;border-radius:5px;flex-direction:column;box-shadow:0 2px 4px 0 ', COLORS.BOX_SHADOW, ';background-color:', function (props) {
  return props.isOdd ? COLORS.ROW_BACKGROUND.ODD : COLORS.ROW_BACKGROUND.EVEN;
}, ';');
var TableBody =
/*#__PURE__*/
styled__default('div', {
  target: 'e1hg1dub1'
})('display:flex;flex-direction:column;position:relative;');
var TableRowDataList =
/*#__PURE__*/
styled__default('div', {
  target: 'e1hg1dub2'
})('display:flex;flex-direction:row;flex-grow:1;');

function filterDataForPagination(data, page, maxItemPerPage) {
  //isPaginationEnabled
  if (page != null && page > 0) {
    var sliceFrom = (page - 1) * maxItemPerPage;
    var sliceTo = page * maxItemPerPage;
    return data.slice(sliceFrom, sliceTo);
  }

  return data;
}

function getSortedData(data, sortOrder, sortBy) {
  if (data.length && sortOrder && sortBy) {
    data = [].concat(toConsumableArray(data)).sort(function (a, b) {
      var valueA = a[sortBy];
      var valueB = b[sortBy];
      var parsedA = parseFloat(valueA);
      var parsedB = parseFloat(valueB);

      if (isNaN(parsedA) === false && isNaN(parsedB) === false) {
        return sortOrder === 'asc' ? parsedA - parsedB : parsedB - parsedA;
      } else {
        if (valueA < valueB) {
          return sortOrder === 'asc' ? -1 : 1;
        }

        if (valueA > valueB) {
          return sortOrder === 'asc' ? 1 : -1;
        }

        return 0;
      }
    });
  }

  return data;
}

function getVisibleRows(newProps, newState) {
  var data = newProps.data;

  if (newState.isSorting === true && newState.sortOrder !== null && newState.sortBy !== null) {
    data = getSortedData(data, newState.sortOrder, newState.sortBy);
  }

  return filterDataForPagination(data, newProps.page, newProps.maxItemPerPage);
}

function getNextSortOrder(defaultSortOrder, sortBy) {
  var newSortOrder = defaultSortOrder.indexOf(sortBy) + 1;
  return newSortOrder < defaultSortOrder.length ? defaultSortOrder[newSortOrder] : null;
}

var _ref2$2 = 'padding: 0;';
var _ref4 = 'display:flex;flex-direction:column;';

var ExpandableTable = function (_Component) {
  inherits(ExpandableTable, _Component);

  function ExpandableTable() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, ExpandableTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = ExpandableTable.__proto__ || Object.getPrototypeOf(ExpandableTable)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      openedRows: _this.props.openedRows.slice(0, _this.props.maxOpen),
      tableRows: [],
      isSorting: _this.props.defaultIsSorting,
      sortOrder: _this.props.defaultSortOrder[0],
      sortBy: null,
      scrollBarWidth: 0
    }, _this.toggleRows = function (ids, scrollToIndex) {
      _this.setState(function (state) {
        var newState = {
          openedRows: state.openedRows.reduce(function (accumulator, currentValue) {
            var indexOfCurrentValue = accumulator.indexOf(currentValue);

            if (indexOfCurrentValue === -1) {
              accumulator.push(currentValue);
            } else {
              accumulator.splice(indexOfCurrentValue, 1);
            }

            accumulator = accumulator.slice(0, _this.props.maxOpen);
            return accumulator;
          }, ids)
        };
        return newState;
      }, scrollToIndex);
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(ExpandableTable, [{
    key: 'changeSortOrder',
    value: function changeSortOrder(sortBy) {
      var newSortBy = sortBy;
      var newSortOrder = this.props.defaultSortOrder[0];

      if (this.state.sortBy === sortBy) {
        newSortOrder = getNextSortOrder(this.props.defaultSortOrder, this.state.sortOrder);
      }

      if (newSortOrder === null) {
        newSortBy = null;
      }

      this.setState({
        sortBy: newSortBy,
        sortOrder: newSortOrder
      });
    }
    /**
      Based on user provided columns width it calculates
      the remaining space for columns equally
    */

  }, {
    key: 'calculatFreeColumnsWidth',
    value: function calculatFreeColumnsWidth(columns) {
      var columnsState = columns.reduce(function (accumulator, column) {
        return column.width ? {
          remainingWidth: accumulator.remainingWidth - column.width,
          widthSpecifiedCnt: accumulator.widthSpecifiedCnt + 1
        } : accumulator;
      }, {
        remainingWidth: 100,
        widthSpecifiedCnt: 0
      });
      var columnWidth = columnsState.remainingWidth / (columns.length - columnsState.widthSpecifiedCnt);
      return parseFloat(columnWidth.toFixed(3));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          openedRows = _state.openedRows,
          tableRows = _state.tableRows,
          sortBy = _state.sortBy,
          sortOrder = _state.sortOrder,
          isSorting = _state.isSorting,
          scrollBarWidth = _state.scrollBarWidth;
      var _props = this.props,
          columns = _props.columns,
          renderRow = _props.renderRow,
          maxBodyHeight = _props.maxBodyHeight;
      var freeColumnsWidth = this.calculatFreeColumnsWidth(columns);
      return React__default.createElement(Table, {
        isOdd: Boolean((tableRows.length + 1) % 2)
      }, React__default.createElement(TableHeader, {
        scrollBarWidth: scrollBarWidth
      }, columns.map(function (column) {
        return React__default.createElement(TableData, {
          key: column.key,
          columnKey: column.key,
          isInHeader: true,
          align: column.align,
          width: column.width || freeColumnsWidth,
          tooltip: column.tooltip,
          sortBy: sortBy,
          sortOrder: sortOrder,
          isSorting: isSorting,
          rowClickedHandler: function rowClickedHandler() {
            return _this2.changeSortOrder(column.key);
          }
        }, column.label);
      })), React__default.createElement(TableBody, null, React__default.createElement(VirtualList$1, {
        style: maxBodyHeight && {
          height: maxBodyHeight
        },
        virtualListClassName:
        /*#__PURE__*/

        /*#__PURE__*/
        styled.css(_ref2$2),
        virtualListThreshold: 0,
        defaultHeight: 41,
        getScrollBarWidth: function getScrollBarWidth(scrollBarWidth) {
          return _this2.setState({
            scrollBarWidth: scrollBarWidth
          });
        },
        minHeight: 41,
        items: tableRows.map(function (row, key) {
          return {
            id: row.id,
            render: function render(_ref3) {
              var style = _ref3.style,
                  forceUpdateGrid = _ref3.forceUpdateGrid,
                  scrollToIndex = _ref3.scrollToIndex;
              var isOpen = openedRows.includes(row.id);
              var isOdd = Boolean((key + 1) % 2);
              var isLast = tableRows.length - 1 === key;
              return React__default.createElement('div', {
                key: row.id,
                style: style,
                className:
                /*#__PURE__*/

                /*#__PURE__*/
                styled.css(_ref4)
              }, React__default.createElement(TableRow, {
                isOdd: isOdd,
                onClick: function onClick() {
                  forceUpdateGrid();

                  _this2.toggleRows([row.id], function () {
                    return scrollToIndex(key);
                  });
                },
                isOpen: isOpen,
                isLast: !isOpen && isLast,
                'data-action': 'expand-row'
              }, React__default.createElement(TableRowDataList, null, columns.map(function (column) {
                return React__default.createElement(TableData, {
                  key: column.key,
                  align: column.align,
                  width: column.width || freeColumnsWidth,
                  bold: column.bold
                }, row[column.key]);
              })), React__default.createElement(TableData, {
                isTick: true,
                isOpen: isOpen
              })), isOpen && React__default.createElement(ExpandedContainer, {
                isLast: isLast
              }, renderRow({
                isOdd: isOdd,
                isLast: isLast,
                data: row
              })));
            }
          };
        })
      })));
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(newProps, newState) {
      return {
        tableRows: getVisibleRows(newProps, newState)
      };
    }
  }]);
  return ExpandableTable;
}(React.Component);

ExpandableTable.defaultProps = {
  maxOpen: 1,
  openedRows: [],
  maxBodyHeight: null,
  maxItemPerPage: 10,
  defaultSortOrder: ['desc', 'asc'],
  defaultIsSorting: false
};
var styles$25 = {
  "Filmstrip": "quid-react-components__src-components-Filmstrip-__Filmstrip",
  "Filmstrip--horizontal": "quid-react-components__src-components-Filmstrip-__Filmstrip--horizontal",
  "Filmstrip--vertical": "quid-react-components__src-components-Filmstrip-__Filmstrip--vertical",
  "Filmstrip__main": "quid-react-components__src-components-Filmstrip-__Filmstrip__main",
  "Filmstrip__main--horizontal": "quid-react-components__src-components-Filmstrip-__Filmstrip__main--horizontal",
  "Filmstrip__main--vertical": "quid-react-components__src-components-Filmstrip-__Filmstrip__main--vertical",
  "Filmstrip__navigation": "quid-react-components__src-components-Filmstrip-__Filmstrip__navigation",
  "Filmstrip__navigation--horizontal": "quid-react-components__src-components-Filmstrip-__Filmstrip__navigation--horizontal",
  "Filmstrip__navigation--vertical": "quid-react-components__src-components-Filmstrip-__Filmstrip__navigation--vertical",
  "Filmstrip__navigation--left": "quid-react-components__src-components-Filmstrip-__Filmstrip__navigation--left",
  "Filmstrip__navigation--right": "quid-react-components__src-components-Filmstrip-__Filmstrip__navigation--right",
  "Filmstrip__navigation--top": "quid-react-components__src-components-Filmstrip-__Filmstrip__navigation--top",
  "Filmstrip__navigation--bottom": "quid-react-components__src-components-Filmstrip-__Filmstrip__navigation--bottom"
};

function Arrow(_ref) {
  var direction = _ref.direction,
      onMouseDown = _ref.onMouseDown,
      onMouseUp = _ref.onMouseUp,
      props = objectWithoutProperties(_ref, ['direction', 'onMouseDown', 'onMouseUp']);
  return React__default.createElement('div', props, React__default.createElement(Button$1, {
    onMouseDown: onMouseDown,
    onMouseUp: onMouseUp,
    importance: 'secondary',
    'data-action': 'scroll-' + direction
  }, React__default.createElement(Icon$1, {
    name: 'chevron_' + direction
  })));
}

var styles$26 = {
  "Item": "quid-react-components__src-components-Filmstrip-Item-__Item",
  "Item--active": "quid-react-components__src-components-Filmstrip-Item-__Item--active"
};

function Item$2(_ref) {
  var id = _ref.id,
      _ref$isActive = _ref.isActive,
      isActive = _ref$isActive === undefined ? false : _ref$isActive,
      children = _ref.children,
      className = _ref.className,
      props = objectWithoutProperties(_ref, ['id', 'isActive', 'children', 'className']);
  return React__default.createElement('div', _extends({
    className: cn(styles$26.Item, isActive && styles$26['Item--active'], className),
    tabIndex: 0
  }, props), children);
}

var ORIENTATION = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical'
};

var Filmstrip = function (_Component) {
  inherits(Filmstrip, _Component);

  function Filmstrip() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Filmstrip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Filmstrip.__proto__ || Object.getPrototypeOf(Filmstrip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      showLeftArrow: false,
      showRightArrow: true
    }, _this.scrolling = false, _this.handleMouseWheel = function (evt) {
      var deltaA = 'delta' + _this.axis.toUpperCase();

      var deltaB = 'delta' + _this.oppositeAxis.toUpperCase();

      var modifier = _this.isHoriz ? 1 : -1;

      if (Math.abs(evt[deltaB]) > Math.abs(evt[deltaA])) {
        _this.container[_this.scrollDir] -= evt[deltaB] * modifier;
      } else {
        _this.container[_this.scrollDir] += evt[deltaA];
      }

      evt.preventDefault();
    }, _this.preventScroll = function (evt) {
      return evt.preventDefault();
    }, _this.scroll = function (direction) {
      var _scroll;

      if (_this.scrolling === false) {
        return _this.props.onScrollEnd && _this.props.onScrollEnd();
      }

      scroll(_this.container, (_scroll = {}, defineProperty(_scroll, _this.axis, _this.container[_this.scrollDir] + _this.props.scrollStep * direction), defineProperty(_scroll, _this.oppositeAxis, 0), defineProperty(_scroll, 'duration', _this.props.scrollDuration), defineProperty(_scroll, 'ease', 'linear'), _scroll));
      setTimeout(function () {
        return _this.scroll(direction);
      }, _this.props.scrollDuration);
    }, _this.startScrolling = function (direction) {
      _this.scrolling = true;

      _this.scroll(direction);
    }, _this.stopScrolling = function () {
      _this.scrolling = false;

      _this.updateArrowsVisibility();
    }, _this.updateArrowsVisibility = throttle(function (evt) {
      return _this.container && _this.setState({
        showLeftArrow: _this.container[_this.scrollDir] > 0,
        showRightArrow: _this.container[_this.scrollDir] + _this.container[_this.axis === 'x' ? 'offsetWidth' : 'offsetHeight'] < _this.container[_this.axis === 'x' ? 'scrollWidth' : 'scrollHeight']
      });
    }, 500), _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Filmstrip, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          onSelect = _props.onSelect,
          activeId = _props.activeId,
          children = _props.children,
          onScrollEnd = _props.onScrollEnd,
          scrollStep = _props.scrollStep,
          scrollDuration = _props.scrollDuration,
          className = _props.className,
          props = objectWithoutProperties(_props, ['onSelect', 'activeId', 'children', 'onScrollEnd', 'scrollStep', 'scrollDuration', 'className']); // Iterate trough the items and create an Item element
      // for each of them, applying to each one its own data

      return React__default.createElement('div', _extends({
        className: cn(styles$25.Filmstrip, styles$25['Filmstrip--' + this.props.orientation], className),
        'data-context': 'filmstrip',
        onWheel: this.updateArrowsVisibility
      }, props), this.state.showLeftArrow && React__default.createElement(Arrow, {
        className: cn(styles$25['Filmstrip__navigation'], styles$25['Filmstrip__navigation--' + this.props.orientation], this.isHoriz ? styles$25['Filmstrip__navigation--left'] : styles$25['Filmstrip__navigation--top']),
        direction: this.isHoriz ? 'left' : 'up',
        onMouseDown: function onMouseDown() {
          return _this2.startScrolling(-1);
        },
        onMouseUp: this.stopScrolling,
        'data-action': 'scroll-left'
      }), React__default.createElement('div', {
        className: cn(styles$25.Filmstrip__main, styles$25['Filmstrip__main--' + this.props.orientation]),
        onScroll: this.preventScroll,
        onWheel: this.handleMouseWheel,
        ref: function ref(el) {
          return el !== null && (_this2.container = el);
        }
      }, React.Children.map(children, function (child, key) {
        return React.cloneElement(child, {
          key: key,
          onClick: function onClick() {
            return onSelect(child.props.id);
          },
          isActive: child.props.id === activeId,
          'data-action': 'select-item',
          'data-value': key
        });
      })), this.state.showRightArrow && React__default.createElement(Arrow, {
        className: cn(styles$25.Filmstrip__navigation, styles$25['Filmstrip__navigation--' + this.props.orientation], this.isHoriz ? styles$25['Filmstrip__navigation--right'] : styles$25['Filmstrip__navigation--bottom']),
        direction: this.isHoriz ? 'right' : 'down',
        onMouseDown: function onMouseDown() {
          return _this2.startScrolling(1);
        },
        onMouseUp: this.stopScrolling,
        'data-action': 'scroll-right'
      }));
    }
  }, {
    key: 'isHoriz',
    get: function get$$1() {
      return this.props.orientation === ORIENTATION.HORIZONTAL;
    }
  }, {
    key: 'axis',
    get: function get$$1() {
      return this.isHoriz ? 'x' : 'y';
    }
  }, {
    key: 'oppositeAxis',
    get: function get$$1() {
      return this.isHoriz ? 'y' : 'x';
    }
  }, {
    key: 'scrollDir',
    get: function get$$1() {
      return this.isHoriz ? 'scrollLeft' : 'scrollTop';
    } // To be able to scroll horizontally the filmstrip when the mousewheel
    // is vertically scrolled we must listen to `mousewheel` instead of `scroll`
    // since the vertical `scroll` event isn't fired if there's no vertical scrollbar
    // below, we inhibit the `scroll` events since we replace them with this method
    // Hides the relative arrow if the filmstrip is scrolled completely to the left
    // or to the right, this avoids to show the arrow when not needed

  }]);
  return Filmstrip;
}(React.Component);

Filmstrip.defaultProps = {
  scrollStep: 100,
  scrollDuration: 200,
  orientation: ORIENTATION.HORIZONTAL
};
Filmstrip.Item = Item$2;
var compStyles$2 = {
  "FilterMenu": "quid-react-components__src-components-FilterMenu-__FilterMenu",
  "FilterMenu__list": "quid-react-components__src-components-FilterMenu-__FilterMenu__list",
  "FilterMenu__popper": "quid-react-components__src-components-FilterMenu-__FilterMenu__popper",
  "FilterMenu__section": "quid-react-components__src-components-FilterMenu-__FilterMenu__section",
  "FilterMenu__section--twoColumn": "quid-react-components__src-components-FilterMenu-__FilterMenu__section--twoColumn",
  "FilterMenu__heading": "quid-react-components__src-components-FilterMenu-__FilterMenu__heading",
  "FilterMenu__item": "quid-react-components__src-components-FilterMenu-__FilterMenu__item"
};
var styles$27 = {
  "Item": "quid-react-components__src-components-FilterMenu-Item-__Item",
  "Item__label": "quid-react-components__src-components-FilterMenu-Item-__Item__label",
  "Item__count": "quid-react-components__src-components-FilterMenu-Item-__Item__count"
};

function DefaultItem(_ref) {
  var label = _ref.label,
      count = _ref.count;
  return React__default.createElement('div', {
    className: styles$27.Item
  }, React__default.createElement('span', {
    className: styles$27.Item__label
  }, label), React__default.createElement(Text, {
    type: 'secondary',
    className: styles$27.Item__count
  }, count));
}

function CategoryFooter(_ref) {
  var onClick = _ref.onClick,
      category = _ref.category,
      onMouseOver = _ref.onMouseOver,
      count = _ref.count,
      className = _ref.className,
      props = objectWithoutProperties(_ref, ['onClick', 'category', 'onMouseOver', 'count', 'className']);

  if (count <= 1) {
    return null;
  }

  return React__default.createElement(ContextMenu$1.Item, _extends({
    onClick: onClick,
    onMouseOver: onMouseOver,
    'data-action': 'select-all',
    'data-value': category,
    tall: true
  }, props), React__default.createElement(DefaultItem, {
    label: 'Select All',
    count: count
  }));
}

var CMMenu = ContextMenu$1.Menu,
    CMItem = ContextMenu$1.Item,
    CMHeading = ContextMenu$1.Heading;

function renderItems(Item$$1, items, categoryId, activeItems, onChange, onMouseOver, limit, styles$$1) {
  return items.slice(0, limit).map(function (item) {
    return React__default.createElement(CMItem, {
      isActive: activeItems.some(function (_ref) {
        var id = _ref.id;
        return id === item.id;
      }),
      key: categoryId + '_' + item.id,
      onClick: function onClick(evt) {
        return onChange && onChange(evt, [item]);
      },
      onMouseOver: function (_onMouseOver) {
        function onMouseOver(_x) {
          return _onMouseOver.apply(this, arguments);
        }

        onMouseOver.toString = function () {
          return _onMouseOver.toString();
        };

        return onMouseOver;
      }(function (evt) {
        return onMouseOver && onMouseOver(evt, [item]);
      }),
      tall: true,
      className: styles$$1.FilterMenu__item
    }, React__default.createElement(Item$$1, item));
  });
}

function filterItems$1(items, filter) {
  return items.filter(function (_ref2) {
    var label = _ref2.label;
    return label.toLowerCase().includes(filter.toLowerCase());
  });
}

function renderList(CategoryFooter$$1, Item$$1, items, categories, filter, activeItems, onChange, onMouseOver, limit, twoColumn, Heading, styles$$1) {
  var sectionClassName = cn(styles$$1['FilterMenu__section'], twoColumn && styles$$1['FilterMenu__section--twoColumn']);
  var filteredItems = filterItems$1(items, filter);
  return categories.map(function (_ref3) {
    var label = _ref3.label,
        id = _ref3.id,
        count = _ref3.count;
    return {
      id: id,
      label: label,
      count: count,
      items: filteredItems.filter(function (_ref4) {
        var categoryId = _ref4.categoryId;
        return categoryId === id;
      })
    };
  }).filter(function (_ref5) {
    var items = _ref5.items;
    return items.length > 0;
  }).reduce(function (acc, category) {
    return acc.concat(React__default.createElement('li', {
      className: sectionClassName,
      key: category.id
    }, categories.length > 0 && React__default.createElement(Heading, {
      className: styles$$1.FilterMenu__heading,
      key: category.id
    }, category.label), React__default.createElement('ul', {
      className: styles$$1.FilterMenu__list
    }, renderItems(Item$$1, category.items, category.id, activeItems, onChange, onMouseOver, limit, styles$$1), React__default.createElement(CategoryFooter$$1, {
      key: category.id + '_footer',
      onClick: function onClick(evt) {
        return onChange && onChange(evt, category.items, true);
      },
      onMouseOver: function (_onMouseOver2) {
        function onMouseOver(_x2) {
          return _onMouseOver2.apply(this, arguments);
        }

        onMouseOver.toString = function () {
          return _onMouseOver2.toString();
        };

        return onMouseOver;
      }(function (evt) {
        return onMouseOver && onMouseOver(evt, category.items);
      }),
      count: category.count !== undefined ? category.count : category.items.length,
      category: category.id
    }))));
  }, []);
}

function updateFilter(_ref6) {
  var filter = _ref6.target.value;
  this.setState({
    filter: filter
  });
}

var FilterMenu = function (_Component) {
  inherits(FilterMenu, _Component);

  function FilterMenu() {
    var _ref7;

    var _temp, _this, _ret;

    classCallCheck(this, FilterMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref7 = FilterMenu.__proto__ || Object.getPrototypeOf(FilterMenu)).call.apply(_ref7, [this].concat(args))), _this), _this.state = {
      filter: ''
    }, _this.selectItems = function (evt, newItems, addOnly) {
      var meta = evt.metaKey;
      var activeItems = _this.props.activeItems; // The new selection is the difference between the old selection
      // and the new one if the meta key is pressed

      var items = void 0;

      if (meta) {
        if (addOnly) {
          items = [].concat(toConsumableArray(new Set(activeItems.concat(newItems))));
        } else {
          items = _this.props.items.filter(function (item) {
            var isNotRemoved = activeItems.includes(item) && !newItems.includes(item);
            var isAdded = !activeItems.includes(item) && newItems.includes(item);

            if (isNotRemoved || isAdded) {
              return item;
            }
          });
        }
      } else {
        var isSigleItem = newItems.length === 1;
        var isNewItemSameAsPreviousOne = newItems[0] === activeItems[0];

        if (isSigleItem && isNewItemSameAsPreviousOne) {
          items = [];
        } else {
          items = newItems;
        }
      }

      _this.props.onChange(items);
    }, _this.mouseOverItems = function (evt, items) {
      return _this.props.onMouseOver && _this.props.onMouseOver(items);
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(FilterMenu, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          onToggle = _props.onToggle,
          placement = _props.placement,
          isOpen = _props.isOpen,
          items = _props.items,
          activeItems = _props.activeItems,
          categories = _props.categories,
          _props$styles = _props.styles,
          styles$$1 = _props$styles === undefined ? compStyles$2 : _props$styles,
          menuClassName = _props.menuClassName,
          menuStyle = _props.menuStyle,
          children = _props.children,
          placeholder = _props.placeholder,
          disabled = _props.disabled,
          onChange = _props.onChange,
          onMouseOver = _props.onMouseOver,
          updateFilter = _props.updateFilter,
          menuProps = _props.menuProps,
          inputProps = _props.inputProps,
          limit = _props.limit,
          CategoryFooter$$1 = _props.CategoryFooter,
          Heading = _props.Heading,
          Item$$1 = _props.Item,
          className = _props.className,
          twoColumn = _props.twoColumn,
          props = objectWithoutProperties(_props, ['onToggle', 'placement', 'isOpen', 'items', 'activeItems', 'categories', 'styles', 'menuClassName', 'menuStyle', 'children', 'placeholder', 'disabled', 'onChange', 'onMouseOver', 'updateFilter', 'menuProps', 'inputProps', 'limit', 'CategoryFooter', 'Heading', 'Item', 'className', 'twoColumn']);
      var filter = this.state.filter;
      var list = renderList(CategoryFooter$$1, Item$$1, items, categories, filter, activeItems, this.selectItems, this.mouseOverItems, limit, twoColumn, Heading, styles$$1);
      var menu = React__default.createElement(CMMenu, _extends({
        className: cn(styles$$1.FilterMenu__list, menuClassName),
        style: menuStyle
      }, menuProps), list);
      return React__default.createElement(ContextMenu$1, _extends({
        className: cn(styles$$1.FilterMenu, className),
        isOpen: isOpen && list.length > 0 && !disabled,
        onToggle: disabled ? undefined : onToggle,
        placement: placement,
        menu: menu,
        closeOnMouseOut: true,
        closeOnChildrenClick: false,
        popperClassName: styles$$1.FilterMenu__popper
      }, props), React.cloneElement(children, _extends({}, inputProps, {
        placeholder: placeholder,
        disabled: disabled,
        onMouseEnter: function onMouseEnter() {
          return !disabled && onToggle(true);
        },
        onChange: updateFilter.bind(this),
        onFocus: function onFocus() {
          return !disabled && onToggle(true);
        }
      })));
    }
  }]);
  return FilterMenu;
}(React.Component);

FilterMenu.defaultProps = {
  placement: 'bottom-start',
  children: React__default.createElement(ButtonMenu, {
    'data-action': 'toggle'
  }),
  disabled: false,
  updateFilter: updateFilter,
  CategoryFooter: CategoryFooter,
  Item: DefaultItem,
  twoColumn: false,
  Heading: CMHeading
};
var styles$28 = {
  "Footer": "quid-react-components__src-components-Footer-__Footer"
};
var styles$29 = {
  "Padder": "quid-react-components__src-components-Footer-Padder-__Padder",
  "Padder--first": "quid-react-components__src-components-Footer-Padder-__Padder--first",
  "Padder--last": "quid-react-components__src-components-Footer-Padder-__Padder--last"
};

function Padder(_ref) {
  var isFirst = _ref.isFirst,
      isLast = _ref.isLast,
      className = _ref.className,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['isFirst', 'isLast', 'className', 'children']);
  return React.cloneElement(children, {
    className: cn(className, styles$29['Padder'], isFirst && styles$29['Padder--first'], isLast && styles$29['Padder--last'])
  });
}

var Padder$1 = exposeName('Padder')(Padder);
var styles$30 = {
  "Slot": "quid-react-components__src-components-Footer-Slot-__Slot",
  "Slot--left": "quid-react-components__src-components-Footer-Slot-__Slot--left",
  "Slot--center": "quid-react-components__src-components-Footer-Slot-__Slot--center",
  "Slot--right": "quid-react-components__src-components-Footer-Slot-__Slot--right",
  "Slot--separated": "quid-react-components__src-components-Footer-Slot-__Slot--separated"
};

function Slot(_ref) {
  var _ref$separated = _ref.separated,
      separated = _ref$separated === undefined ? false : _ref$separated,
      _ref$left = _ref.left,
      left = _ref$left === undefined ? false : _ref$left,
      _ref$right = _ref.right,
      right = _ref$right === undefined ? false : _ref$right,
      _ref$center = _ref.center,
      center = _ref$center === undefined ? false : _ref$center,
      children = _ref.children,
      className = _ref.className,
      props = objectWithoutProperties(_ref, ['separated', 'left', 'right', 'center', 'children', 'className']);
  return React__default.createElement('div', _extends({
    className: cn(styles$30.Slot, left && styles$30['Slot--left'], right && styles$30['Slot--right'], center && styles$30['Slot--center'], separated && styles$30['Slot--separated'], className)
  }, props), React.Children.map(children, function (child, key) {
    var isPadder = React.isValidElement(child) && getName(child) === getName(Padder$1);
    return React.cloneElement(child, _extends({
      key: key
    }, isPadder ? {
      isFirst: key === 0,
      isLast: key === React.Children.count(children) - 1
    } : {}));
  }));
}

var themes = {
  dark: ['var(--gray7)', 'dark'],
  light: ['var(--white)', 'light'],
  transparent: ['transparent', null]
};

function Footer(_ref) {
  var _ref$theme = _ref.theme,
      theme = _ref$theme === undefined ? 'transparent' : _ref$theme,
      style = _ref.style,
      className = _ref.className,
      props = objectWithoutProperties(_ref, ['theme', 'style', 'className']);

  var _themes$theme = slicedToArray(themes[theme], 2),
      backgroundColor = _themes$theme[0],
      dataTheme = _themes$theme[1];

  return React__default.createElement('nav', _extends({
    'data-theme': dataTheme,
    className: cn(styles$28.Footer, className),
    style: _extends({}, style, {
      backgroundColor: backgroundColor
    })
  }, props));
}

Footer.Padder = Padder$1;
Footer.Slot = Slot;
var EVENTS = ['onMouseEnter', 'onClick'];

function trackEvent(HeapAnalytics, heapEventName) {
  var heapEventProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return HeapAnalytics.sendEvent(heapEventName, heapEventProps);
} // For the heapEventName prop, please use the following format:
// custom:<app>:<panel or module>/<ACTION_TAKEN>
//  where <app> is one of "search", "explore", "analyze", "present",
//  or "viz" (for UI/actions common to both explore & analyze)
// e.g. custom:analyze:info-panel/SHOW_CLUSTERING_INFO_TOOLTIP
// e.g. custom:viz:header/SEARCH_CRUMB_TOOLTIP


function HeapAnalyticsWrapper(props) {
  var HeapAnalytics = props.HeapAnalytics,
      events = props.events,
      heapEventName = props.heapEventName,
      heapEventProps = props.heapEventProps;
  var child = React__default.Children.only(props.children);
  var childProps = {};

  var trackEventHandler = function trackEventHandler() {
    return trackEvent(HeapAnalytics, heapEventName, heapEventProps);
  };

  events.forEach(function (event) {
    if (EVENTS.includes(event)) {
      childProps[event] = !child.props[event] ? function () {
        return trackEventHandler();
      } : function () {
        var _child$props;

        (_child$props = child.props)[event].apply(_child$props, arguments);

        trackEventHandler();
      };
    }
  });
  return React__default.cloneElement(child, childProps);
}

var styles$31 = {
  "HeatMap": "quid-react-components__src-components-Heatmap-__HeatMap",
  "HeatMap__header": "quid-react-components__src-components-Heatmap-__HeatMap__header",
  "HeatMap__row": "quid-react-components__src-components-Heatmap-__HeatMap__row",
  "HeatMap__row--selected": "quid-react-components__src-components-Heatmap-__HeatMap__row--selected",
  "HeatMap__resizeAware": "quid-react-components__src-components-Heatmap-__HeatMap__resizeAware",
  "HeatMap__list": "quid-react-components__src-components-Heatmap-__HeatMap__list",
  "HeatMapCell": "quid-react-components__src-components-Heatmap-__HeatMapCell",
  "HeatMap__cellWrapper": "quid-react-components__src-components-Heatmap-__HeatMap__cellWrapper",
  "HeatMapCell--header": "quid-react-components__src-components-Heatmap-__HeatMapCell--header",
  "HeatMapCell--leading": "quid-react-components__src-components-Heatmap-__HeatMapCell--leading",
  "HeatMapCell__title": "quid-react-components__src-components-Heatmap-__HeatMapCell__title",
  "HeatMapCell__variations": "quid-react-components__src-components-Heatmap-__HeatMapCell__variations",
  "HeatMapCell__variation": "quid-react-components__src-components-Heatmap-__HeatMapCell__variation",
  "HeatMapCell__text": "quid-react-components__src-components-Heatmap-__HeatMapCell__text",
  "HeatMapCell__dropdown": "quid-react-components__src-components-Heatmap-__HeatMapCell__dropdown",
  "HeatMapCell__dropdownWrapper": "quid-react-components__src-components-Heatmap-__HeatMapCell__dropdownWrapper"
};

function HeatMapCell(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$cell = _ref.cell,
      cell = _ref$cell === undefined ? {} : _ref$cell,
      style = _ref.style,
      _ref$isSelected = _ref.isSelected,
      _ref$isLeadingCell = _ref.isLeadingCell,
      isLeadingCell = _ref$isLeadingCell === undefined ? false : _ref$isLeadingCell,
      _ref$maxTextHeight = _ref.maxTextHeight,
      maxTextHeight = _ref$maxTextHeight === undefined ? 48 : _ref$maxTextHeight,
      _ref$noTextWrapper = _ref.noTextWrapper,
      noTextWrapper = _ref$noTextWrapper === undefined ? false : _ref$noTextWrapper,
      _ref$minLeadingColumn = _ref.minLeadingColumnWidth,
      minLeadingColumnWidth = _ref$minLeadingColumn === undefined ? 105 : _ref$minLeadingColumn,
      dropdown = _ref.dropdown,
      tooltip = _ref.tooltip; // If this is the leading cell, we add the needed style
  // otherwise we add the optional background color to the cell

  var finalStyle = _extends({
    color: undefined,
    backgroundColor: undefined,
    borderColor: undefined
  }, style);

  if (isLeadingCell) {
    finalStyle.color = cell.accent;
    finalStyle.borderColor = cell.accent;

    if (style != null && typeof style.width === 'number') {
      finalStyle.width = Math.max(minLeadingColumnWidth, Number(style.width));
    }
  } else {
    finalStyle.backgroundColor = cell.color;
  }

  var content = void 0;

  if (!noTextWrapper && typeof children === 'string') {
    content = React__default.createElement(Ellipsis, {
      className: styles$31.HeatMapCell__text,
      maxHeight: maxTextHeight,
      addTitle: isLeadingCell
    }, children);
  } else {
    content = children;
  }

  return React__default.createElement('div', {
    className: cn(className, styles$31.HeatMapCell, defineProperty({}, styles$31['HeatMapCell--leading'], isLeadingCell)),
    style: finalStyle,
    title: tooltip
  }, content, dropdown);
}

var popperClassName =
/*#__PURE__*/
styled.css('z-index:2;');
var menu =
/*#__PURE__*/
styled.css('width:9.29em;');

var Dropdown$1 = function (_Component) {
  inherits(Dropdown, _Component);

  function Dropdown() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Dropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isOpen: false
    }, _this.toggleDropdown = function () {
      return _this.setState(function (_ref2) {
        var isOpen = _ref2.isOpen;
        return {
          isOpen: !isOpen
        };
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Dropdown, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var renderOption = function renderOption(selectOption) {
        return function (option) {
          switch (option.type) {
            case 'separator':
              return React__default.createElement(ContextMenu$1.Divider, null);

            case 'group':
              return React.Children.toArray(option.options && option.selectOption && option.options.map(renderOption(option.selectOption)));

            default:
              return React__default.createElement(ContextMenu$1.Item, {
                onClick: function onClick() {
                  selectOption(option);

                  _this2.setState({
                    isOpen: false
                  });
                }
              }, option.label);
          }
        };
      };

      return React__default.createElement(ContextMenu$1, {
        popperClassName: popperClassName,
        onToggle: this.toggleDropdown,
        popperModifiers: this.props.popperOptions.modifiers,
        placement: this.props.popperOptions.placement,
        className: this.props.className,
        menu: React__default.createElement(ContextMenu$1.Menu, {
          className: menu
        }, React.Children.toArray(this.props.options.map(renderOption(this.props.selectOption)))),
        isOpen: this.state.isOpen
      }, this.props.children({
        onClick: this.toggleDropdown
      }));
    }
  }]);
  return Dropdown;
}(React.Component);

Dropdown$1.defaultProps = {
  popperOptions: {}
};

var generatePopperOptions = function generatePopperOptions(placement, boundariesElement) {
  return {
    placement: placement,
    modifiers: {
      keepTogether: {
        enabled: false
      },
      arrow: {
        enabled: false
      },
      preventOverflow: {
        boundariesElement: boundariesElement
      }
    }
  };
}; // FIXME(fzivolo): It will probably be easier to rewrite the component
// rather than trying to make this one type safe...


var HeatMapHeader = function (_Component) {
  inherits(HeatMapHeader, _Component);

  function HeatMapHeader() {
    classCallCheck(this, HeatMapHeader);
    return possibleConstructorReturn(this, (HeatMapHeader.__proto__ || Object.getPrototypeOf(HeatMapHeader)).apply(this, arguments));
  }

  createClass(HeatMapHeader, [{
    key: 'shouldComponentUpdate',
    //
    // React methods
    //

    /* istanbul ignore next */
    value: function shouldComponentUpdate(nextProps) {
      var widthChanged = nextProps.columnWidth !== this.props.columnWidth;

      if (widthChanged) {
        return true;
      }

      var leadingColumnWidthChanged = nextProps.leadingColumnWidth !== this.props.leadingColumnWidth;

      if (leadingColumnWidthChanged) {
        return true;
      }

      var heatmapChanged = nextProps.heatmap !== this.props.heatmap;

      if (heatmapChanged) {
        return true;
      }

      var sortPropertyChanged = nextProps.sort.property !== this.props.sort.property;
      var sortDirectionChanged = nextProps.sort.direction !== this.props.sort.direction;
      var sortVariationChanged = nextProps.sort.variation !== this.props.sort.variation;

      if (sortPropertyChanged || sortDirectionChanged || sortVariationChanged) {
        return true;
      }

      var columnsChanged = nextProps.columns !== this.props.columns;
      return columnsChanged;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var cols = this.props.columns.map(function (property, index) {
        var variationsEnabled = property.variations.filter(function (variation) {
          return variation.enabled;
        });
        var isLeading = index === 0;
        var width = (isLeading ? _this2.props.leadingColumnWidth : _this2.props.columnWidth) * variationsEnabled.length + variationsEnabled.length - 1;
        var variationsCols = void 0;
        var title = property.title;
        var maxTextHeight = 48; // Use this property to populate the sort dropdown options and enable
        // the current sorting direction

        var sortCurrent = {
          property: property.property,
          variation: undefined
        }; // If there's a single variation enabled we show it on a newline in the title cell

        if (variationsEnabled.length === 1) {
          // Add current variation to sortCurrent
          var variationName = variationsEnabled[0].title;
          var _variation = variationsEnabled[0].variation; // some variations will be completely ignored if they are the only one enabled

          if (!_this2.props.ignoredVariations.includes(_variation)) {
            title += ' \n ';
            title += variationName;
          } // Since the cell will not have the variations row, we can give more space
          // to the title


          maxTextHeight = 76;
        } // If there's more than one variation enabled, we show them in the second
        // row of the cell, `variationsCols` will contian all the cells to display
        // in the second row


        var variationsRow = null;

        if (variationsEnabled.length > 1) {
          variationsCols = variationsEnabled.map(function (variation, index2) {
            // Render variations' sorting dropdowns only once the heatmap reference is available
            var sortDropdown = void 0;

            if (_this2.props.heatmap) {
              // Add current variation to sortCurrent
              sortCurrent.variation = variation; // Create the sorting options

              var sortOptions = createSortOptions(_this2.props.sort, sortCurrent); // Create the sorting dropdown

              sortDropdown = React__default.createElement(Dropdown$1, {
                className: styles$31.HeatMapCell__dropdownWrapper,
                popperOptions: generatePopperOptions('bottom-end', _this2.props.heatmap),
                options: sortOptions,
                selectOption: function selectOption(option) {
                  return _this2.props.selectSorting(property, variation, option);
                }
              }, function (_ref) {
                var onClick = _ref.onClick;
                return React__default.createElement(Icon$1, {
                  tabIndex: 0,
                  className: styles$31.HeatMapCell__dropdown,
                  name: 'chevron_down',
                  onClick: onClick
                });
              });
            }

            return React__default.createElement(HeatMapCell, {
              key: index2,
              maxTextHeight: 24,
              className: styles$31.HeatMapCell__variation,
              dropdown: sortDropdown,
              tooltip: variation.tooltip
            }, variation.title);
          }); // Prepare to render the variations list

          variationsRow = React__default.createElement('div', {
            className: styles$31.HeatMapCell__variations
          }, variationsCols);
        } // Prepare title's dropdown, it will display the variations list
        // if there's more than one variation
        // If there's only one active variation, the sorting options of it
        // will be displayed in this dropdown as well
        // Render dropdowns only once the heatmap reference is available


        var mainDropdown = void 0;

        if (_this2.props.heatmap) {
          var dropdownOptions = []; // If there's a single variation enabled, show the sorting options
          // in the title's dropdown

          if (variationsEnabled.length === 1) {
            sortCurrent.variation = variationsEnabled[0];
            dropdownOptions = dropdownOptions.concat(createSortOptions(_this2.props.sort, sortCurrent));
          } // If there's more than one variation, show them in the dropdown
          // to allow the user to toggle them


          if (property.variations.length > 1) {
            // If there are previous options, add a separator
            if (dropdownOptions.length > 0) {
              dropdownOptions.push(_this2.props.separator);
            }

            var variationsOptions = property.variations.map(function (variation) {
              return {
                enabled: variation.enabled,
                value: variation.variation,
                label: variation.title
              };
            });
            dropdownOptions.push({
              type: 'group',
              multiSelect: true,
              options: variationsOptions,
              selectOption: function selectOption(option) {
                return _this2.props.selectVariation(property, option);
              }
            });
          }

          mainDropdown = React__default.createElement(Dropdown$1, {
            className: styles$31.HeatMapCell__dropdownWrapper,
            popperOptions: generatePopperOptions('bottom-end', _this2.props.heatmap),
            options: dropdownOptions,
            selectOption: function selectOption(option) {
              return _this2.props.selectSorting(property, property.variations[0], option);
            }
          }, function (_ref2) {
            var onClick = _ref2.onClick;
            return React__default.createElement(Icon$1, {
              tabIndex: 0,
              className: styles$31.HeatMapCell__dropdown,
              name: 'chevron_down',
              onClick: onClick
            });
          });
        }

        return React__default.createElement(HeatMapCell, {
          key: index,
          className: cn(styles$31.HeatMapCell, styles$31['HeatMapCell--header']),
          style: {
            width: width
          },
          isLeadingCell: isLeading,
          noTextWrapper: true
        }, React__default.createElement(HeatMapCell, {
          className: styles$31.HeatMapCell__title,
          maxTextHeight: maxTextHeight,
          dropdown: mainDropdown
        }, title), variationsRow);
      });
      return React__default.createElement('div', {
        className: styles$31.HeatMap__header,
        style: {
          paddingRight: this.props.scrollbarWidth
        }
      }, cols);
    }
  }]);
  return HeatMapHeader;
}(React.Component);

HeatMapHeader.defaultProps = {
  leadingColumnWidth: 105,
  columnWidth: 75,
  scrollbarWidth: 0,
  separator: {
    type: 'separator'
  },
  ignoredVariations: ['default', 'count']
};

function createSortOptions(sort, current) {
  var sortOptions = [{
    enabled: false,
    value: 'ascending',
    label: 'Sort ascending'
  }, {
    enabled: false,
    value: 'descending',
    label: 'Sort descending'
  }];

  if (sort.property === current.property && current.variation && sort.variation === current.variation.variation) {
    if (sort.direction === 'ascending') {
      sortOptions[0].enabled = true;
    } else {
      sortOptions[1].enabled = true;
    }
  }

  return sortOptions;
}

var HeatMapRow = function (_Component) {
  inherits(HeatMapRow, _Component);

  function HeatMapRow() {
    classCallCheck(this, HeatMapRow);
    return possibleConstructorReturn(this, (HeatMapRow.__proto__ || Object.getPrototypeOf(HeatMapRow)).apply(this, arguments));
  }

  createClass(HeatMapRow, [{
    key: 'onKeyDown',
    value: function onKeyDown(evt) {
      var RETURN = 13;

      if (evt.keyCode === RETURN) {
        this.props.onClick(evt);
      }
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      this._columns = mapProperties(this.props.columns);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this._columns = mapProperties(nextProps.columns);
    }
    /* istanbul ignore next */

  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var widthChanged = nextProps.columnWidth !== this.props.columnWidth;

      if (widthChanged) {
        return true;
      }

      var leadingColumnWidthChanged = nextProps.leadingColumnWidth !== this.props.leadingColumnWidth;

      if (leadingColumnWidthChanged) {
        return true;
      }

      var isSelectedChanged = nextProps.isSelected !== this.props.isSelected;

      if (isSelectedChanged) {
        return true;
      }

      var areColumnsChanged = nextProps.columns !== this.props.columns;

      if (areColumnsChanged) {
        return true;
      }

      var rowChanged = nextProps.row !== this.props.row;

      if (rowChanged) {
        return true;
      }

      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var cells = this.props.row.map(function (cell, index) {
        return Object.keys(cell.variations).map(function (variationName, index2) {
          var variation = cell.variations[variationName];
          var isLeading = index === 0 && index2 === 0; // Check if the current property + variation is enabled
          // if not, we don't want to render the cell

          var isPropEnabled = _this2._columns[cell.property][variationName];

          if (!isPropEnabled) {
            return null;
          }

          var width = isLeading ? _this2.props.leadingColumnWidth : _this2.props.columnWidth;
          return React__default.createElement(HeatMapCell, {
            key: index2,
            cell: variation,
            isSelected: _this2.props.isSelected,
            isLeadingCell: isLeading,
            maxTextHeight: _this2.props.rowHeight,
            style: {
              width: width
            }
          }, variation.label.toString());
        });
      });
      return React__default.createElement('div', {
        className: cn(styles$31.HeatMap__row, defineProperty({}, styles$31['HeatMap__row--selected'], this.props.isSelected)),
        style: {
          height: this.props.rowHeight
        },
        tabIndex: 0,
        onClick: this.props.onClick,
        onKeyDown: function onKeyDown(evt) {
          return _this2.onKeyDown(evt);
        }
      }, cells);
    }
  }]);
  return HeatMapRow;
}(React.Component); // Create a matrix of property.variation to make it easy (and fast) to check
// if a given property + variation is enabled or not


HeatMapRow.defaultProps = {
  columnWidth: 75,
  isSelected: false,
  row: []
};
HeatMapRow.propTypes = {
  columns: PropTypes.array.isRequired,
  leadingColumnWidth: PropTypes.number,
  columnWidth: PropTypes.number,
  rowHeight: PropTypes.number,
  isSelected: PropTypes.bool,
  row: PropTypes.arrayOf(PropTypes.shape({
    accentColor: PropTypes.string.isRequired,
    property: PropTypes.string.isRequired,
    variations: PropTypes.objectOf(PropTypes.shape({
      accent: PropTypes.string.isRequired,
      color: PropTypes.string.isRequired,
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    }))
  })),
  onClick: PropTypes.func.isRequired
};

function mapProperties(columns) {
  var cols = {};
  columns.forEach(function (col) {
    cols[col.property] = {};
    col.variations.forEach(function (vr) {
      return cols[col.property][vr.variation] = vr.enabled;
    });
  });
  return cols;
}

var HeatMapStyle = function (_Component) {
  inherits(HeatMapStyle, _Component);

  function HeatMapStyle() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, HeatMapStyle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = HeatMapStyle.__proto__ || Object.getPrototypeOf(HeatMapStyle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      scrollX: 0
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(HeatMapStyle, [{
    key: 'updateScrollX',
    value: function updateScrollX(el) {
      var scrollX = el.scrollLeft;
      /* istanbul ignore else */

      if (this.state.scrollX !== scrollX) {
        this.setState({
          scrollX: scrollX
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this; // Setup scroll event listener


      this.props.heatmap.addEventListener('scroll', function () {
        return _this2.updateScrollX(_this2.props.heatmap);
      }, {
        passive: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var css = '\n      .' + styles$31['HeatMapCell--leading'] + ' {\n        margin-left: -' + (this.props.leadingColumnWidth + this.props.margin) + 'px;\n        transform: translate3d(' + this.state.scrollX + 'px, 0, 0);\n      }\n      .' + styles$31['HeatMap__list'] + ' {\n        width: calc(100% + ' + this.state.scrollX + 'px);\n      }\n      .' + styles$31['HeatMap__row'] + ',\n      .' + styles$31['HeatMap__header'] + ' {\n        padding-left: ' + (this.props.leadingColumnWidth + this.props.margin) + 'px;\n      }\n    ';
      return React__default.createElement('style', {
        dangerouslySetInnerHTML: {
          __html: css
        }
      });
    }
  }]);
  return HeatMapStyle;
}(React.Component);

var Heatmap = function (_Component) {
  inherits(Heatmap, _Component);

  function Heatmap() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Heatmap);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Heatmap.__proto__ || Object.getPrototypeOf(Heatmap)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      scrollbarWidth: 0,
      listHeight: 100,
      listWidth: 100
    }, _this._contentWidth = 0, _this.updateListSize = function (listHeight, listWidth) {
      // Don't bother to update these states if they are falsy (0, undefined, etc)
      // it would lead to errors during the React rendering process and they are
      // most probably wrong values that get captured during repaints of the browser

      /* istanbul ignore else */
      if (listHeight && _this.state.listHeight !== listHeight) {
        _this.setState({
          listHeight: listHeight
        });
      }
      /* istanbul ignore else */


      if (listWidth && _this.state.listWidth !== listWidth) {
        _this.setState({
          listWidth: listWidth
        });
      }
    }, _this.updateScrollbarWidth = function (el) {
      var scrollbarWidth = Math.max(el.offsetWidth - el.scrollWidth, 0);
      /* istanbul ignore else */

      if (_this.state.scrollbarWidth !== scrollbarWidth) {
        _this.setState({
          scrollbarWidth: scrollbarWidth
        });
      }
    }, _this.selectRow = function (rowId, evt) {
      var rows = _this.props.selectedRows.slice();

      var isMulti = evt.ctrlKey || evt.metaKey;
      var selectedRows = void 0;

      if (isMulti) {
        // If we are pressing ctrl/cmd key
        if (rows.includes(rowId)) {
          // And the selected row is already in the array, we remove it
          selectedRows = rows.filter(function (id) {
            return id !== rowId;
          });
        } else {
          // Otherwise we add it to the array
          selectedRows = rows.concat([rowId]);
        }
      } else {
        // If we are not pressing ctrl/cmd key
        if (rows.length === 1 && rows[0] === rowId) {
          // And the only selected element is the clicked one, we deselect it
          selectedRows = [];
        } else {
          // Otherwise, we select it
          selectedRows = [rowId];
        }
      }

      _this.props.changeSelection(selectedRows);
    }, _this.selectSorting = function (property, variation, option) {
      var propertyName = property.property;
      var direction = option.value;
      var variationName = variation.variation;

      _this.props.changeSorting(propertyName, variationName, direction);
    }, _this.selectVariation = function (column, option) {
      var variation = option.value;
      var property = column.property + variation[0].toUpperCase() + variation.slice(1);

      _this.props.changeActiveColumns(property, !option.enabled);
    }, _this.renderRows = function (rows, columnWidth, leadingColumnWidth) {
      return rows.map(function (row, index) {
        var isSelected = _this.props.selectedRows.includes(row.id);

        return React__default.createElement(HeatMapRow, {
          columns: _this.props.heatmapData.columns,
          row: row.columns,
          rowHeight: _this.props.rowHeight,
          columnWidth: columnWidth,
          leadingColumnWidth: leadingColumnWidth,
          isSelected: isSelected,
          key: index,
          onClick: function onClick(evt) {
            return _this.selectRow(row.id, evt);
          }
        });
      });
    }, _this.handleClickOutside = function (evt) {
      // Check if the click target is the heatmap or a child of it
      var heatmap = reactDom.findDOMNode(_this._heatmap);
      var isOutsideHeatMap = heatmap && evt.currentTarget instanceof Node && !heatmap.contains(evt.currentTarget) && heatmap !== evt.currentTarget; // Check if the click target is one of the excluded nodes or a child of them
      // (by default, the viz UI elements are all excluded)

      var custom = [].slice.call(document.querySelectorAll(_this.props.ignoreClickOutside));
      var isOutsideCustom = true;
      custom.some(function (node) {
        if (node.contains(evt.target)) {
          isOutsideCustom = false;
          return true;
        }

        return false;
      });

      if (isOutsideHeatMap && isOutsideCustom) {
        _this.props.changeSelection([]);
      }
    }, _this.handleResize = function (_ref2) {
      var width = _ref2.width,
          height = _ref2.height;

      _this.updateListSize(height, width);

      _this._list && _this.updateScrollbarWidth(_this._list);
    }, _this.getColumnsCountAndMargins = function (columns, margin) {
      var visibleColumnsCount = 0;
      var additionalMargin = 0;
      columns.forEach(function (_ref3) {
        var variations = _ref3.variations;
        return variations.forEach(function (variation) {
          if (variation.enabled) {
            visibleColumnsCount++;
            additionalMargin++;
          }
        });
      });
      return {
        visibleColumnsCount: visibleColumnsCount,
        additionalMargin: additionalMargin
      };
    }, _temp), possibleConstructorReturn(_this, _ret);
  } //
  // Custom methods
  //
  // We need to know if the scrollbar is visible to adjust the header accordingly
  // Use the following 3 methods to fire the actions to the model and
  // update the data passed to the HeatMap accordingly
  // On click outside of HeatMap we deselect all the selected rows
  // This method is called once resizeAware is initialized
  // it setups the resize event listener and updates the size manually
  // the first time


  createClass(Heatmap, [{
    key: 'componentDidUpdate',
    //
    // React methods
    //
    value: function componentDidUpdate() {
      // FIXME: DOM measurements seems to be off by 3px...
      var SAFE_MARGIN = 3;
      var heatmap = reactDom.findDOMNode(this._heatmap);
      var maxScrollLeft = this._contentWidth - heatmap.offsetWidth + SAFE_MARGIN;
      /* istanbul ignore if */

      if (heatmap.scrollLeft > maxScrollLeft) {
        heatmap.scrollLeft = maxScrollLeft;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this; // Extract properties from props and state and make them easily accessible


      var _props = this.props,
          heatmapData = _props.heatmapData,
          margin = _props.margin,
          maxColWidth = _props.maxColWidth,
          minColWidth = _props.minColWidth,
          leadingCellMaxWidth = _props.leadingCellMaxWidth,
          leadingCellMinWidth = _props.leadingCellMinWidth,
          rowHeight = _props.rowHeight,
          sort = _props.sort,
          _state = this.state,
          listHeight = _state.listHeight,
          scrollbarWidth = _state.scrollbarWidth; // Calculate width of columns

      var _getColumnsCountAndMa = this.getColumnsCountAndMargins(heatmapData.columns, margin),
          visibleColumnsCount = _getColumnsCountAndMa.visibleColumnsCount,
          additionalMargin = _getColumnsCountAndMa.additionalMargin;

      var listWidth = this.state.listWidth - additionalMargin * margin; // First calculate the columns width if all the columns were supposed to be even

      var columnWidth = Math.min(Math.max(minColWidth, Math.floor(listWidth / visibleColumnsCount)), maxColWidth); // Then subtract from the list width, the width of the normal columns summed up
      // this is the available space for the leading column
      // The leading column has a minimum width to respect, this means that we may end up with
      // a leading column that overlaps it content!

      var leadingColumnWidth = Math.min(Math.max(listWidth - columnWidth * (visibleColumnsCount - 1), leadingCellMinWidth), leadingCellMaxWidth); // To avoid the overlapping problem or empty spaces, we re-calculate the normal
      // columns width, this time substracting the leading column width during the computations

      columnWidth = Math.max(minColWidth, Math.floor((listWidth - leadingColumnWidth) / (visibleColumnsCount - 1)));
      this._contentWidth = leadingColumnWidth + // leading column
      columnWidth * (visibleColumnsCount - 1) + // columns (- leading column)
      additionalMargin * margin; // additional margins

      var maxHeight = heatmapData.rows.length * (rowHeight + margin);
      var rows = this.renderRows(heatmapData.rows, columnWidth, leadingColumnWidth);
      return React__default.createElement(MouseOutside, {
        onClickOutside: this.handleClickOutside,
        className: styles$31.HeatMap,
        ref: function ref(el) {
          return _this2._heatmap = reactDom.findDOMNode(el);
        }
      }, this._heatmap && React__default.createElement(HeatMapStyle, {
        leadingColumnWidth: leadingColumnWidth,
        margin: margin,
        heatmap: this._heatmap
      }), React__default.createElement(HeatMapHeader, {
        columns: heatmapData.columns,
        scrollbarWidth: scrollbarWidth,
        columnWidth: columnWidth,
        leadingColumnWidth: leadingColumnWidth,
        heatmap: this._heatmap,
        selectSorting: this.selectSorting,
        selectVariation: this.selectVariation,
        sort: sort
      }), React__default.createElement(ResizeAware__default, {
        className: styles$31.HeatMap__resizeAware,
        onResize: this.handleResize
      }, React__default.createElement(Infinite, {
        className: styles$31.HeatMap__list,
        containerHeight: listHeight,
        elementHeight: rowHeight,
        ref: function ref(el) {
          return _this2._list = reactDom.findDOMNode(el);
        },
        styles: {
          scrollableStyle: {
            maxHeight: maxHeight
          }
        }
      }, rows)));
    }
  }]);
  return Heatmap;
}(React.Component);

Heatmap.defaultProps = {
  rowHeight: 48,
  minColWidth: 65,
  maxColWidth: 100,
  leadingCellMinWidth: 105,
  leadingCellMaxWidth: 300,
  margin: 1,
  ignoreClickOutside: '#viz .ui, [data-dropdown]',
  selectedRows: []
};
var styles$32 = {
  "HorizontalSpinner__label": "quid-react-components__src-components-HorizontalSpinner-__HorizontalSpinner__label",
  "HorizontalSpinner": "quid-react-components__src-components-HorizontalSpinner-__HorizontalSpinner",
  "HorizontalSpinner__dots": "quid-react-components__src-components-HorizontalSpinner-__HorizontalSpinner__dots",
  "HorizontalSpinner__dot": "quid-react-components__src-components-HorizontalSpinner-__HorizontalSpinner__dot",
  "dots": "quid-react-components__src-components-HorizontalSpinner-__dots",
  "HorizontalSpinner__dot--bordered": "quid-react-components__src-components-HorizontalSpinner-__HorizontalSpinner__dot--bordered",
  "HorizontalSpinner__dot--n0": "quid-react-components__src-components-HorizontalSpinner-__HorizontalSpinner__dot--n0",
  "HorizontalSpinner__dot--n1": "quid-react-components__src-components-HorizontalSpinner-__HorizontalSpinner__dot--n1",
  "HorizontalSpinner__dot--n2": "quid-react-components__src-components-HorizontalSpinner-__HorizontalSpinner__dot--n2",
  "HorizontalSpinner__dot--n3": "quid-react-components__src-components-HorizontalSpinner-__HorizontalSpinner__dot--n3",
  "HorizontalSpinner__dot--n4": "quid-react-components__src-components-HorizontalSpinner-__HorizontalSpinner__dot--n4",
  "HorizontalSpinner__dot--n5": "quid-react-components__src-components-HorizontalSpinner-__HorizontalSpinner__dot--n5",
  "ellipsis": "quid-react-components__src-components-HorizontalSpinner-__ellipsis"
};

function HorizontalSpinner(properties) {
  // Something weird happens here, if we use the object destructuring
  // with default value Flow throws a type error
  // https://github.com/facebook/flow/issues/4270
  // https://stackoverflow.com/q/44828554/2059996
  var _properties$label = properties.label,
      label = _properties$label === undefined ? 'Loading' : _properties$label,
      _properties$bordered = properties.bordered,
      bordered = _properties$bordered === undefined ? true : _properties$bordered,
      borderColor = properties.borderColor,
      style = properties.style,
      _properties$width = properties.width,
      width = _properties$width === undefined ? '30em' : _properties$width,
      className = properties.className,
      props = objectWithoutProperties(properties, ['label', 'bordered', 'borderColor', 'style', 'width', 'className']);
  return React__default.createElement('div', _extends({
    className: cn(styles$32.HorizontalSpinner, className)
  }, props, {
    style: _extends({
      width: width
    }, style)
  }), React__default.createElement('div', {
    className: styles$32['HorizontalSpinner__dots']
  }, new Array(6).fill().map(function (item, index) {
    return React__default.createElement('div', {
      className: cn(styles$32['HorizontalSpinner__dot'], styles$32['HorizontalSpinner__dot--n' + index], bordered && styles$32['HorizontalSpinner__dot--bordered']),
      style: {
        borderColor: borderColor
      },
      key: index
    });
  })), React__default.createElement('div', {
    className: styles$32['HorizontalSpinner__label']
  }, label));
} // $FlowFixMe(fzivolo): we'll soon get rid of these HOCs thanks to React hooks


var omitProps = function omitProps(keys) {
  return recompose.mapProps(function (props) {
    return omit(props, keys);
  });
}; // FIXME: get rid of the Flow comment syntax once we get to Babel 7

/*::
type ContextState = {
  active: ?string,
  select?: string => void,
  register?: string => void,
};
*/
// FIXME: get rid of the Flow comment syntax once we get to Babel 7


var Context = React.createContext
/*:: <ContextState> */
({
  active: '',
  select: undefined,
  register: undefined
}); // ⭐️ Tabs

var enhanceTabs = recompose.compose(recompose.setDisplayName('Tabs'), recompose.withStateHandlers(function (_ref) {
  var defaultActive = _ref.defaultActive;
  return {
    _registeredTabs: [],
    _active: defaultActive
  };
}, {
  _register: function _register(_ref2) {
    var _registeredTabs = _ref2._registeredTabs;
    return function (name) {
      return {
        _registeredTabs: _registeredTabs.concat(name)
      };
    };
  },
  _select: function _select() {
    return function (name) {
      return {
        _active: name
      };
    };
  }
}), recompose.mapProps(function (props) {
  return _extends({}, props, {
    _active: props._active || props._registeredTabs[0]
  });
}));
var Tabs = enhanceTabs(function (_ref3) {
  var controlledActive = _ref3.active,
      controlledOnSelect = _ref3.onSelect,
      _active = _ref3._active,
      _select = _ref3._select,
      _register = _ref3._register,
      children = _ref3.children;

  if (controlledActive != null && controlledOnSelect == null || controlledOnSelect != null && controlledActive == null) {
    // eslint-disable-next-line no-console
    console.error('Warning: TabsProvider.Tabs can be used either as a controlled or stateful component, ' + 'when used as controlled component, make sure to define both `value` and `onSelect` properties to it.');
  }

  var active = controlledActive != null ? controlledActive : _active;
  var select = controlledOnSelect != null ? controlledOnSelect : _select;
  return React__default.createElement(Context.Provider, {
    value: {
      active: active,
      select: select,
      register: _register
    }
  }, children({
    active: active
  }));
}); // ⭐️ TabList

var enhanceTabList = recompose.compose(recompose.setDisplayName('TabList'), withContext.withContext(Context, '_tabsProvider'));
var TabList = enhanceTabList(function (_ref4) {
  var _tabsProvider = _ref4._tabsProvider,
      children = _ref4.children;
  return children(_tabsProvider);
}); // ⭐️ TabPanel

var enhanceTabPanel = recompose.compose(recompose.setDisplayName('TabPanel'), withContext.withContext(Context, '_tabsProvider'), recompose.lifecycle({
  componentDidMount: function componentDidMount() {
    this.props._tabsProvider.register(this.props.name);
  }
}));
var TabPanel = enhanceTabPanel(function (_ref5) {
  var children = _ref5.children,
      name = _ref5.name,
      _tabsProvider = _ref5._tabsProvider;
  return name === _tabsProvider.active ? children({
    name: name
  }) : null;
});
var TabsProvider = {
  Tabs: Tabs,
  TabList: TabList,
  TabPanel: TabPanel
};
var FooterHeader =
/*#__PURE__*/
styled__default('div', {
  target: 'epdetbt0'
})('display:flex;height:1.86em;align-items:center;padding:', halfPadding, ' ', padding, ';box-shadow:0 ', function (props) {
  return props.open ? 1 : 0;
}, 'px 0 ', function (props) {
  return props.open ? 0 : -1;
}, 'px var(--gray1);border-radius:', function (props) {
  return !props.open ? '0 0 2px 2px' : 'none';
}, ';cursor:pointer;&:focus-mouse{outline:0;}');
var ToggleButton =
/*#__PURE__*/
styled__default(function (_ref) {
  var open = _ref.open,
      props = objectWithoutProperties(_ref, ['open']);
  return React__default.createElement(Button$1, _extends({}, props, {
    size: 'small'
  }), React__default.createElement(Icon$1, {
    className: icon,
    name: 'chevron_right'
  }));
}, {
  target: 'epdetbt1'
})('margin-left:auto;.', icon, '{transition:transform 0.2s ease-out;transform:rotate(', function (props) {
  return props.open ? 90 : 0;
}, 'deg);}');
var Footer$1 =
/*#__PURE__*/
styled__default(function (_ref2) {
  var children = _ref2.children,
      onToggle = _ref2.onToggle,
      header = _ref2.header,
      open = _ref2.open,
      props = objectWithoutProperties(_ref2, ['children', 'onToggle', 'header', 'open']);
  return React__default.createElement('div', props, React__default.createElement(FooterHeader, {
    open: open,
    tabIndex: -1,
    onClick: onToggle
  }, header, React__default.createElement(ToggleButton, {
    onClick: function onClick(evt) {
      evt.stopPropagation();
      onToggle(evt);
    },
    open: open
  })), React__default.createElement(AnimateHeight, {
    height: open ? 'auto' : 0
  }, children));
}, {
  target: 'epdetbt2'
})('position:absolute;background-color:#fff;border-width:1px;border-color:var(--gray1);border-style:solid;border-radius:0 0 2px 2px;bottom:0;left:0;right:0;'); // used as selector in the Footer component

var icon =
/*#__PURE__*/
styled.css();
var padding = 10 / 13 + 'em';
var halfPadding = 10 / 13 / 2 + 'em';
var Panel =
/*#__PURE__*/
styled__default(BasicPanel, {
  target: 'e3tlmn90'
})('position:relative;flex:1;min-height:2.14em;width:', function (props) {
  return props.width;
}, ';max-width:100%;');
var CloseBtn =
/*#__PURE__*/
styled__default(function (_ref) {
  var open = _ref.open,
      props = objectWithoutProperties(_ref, ['open']);
  return React__default.createElement(Button$1, _extends({}, props, {
    size: open ? 'small' : 'regular'
  }), React__default.createElement(Icon$1, {
    className: icon,
    name: open ? 'close' : 'info'
  }));
}, {
  target: 'e3tlmn91'
})('margin-left:auto;');
var HeaderTitle =
/*#__PURE__*/
styled__default('div', {
  target: 'e3tlmn92'
})('display:flex;flex-direction:column;justify-content:center;min-height:1.74em;');
var StyledFlipper =
/*#__PURE__*/
styled__default(reactFlipToolkit.Flipper, {
  target: 'e3tlmn93'
})('display:flex;flex-direction:column;flex:1;min-height:0;'); // FIXME: get rid of the Flow comment syntax once we get to Babel 7

/*::
type ContextType = {
  _setOpen: ?() => void,
  _open: boolean,
};
*/
// FIXME: get rid of the Flow comment syntax once we get to Babel 7

var Context$1 = React.createContext
/*:: <ContextType> */
({
  _setOpen: undefined,
  _open: false
});
var Header$1 = withContext.withContext(Context$1, '_context')(
/*#__PURE__*/
styled__default(function (_ref2) {
  var _context = _ref2._context,
      props = objectWithoutProperties(_ref2, ['_context']);
  return React__default.createElement('header', {
    className: props.className
  }, React__default.createElement(HeaderTitle, null, props.children), React__default.createElement(CloseBtn, {
    open: true,
    onClick: function onClick() {
      return _context._setOpen(!_context._open);
    }
  }));
}, {
  target: 'e3tlmn94'
})('position:relative;z-index:1;background-color:#fff;display:flex;flex-shrink:0;flex-direction:row;align-items:flex-start;padding:', function (props) {
  return props._context._open ? padding : 0;
}, ';border:', function (props) {
  return props._context._open ? 1 : 0;
}, 'px solid var(--gray1);border-radius:2px 2px 0 0;', HeaderTitle, '{display:', function (props) {
  return props._context._open ? 'flex' : 'none';
}, ';}'));
var Navbar =
/*#__PURE__*/
styled__default('nav', {
  target: 'e3tlmn95'
})('display:flex;flex-shrink:0;flex-direction:row;align-items:center;padding:', padding, ';border-width:0 1px 1px 1px;border-color:var(--gray1);border-style:solid;');
var _ref4$1 = 'min-height:9.29em;';
var _ref5 = 'display:none;min-height:0em;';
var Content = withContext.withContext(Context$1, '_context')(
/*#__PURE__*/
styled__default(function (_ref3) {
  var _context = _ref3._context,
      children = _ref3.children,
      props = objectWithoutProperties(_ref3, ['_context', 'children']);
  return React__default.createElement('div', props, children);
}, {
  target: 'e3tlmn96'
})('flex:1;flex-direction:column;', function (props) {
  return props._context._open ?
  /*#__PURE__*/
  styled.css(_ref4$1) :
  /*#__PURE__*/
  styled.css(_ref5);
}, ';'));
var TabList$1 = recompose.mapProps(function (props) {
  return _extends({}, props, {
    children: React__default.createElement(TabsProvider.TabList, null, function (_ref6) {
      var active = _ref6.active,
          select = _ref6.select;
      return React__default.createElement(ButtonGroup, {
        onToggle: select,
        buttonsState: React.Children.map(props.children, function (child) {
          return {
            name: child.props.name,
            isActive: child.props.name === active
          };
        }),
        size: 'small'
      }, props.children);
    })
  });
})(
/*#__PURE__*/
styled__default('nav', {
  target: 'e3tlmn97'
})('margin-left:auto;display:flex;'));
var TabPanel$1 =
/*#__PURE__*/
styled__default(function (_ref7) {
  var name = _ref7.name,
      props = objectWithoutProperties(_ref7, ['name']);
  return React__default.createElement(TabsProvider.TabPanel, {
    name: name
  }, function () {
    return React__default.createElement('section', props);
  });
}, {
  target: 'e3tlmn98'
})('flex:1;background-color:var(--gray1);margin-bottom:1.86em;&:last-child{border-radius:0 0 2px 2px;margin-bottom:0;}');
var setStatics = recompose.compose(recompose.setStatic('Header', Header$1), recompose.setStatic('Navbar', Navbar), recompose.setStatic('TabList', TabList$1), recompose.setStatic('TabPanel', TabPanel$1), recompose.setStatic('Footer', Footer$1), recompose.setStatic('Content', Content));
var enhance$3 = recompose.compose(setStatics, recompose.defaultProps({
  defaultOpen: true,
  onToggle: function onToggle(_open) {
    return !_open;
  },
  width: '100%'
}), recompose.withStateHandlers(function (_ref8) {
  var defaultOpen = _ref8.defaultOpen;
  return {
    _open: defaultOpen
  };
}, {
  _setOpen: function _setOpen(_ref9, props) {
    var _open = _ref9._open;
    return function () {
      var open = props.onToggle(_open);

      if (open != null) {
        return {
          _open: open
        };
      }
    };
  }
}), omitProps(['defaultOpen', 'onToggle']));
var _ref12 = 'display:flex;flex-direction:column;flex:1;overflow:hidden;';
var _ref13 = 'margin-left:auto;background-color:white;';

var InnerInfoPanel = function InnerInfoPanel(_ref10) {
  var children = _ref10.children,
      _open = _ref10._open,
      _setOpen = _ref10._setOpen,
      className = _ref10.className,
      onToggle = _ref10.onToggle,
      activeTab = _ref10.activeTab,
      onTabSelect = _ref10.onTabSelect,
      width = _ref10.width,
      props = objectWithoutProperties(_ref10, ['children', '_open', '_setOpen', 'className', 'onToggle', 'activeTab', 'onTabSelect', 'width']);
  return React__default.createElement(TabsProvider.Tabs, {
    active: activeTab,
    onSelect: onTabSelect
  }, function (_ref11) {
    var active = _ref11.active;
    return React__default.createElement(Context$1.Provider, {
      value: {
        _setOpen: _setOpen,
        _open: _open,
        active: active
      }
    }, React__default.createElement(StyledFlipper, {
      flipKey: _open
    }, _open ? React__default.createElement(reactFlipToolkit.Flipped, {
      flipId: 'infopanel'
    }, React__default.createElement('div', {
      className:
      /*#__PURE__*/

      /*#__PURE__*/
      styled.css(_ref12)
    }, React__default.createElement(reactFlipToolkit.Flipped, {
      inverseFlipId: 'infopanel'
    }, React__default.createElement(Panel, _extends({
      className: className,
      open: _open,
      flexDirection: 'column',
      'data-theme': 'light',
      width: width
    }, props), children)))) : React__default.createElement(reactFlipToolkit.Flipped, {
      flipId: 'infopanel'
    }, React__default.createElement('div', {
      className:
      /*#__PURE__*/

      /*#__PURE__*/
      styled.css(_ref13)
    }, React__default.createElement(reactFlipToolkit.Flipped, {
      inverseFlipId: 'infopanel'
    }, React__default.createElement(CloseBtn, {
      open: false,
      onClick: _setOpen
    }))))));
  });
}; // Bad Flow type, see https://github.com/acdlite/recompose/issues/671#issuecomment-391762569


var InfoPanel = enhance$3(InnerInfoPanel);
var styles$33 = {
  "InputAutosize": "quid-react-components__src-components-InputAutosize-__InputAutosize",
  "InputAutosize__sizer": "quid-react-components__src-components-InputAutosize-__InputAutosize__sizer",
  "InputAutosize__input": "quid-react-components__src-components-InputAutosize-__InputAutosize__input"
};

var toPx = function toPx(str) {
  return +str.split('px')[0];
};

var InputAutosize = function (_Component) {
  inherits(InputAutosize, _Component);

  function InputAutosize() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, InputAutosize);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = InputAutosize.__proto__ || Object.getPrototypeOf(InputAutosize)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      width: 0,
      value: ''
    }, _this.updateWidth = function (value) {
      var styles$$1 = window.getComputedStyle(_this.input, null);
      var paddings = toPx(styles$$1.paddingLeft) + toPx(styles$$1.paddingRight);

      _this.setState({
        value: value
      }, function () {
        var _this$sizer$getBoundi = _this.sizer.getBoundingClientRect(),
            width = _this$sizer$getBoundi.width;

        _this.setState({
          width: Math.ceil(width) + paddings
        });
      });
    }, _this.onChange = function (evt) {
      _this.updateWidth(evt.target.value);

      _this.props.onChange && _this.props.onChange(evt);
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(InputAutosize, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updateWidth(this.props.value || '');
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          width = _state.width,
          value = _state.value;
      var _props = this.props,
          placeholder = _props.placeholder,
          defaultValue = _props.defaultValue,
          className = _props.className;
      return React__default.createElement('div', {
        className: styles$33.InputAutosize
      }, React__default.createElement('div', {
        ref: function ref(el) {
          return el !== null && (_this2.sizer = el);
        },
        className: styles$33.InputAutosize__sizer
      }, value || defaultValue || placeholder), React__default.createElement('input', _extends({}, this.props, {
        ref: function ref(el) {
          return el !== null && (_this2.input = el);
        },
        className: cn(styles$33.InputAutosize__input, className),
        style: _extends({}, this.props, {
          width: width
        }),
        placeholder: placeholder,
        onChange: this.onChange
      })));
    }
  }]);
  return InputAutosize;
}(React.Component);

var compStyles$3 = {
  "InputDate": "quid-react-components__src-components-InputDate-__InputDate",
  "InputDate__calendar": "quid-react-components__src-components-InputDate-__InputDate__calendar",
  "InputDate__icon": "quid-react-components__src-components-InputDate-__InputDate__icon",
  "InputDate__input": "quid-react-components__src-components-InputDate-__InputDate__input",
  "InputDate__inputFormElement": "quid-react-components__src-components-InputDate-__InputDate__inputFormElement"
};

function getHTMLElementRef(input) {
  var el = reactDom.findDOMNode(input);
  return el instanceof HTMLElement ? el : undefined;
}

function toYYYYMMDD(date) {
  var day = ('0' + date.getDate()).slice(-2);
  var month = ('0' + (date.getMonth() + 1)).slice(-2);
  var year = date.getFullYear();
  return year + '-' + month + '-' + day;
}

var InputDate = function (_Component) {
  inherits(InputDate, _Component);

  function InputDate() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, InputDate);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = InputDate.__proto__ || Object.getPrototypeOf(InputDate)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      current: undefined,
      isOpen: false
    }, _this.setIsOpen = function (isOpen) {
      return _this.props.onToggle ? _this.props.onToggle(isOpen) : _this.setState({
        isOpen: isOpen
      });
    }, _this.handleOpen = function () {
      return _this.isOpen === false && _this.setIsOpen(true);
    }, _this.handleClose = function () {
      return _this.isOpen === true && _this.setIsOpen(false);
    }, _this.handleCloseOnBlur = function (evt) {
      var relatedTarget = evt.relatedTarget;

      if (_this.component && relatedTarget instanceof HTMLElement ? !_this.component.contains(relatedTarget) : true) {
        _this.setIsOpen(false);
      }
    }, _this.handleInputChange = function (evt) {
      var current = new Date(evt.target.value);

      if (!isNaN(current.getTime())) {
        _this.setState({
          current: current
        });
      }

      _this.props.onChange(evt.target.value);
    }, _this.handleSelect = function (selected) {
      _this.setIsOpen(false);

      _this.props.onChange(toYYYYMMDD(selected));
    }, _this.preventDefault = function (evt) {
      return evt.preventDefault();
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(InputDate, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          value = _props.value,
          _props$styles = _props.styles,
          styles$$1 = _props$styles === undefined ? compStyles$3 : _props$styles,
          outerClassName = _props.outerClassName,
          onChange = _props.onChange,
          isOpenProp = _props.isOpen,
          onToggle = _props.onToggle,
          className = _props.className,
          min = _props.min,
          max = _props.max,
          props = objectWithoutProperties(_props, ['value', 'styles', 'outerClassName', 'onChange', 'isOpen', 'onToggle', 'className', 'min', 'max']);
      var current = this.state.current;
      var isOpen = this.isOpen;
      var dateValue = parse(value);
      var isDateValid = !isNaN(dateValue.getTime());
      return React__default.createElement(reactPopper.Manager, {
        tag: false
      }, React__default.createElement(MouseOutside, {
        className: cn(styles$$1.InputDate, outerClassName),
        onClickOutside: this.handleClose,
        ref: function ref(el) {
          return _this2.component = getHTMLElementRef(el);
        }
      }, React__default.createElement(reactPopper.Target, null, function (_ref2) {
        var targetProps = _ref2.targetProps;
        return React__default.createElement(InputText$1, _extends({
          type: 'date',
          outerClassName: styles$$1.InputDate__input,
          className: cn(styles$$1.InputDate__inputFormElement, className),
          getInputRef: targetProps.ref,
          addon: React__default.createElement(Icon$1, {
            name: 'calendar',
            className: styles$$1['InputDate__icon']
          }),
          onFocus: _this2.handleOpen,
          focus: isOpen,
          onBlur: _this2.handleCloseOnBlur,
          value: value,
          onChange: _this2.handleInputChange,
          onClick: _this2.preventDefault,
          min: min,
          max: max
        }, props));
      }), isOpen && React__default.createElement(reactPopper.Popper, {
        className: styles$$1.InputDate__calendar,
        component: Calendar,
        placement: 'bottom-start',
        current: current || (isDateValid ? dateValue : new Date()),
        onChangeCurrent: function onChangeCurrent(current) {
          return _this2.setState({
            current: current
          });
        },
        onSelect: this.handleSelect,
        selected: isDateValid ? dateValue : undefined,
        minDate: min &&
        /* istanbul ignore next */
        new Date(min),
        maxDate: max &&
        /* istanbul ignore next */
        new Date(max)
      })));
    }
  }, {
    key: 'isOpen',
    get: function get$$1() {
      return Boolean(this.props.onToggle ? this.props.isOpen : this.state.isOpen);
    }
  }]);
  return InputDate;
}(React.Component);

var enhance$4 = recompose.withStateHandlers({
  _label: ''
}, {
  _updateLabel: function _updateLabel() {
    return function (_ref) {
      var files = _ref.target.files;
      return {
        _label: files && files.length ? files[0].name : ''
      };
    };
  }
});
var _ref3$2 = 'opacity:0;position:absolute;pointer-events:none;width:0;height:0;overflow:hidden;';

var InputFile = function InputFile(_ref2) {
  var _ref2$size = _ref2.size,
      size = _ref2$size === undefined ? 'regular' : _ref2$size,
      onChange = _ref2.onChange,
      _label = _ref2._label,
      _updateLabel = _ref2._updateLabel,
      props = objectWithoutProperties(_ref2, ['size', 'onChange', '_label', '_updateLabel']);

  var _ref4 = void 0;

  return React__default.createElement(React.Fragment, null, React__default.createElement('input', {
    ref: function ref(el) {
      return _ref4 = el;
    },
    type: 'file',
    onChange: function (_onChange) {
      function onChange(_x) {
        return _onChange.apply(this, arguments);
      }

      onChange.toString = function () {
        return _onChange.toString();
      };

      return onChange;
    }(function (evt) {
      _updateLabel(evt);

      onChange && onChange(evt);
    }),
    className:
    /*#__PURE__*/

    /*#__PURE__*/
    styled.css(_ref3$2)
  }), React__default.createElement(InputGroup, null, React__default.createElement(InputText$1, _extends({}, props, {
    value: _label,
    size: size,
    readOnly: true // Can't find a way to test this specific interaction with the input[type=file] component
    ,
    onClick:
    /* istanbul ignore next */
    function onClick() {
      return _ref4 && _ref4.click();
    }
  })), React__default.createElement(Button$1, {
    size: size,
    importance: 'primary' // Can't find a way to test this specific interaction with the input[type=file] component
    ,
    onClick:
    /* istanbul ignore next */
    function onClick() {
      return _ref4 && _ref4.click();
    }
  }, 'Select file')));
};

var index = enhance$4(InputFile);
var styles$34 = {
  "InputNumber": "quid-react-components__src-components-InputNumber-__InputNumber",
  "InputNumber__button": "quid-react-components__src-components-InputNumber-__InputNumber__button",
  "InputNumber__button--up": "quid-react-components__src-components-InputNumber-__InputNumber__button--up"
}; // Make sure to always provide a valid fallback default number
// between the min and max range
// If 0 isn't a good value, provide the closest valid value

function getDefaultFallbackValue(min, max) {
  if (min <= 0 && max >= 0) {
    return 0;
  }

  var pickMax = Math.abs(min) > Math.abs(max);
  return pickMax ? max : min;
}

var InputNumber = function (_Component) {
  inherits(InputNumber, _Component);

  function InputNumber() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, InputNumber);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = InputNumber.__proto__ || Object.getPrototypeOf(InputNumber)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      value: Number(_this.props.defaultValue || _this.props.value || getDefaultFallbackValue(_this.props.min, _this.props.max))
    }, _this.updateValue = function (evt) {
      _this.props.onChange && _this.props.onChange(evt);

      if (isNaN(_this.props.value)) {
        // Uncontrolled
        _this.setState({
          value: Number(evt.target.value)
        });
      }
    }, _this.genUpdater = function (increment) {
      return function (state) {
        var _this$props = _this.props,
            max = _this$props.max,
            min = _this$props.min,
            step = _this$props.step;
        var newValue = _this.value + step * (increment ? 1 : -1);

        if (newValue <= max && newValue >= min) {
          return {
            value: newValue
          };
        }

        return {
          value: newValue > max ? max : min
        };
      };
    }, _this.handleChange = function (evt) {
      _this.updateValue(evt);
    }, _this.shiftByStep = function (increment, step) {
      var updater = _this.genUpdater(increment);

      _this.setState(updater, function () {
        _this.input && _this.updateValue({
          target: {
            value: _this.state.value
          }
        });
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(InputNumber, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          unit = _props.unit,
          disabled = _props.disabled,
          step = _props.step,
          name = _props.name,
          min = _props.min,
          max = _props.max,
          id = _props.id,
          size = _props.size,
          props = objectWithoutProperties(_props, ['unit', 'disabled', 'step', 'name', 'min', 'max', 'id', 'size']);
      var value = this.value;
      return React__default.createElement(InputGroup, props, React__default.createElement(InputText$1, {
        type: 'number',
        alignRight: true,
        noAddonPadding: true,
        addon: unit,
        disabled: disabled,
        value: value,
        id: id,
        step: step,
        name: name,
        min: min,
        max: max,
        onChange: this.handleChange,
        getInputRef: function getInputRef(el) {
          return _this2.input = el;
        },
        style: {
          width: size && 'calc(' + size + ' * 1em)'
        }
      }), React__default.createElement('div', {
        className: styles$34.InputNumber
      }, React__default.createElement(Button$1, {
        className: cn(styles$34.InputNumber__button, styles$34['InputNumber__button--up']),
        style: {
          borderTopLeftRadius: 0,
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0
        },
        disabled: disabled,
        onClick: function onClick() {
          return _this2.shiftByStep(true, step);
        },
        'data-action': 'increase',
        'data-value': step
      }, React__default.createElement(Icon$1, {
        squared: false,
        name: 'caret_up'
      })), React__default.createElement(Button$1, {
        className: styles$34.InputNumber__button,
        style: {
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          borderBottomLeftRadius: 0
        },
        disabled: disabled,
        onClick: function onClick() {
          return _this2.shiftByStep(false, step);
        },
        'data-action': 'decrease',
        'data-value': step
      }, React__default.createElement(Icon$1, {
        squared: false,
        name: 'caret_down'
      }))));
    }
  }, {
    key: 'value',
    // Return the props value in case of controlled input
    // or the state value in case of uncontrolled
    get: function get$$1() {
      return isNaN(this.props.value) ? Number(this.state.value) : Number(this.props.value);
    }
  }]);
  return InputNumber;
}(React.Component);

InputNumber.defaultProps = {
  unit: '',
  disabled: false,
  step: 1,
  min: -Infinity,
  max: Infinity
};
var styles$35 = {
  "InputRange": "quid-react-components__src-components-InputRange-__InputRange",
  "InputRange__track--disabled": "quid-react-components__src-components-InputRange-__InputRange__track--disabled",
  "InputRange__handle--disabled": "quid-react-components__src-components-InputRange-__InputRange__handle--disabled",
  "InputRange__track": "quid-react-components__src-components-InputRange-__InputRange__track",
  "InputRange__segment": "quid-react-components__src-components-InputRange-__InputRange__segment",
  "InputRange__segment--on": "quid-react-components__src-components-InputRange-__InputRange__segment--on",
  "InputRange--dragging1": "quid-react-components__src-components-InputRange-__InputRange--dragging1",
  "InputRange--dragging2": "quid-react-components__src-components-InputRange-__InputRange--dragging2",
  "InputRange__handle": "quid-react-components__src-components-InputRange-__InputRange__handle",
  "InputRange__handle--dragging": "quid-react-components__src-components-InputRange-__InputRange__handle--dragging",
  "InputRange__handle--zero": "quid-react-components__src-components-InputRange-__InputRange__handle--zero",
  "pulse": "quid-react-components__src-components-InputRange-__pulse",
  "StepTicks": "quid-react-components__src-components-InputRange-__StepTicks",
  "StepTicks__tick": "quid-react-components__src-components-InputRange-__StepTicks__tick",
  "StepTicks__tick--hidden": "quid-react-components__src-components-InputRange-__StepTicks__tick--hidden"
};

var Handle = function (_PureComponent) {
  inherits(Handle, _PureComponent);

  function Handle() {
    classCallCheck(this, Handle);
    return possibleConstructorReturn(this, (Handle.__proto__ || Object.getPrototypeOf(Handle)).apply(this, arguments));
  }

  createClass(Handle, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          offset = _props.offset,
          color = _props.color,
          dragging = _props.dragging,
          value = _props.value,
          name = _props.name,
          disabled = _props.disabled,
          readOnly = _props.readOnly,
          className = _props.className,
          props = objectWithoutProperties(_props, ['offset', 'color', 'dragging', 'value', 'name', 'disabled', 'readOnly', 'className']);
      var isGrayedOut = disabled || readOnly;
      return React__default.createElement('div', _extends({
        className: cn(styles$35['InputRange__handle'], dragging && styles$35['InputRange__handle--dragging'], isGrayedOut && styles$35['InputRange__handle--disabled'], className),
        tabIndex: !disabled ? 0 : undefined,
        style: {
          transform: 'translateX(calc(' + offset + 'px - 50%))',
          color: !isGrayedOut && color
        },
        'data-action': 'drag-handle',
        'data-value': value
      }, props), React__default.createElement('input', {
        type: 'hidden',
        value: value,
        name: name,
        disabled: disabled,
        readOnly: readOnly
      }));
    }
  }]);
  return Handle;
}(React.PureComponent);

Handle.defaultProps = {
  offset: 0
};

var StepTicks = function (_PureComponent) {
  inherits(StepTicks, _PureComponent);

  function StepTicks() {
    classCallCheck(this, StepTicks);
    return possibleConstructorReturn(this, (StepTicks.__proto__ || Object.getPrototypeOf(StepTicks)).apply(this, arguments));
  }

  createClass(StepTicks, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          step = _props.step,
          max = _props.max,
          min = _props.min,
          hidden = _props.hidden,
          className = _props.className,
          props = objectWithoutProperties(_props, ['step', 'max', 'min', 'hidden', 'className']);
      var steps = Math.round((max - min) / step);
      return React__default.createElement('div', _extends({
        className: cn(styles$35.StepTicks, className)
      }, props), new Array(steps + 1).fill().map(function (_, key) {
        return React__default.createElement('div', {
          key: key,
          className: cn(styles$35.StepTicks__tick, hidden.includes(key) && styles$35['StepTicks__tick--hidden'])
        });
      }));
    }
  }]);
  return StepTicks;
}(React.PureComponent); // We need this to give a proper default value to `track`
// otherwise during tests something may fail because of the
// jsdom quirks that make the component lifecycle execute without
// having the root node initialized


var div = document.createElement('div');
var handles = {
  START: 'start',
  END: 'end'
};
var keys = {
  RIGHT: 39,
  LEFT: 37
};

function fromPercentToPixel(percent, width) {
  return width / 100 * percent;
}

function hasName(name) {
  return typeof name === 'string';
} // We used to use CSS gradients with hard stops, but this bug is
// producing a bad visual result (crbug.com/696603)


function wrapWithSvg(content, _ref) {
  var className = _ref.className,
      props = objectWithoutProperties(_ref, ['className']);
  return React__default.createElement('svg', _extends({
    className: cn(styles$35.InputRange__symbol, className),
    xmlns: 'http://www.w3.org/2000/svg',
    width: '100',
    height: '100'
  }, props), content);
}

function drawSegment(width, offset, color) {
  return function (props) {
    return wrapWithSvg(React__default.createElement('rect', {
      width: width >= 0 ? width + 'px' : '0px',
      height: '2px',
      fill: color,
      x: offset >= 0 ? offset + 'px' : '0px'
    }), props);
  };
}

function getDecimals(num) {
  var stepArr = num.toString().split('.');
  return stepArr[1] ? stepArr[1].length : 0;
}

function toFixed(num, decimals) {
  var parts = num.toString().split('.');
  return parts[0] + '.' + (parts[1] || '').slice(0, decimals);
}

function valueToObject(value) {
  if (value === undefined) {
    return {};
  }

  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
    if (value.hasOwnProperty(handles.START) && value.hasOwnProperty(handles.END)) {
      var _ref2;

      return _ref2 = {}, defineProperty(_ref2, handles.START, +value[handles.START]), defineProperty(_ref2, handles.END, +value[handles.END]), _ref2;
    } else if (value.hasOwnProperty(handles.START)) {
      return defineProperty({}, handles.START, +value[handles.START]);
    } else {
      return defineProperty({}, handles.END, +value[handles.END]);
    }
  }

  return defineProperty({}, handles.START, +value);
}

function computeW3cDefaultValue(min, max) {
  return max > min ? min + (max - min) / 2 : min;
}

function isItTwoHandled(value) {
  return !isNaN(value[handles.END]);
}

function areValuesEqual(a, b) {
  var compA = valueToObject(a);
  var compB = valueToObject(b);
  return compA[handles.START] === compB[handles.START] && compA[handles.END] === compB[handles.END];
}
/**
 * @component
 */


var InputRange = function (_PureComponent) {
  inherits(InputRange, _PureComponent);

  function InputRange() {
    var _ref6;

    var _temp, _this, _ret;

    classCallCheck(this, InputRange);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref6 = InputRange.__proto__ || Object.getPrototypeOf(InputRange)).call.apply(_ref6, [this].concat(args))), _this), _this.track = div, _this.pos = 0, _this.state = {
      width: 0,
      value: undefined,
      dragging: false,
      activeHandle: handles.START,
      stepLen: 0,
      fontSize: 13
    }, _this.uncontrolledOnChange = function (updater) {
      var prevValue = _extends({}, _this.state.value);

      _this.setState(updater, function () {
        if (_this.props.onChange && !areValuesEqual(prevValue, _this.state.value)) {
          _this.props.onChange(_this.state.value);
        }
      });
    }, _this.controlledOnChange = function (updater) {
      var _updater = updater(),
          value = _updater.value;

      var isTwoHandled = isItTwoHandled(value);
      var newValue = isTwoHandled ? value : value[handles.START];

      if (_this.props.onChange && !areValuesEqual(_this.props.value, newValue)) {
        _this.props.onChange(newValue);
      }
    }, _this.handleMouseDown = function (_ref7, activeHandle) {
      var pos = _ref7.clientX;

      if (_this.props.disabled || _this.props.readOnly) {
        return;
      }

      _this.updatePos(pos);

      _this.setState({
        dragging: true,
        activeHandle: activeHandle
      });
    }, _this.handleMouseMove = function (evt) {
      var curPos = evt.clientX;
      var _this2 = _this,
          track = _this2.track,
          pos = _this2.pos,
          _this2$state = _this2.state,
          dragging = _this2$state.dragging,
          stepLen = _this2$state.stepLen,
          activeHandle = _this2$state.activeHandle;

      if (track && dragging) {
        var _track$getBoundingCli = track.getBoundingClientRect(),
            left = _track$getBoundingCli.left; // This is used to avoid unwanted text selection while dragging


        evt.preventDefault && evt.preventDefault();
        var diff = curPos - pos;
        var change = diff / stepLen;
        var currentValue = _this.computedValue[activeHandle];

        var newValue = Math.round((currentValue + change) / _this.props.step) * _this.props.step;

        _this.updatePos(left + (newValue - _this.props.min) * stepLen);

        _this.updateValue(newValue);
      }
    }, _this.handleMouseUp = function () {
      return _this.setState({
        dragging: false
      });
    }, _this.handleTrackMouseDown = function (_ref8) {
      var clientX = _ref8.clientX;

      if (_this.props.disabled || _this.props.readOnly) {
        return;
      }

      var min = _this.props.min;
      var stepLen = _this.state.stepLen;

      var _this$track$getBoundi = _this.track.getBoundingClientRect(),
          left = _this$track$getBoundi.left;

      var value = _this.computedValue;
      var startOffset = stepLen * value[handles.START];
      var endOffset = stepLen * value[handles.END];
      var middleOffset = startOffset + (endOffset - startOffset) / 2;
      var curPos = clientX - left;
      var activeHandle = void 0;

      if (curPos > middleOffset && value[handles.END]) {
        activeHandle = handles.END;
      } else {
        activeHandle = handles.START;
      }

      _this.updatePos(left + (value[activeHandle] - min) * stepLen);

      _this.setState({
        dragging: true,
        activeHandle: activeHandle
      }, function () {
        _this.handleMouseMove({
          clientX: clientX
        });
      });
    }, _this.handleKeyDown = function (_ref9) {
      var which = _ref9.which;

      if (_this.props.disabled || _this.props.readOnly) {
        return;
      }

      var activeHandle = _this.state.activeHandle;
      var step = _this.props.step;

      if (which === keys.LEFT) {
        _this.updateValue(_this.computedValue[activeHandle] - step);
      } else if (which === keys.RIGHT) {
        _this.updateValue(_this.computedValue[activeHandle] + step);
      }
    }, _this.updateValue = function (newValue) {
      return _this.onChange(function () {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state;

        var safeNewValue = Math.round(parseFloat(toFixed(newValue, getDecimals(_this.props.step))) / _this.props.step) * _this.props.step;

        var activeHandle = state.activeHandle,
            _state$value = state.value,
            value = _state$value === undefined ? _this.computedValue : _state$value;
        var _this$props = _this.props,
            min = _this$props.min,
            max = _this$props.max;
        var activeHandleValue = activeHandle === handles.START ? Math.min(!isNaN(value[handles.END]) ? value[handles.END] : max, Math.max(min, safeNewValue)) : Math.max(Math.min(max, safeNewValue), value[handles.START]);
        return {
          value: _extends({}, value, defineProperty({}, activeHandle, activeHandleValue))
        };
      });
    }, _this.updatePos = function (pos) {
      var _this$track$getBoundi2 = _this.track.getBoundingClientRect(),
          left = _this$track$getBoundi2.left,
          right = _this$track$getBoundi2.right;

      _this.pos = Math.max(Math.min(pos, right), left);
    }, _this.computeSizes = function () {
      _this.setState(function (state, _ref10) {
        var min = _ref10.min,
            max = _ref10.max;
        return {
          width: _this.track.offsetWidth,
          stepLen: _this.track.offsetWidth / (max - min),
          fontSize: Number(window.getComputedStyle(_this.track).getPropertyValue('font-size').replace('px', ''))
        };
      });
    }, _this.getSegments = function (isTwoHandled) {
      var _this$props2 = _this.props,
          min = _this$props2.min,
          max = _this$props2.max,
          disabled = _this$props2.disabled,
          readOnly = _this$props2.readOnly;
      var _this$state = _this.state,
          width = _this$state.width,
          fontSize = _this$state.fontSize;
      var isGrayedOut = disabled || readOnly;
      var computedValue = _this.computedValue;
      var start = computedValue.start,
          _computedValue$end = computedValue.end,
          end = _computedValue$end === undefined ? max : _computedValue$end;
      var unit = 100 / (max - min); // 0.43em is the handle size as defined in the CSS of this component

      var handleSize = fontSize * 0.462;
      var padding = isGrayedOut ? handleSize : 0;
      var a = isTwoHandled ? start - min : 0;
      var b = isTwoHandled ? end - min : start - min;
      var seg1W = fromPercentToPixel(unit * a, width);
      var Seg1 = drawSegment(seg1W - padding, 0, 'var(--trackBackground)');
      var seg2W = fromPercentToPixel(unit * b, width) - fromPercentToPixel(unit * a, width) - padding * (isTwoHandled ? 2 : 1);
      var seg2O = seg1W + (isTwoHandled ? padding : 0);
      var Seg2 = drawSegment(seg2W, seg2O, 'var(--selected)');
      var Seg3 = drawSegment(fromPercentToPixel(100 - unit * b, width) - padding, fromPercentToPixel(unit * b, width) + padding, 'var(--trackBackground)');
      return [isTwoHandled && React__default.createElement(Seg1, {
        key: '1',
        className: styles$35['InputRange__segment']
      }), React__default.createElement(Seg2, {
        key: '2',
        className: cn(styles$35['InputRange__segment'], styles$35['InputRange__segment--on'])
      }), React__default.createElement(Seg3, {
        key: '3',
        className: styles$35['InputRange__segment']
      })];
    }, _this.handleFocusStart = function () {
      return _this.setState({
        activeHandle: handles.START
      });
    }, _this.handleFocusEnd = function () {
      return _this.setState({
        activeHandle: handles.END
      });
    }, _this.handleMouseDownStart = function (evt) {
      return _this.handleMouseDown(evt, handles.START);
    }, _this.handleMouseDownEnd = function (evt) {
      return _this.handleMouseDown(evt, handles.END);
    }, _temp), possibleConstructorReturn(_this, _ret);
  } // Don't use state because
  // 1. We don't care/want to re-render on each pos update
  // 2. We need this value to be updated istantly


  createClass(InputRange, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.computeSizes();
      document.addEventListener('mousemove', this.handleMouseMove);
      document.addEventListener('mouseup', this.handleMouseUp);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('mousemove', this.handleMouseMove);
      document.removeEventListener('mouseup', this.handleMouseUp);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var computedValue = this.computedValue,
          _props = this.props,
          discrete = _props.discrete,
          name = _props.name,
          min = _props.min,
          max = _props.max,
          readOnly = _props.readOnly,
          disabled = _props.disabled,
          onChange = _props.onChange,
          color1 = _props.color1,
          color2 = _props.color2,
          step = _props.step,
          className = _props.className,
          props = objectWithoutProperties(_props, ['discrete', 'name', 'min', 'max', 'readOnly', 'disabled', 'onChange', 'color1', 'color2', 'step', 'className']),
          _state = this.state,
          dragging = _state.dragging,
          activeHandle = _state.activeHandle;
      var isGrayedOut = readOnly || disabled; // Is two handled only if it has both `start` and `end` props

      var isTwoHandled = isItTwoHandled(computedValue);
      var valueText = isTwoHandled ? computedValue[handles.START] + ' - ' + computedValue[handles.END] : '' + computedValue[handles.START]; // If there's a single handle, we keep the original name
      // in case there are two handles, we append `1` and `2` to the original name
      // to distinguish them

      var nameStart = void 0,
          nameEnd = void 0;

      if (hasName(name)) {
        nameStart = isTwoHandled ? name + '1' : name;
        nameEnd = name + '2';
      } // Ticks shouldn't overlap with handles, we hide them if necessary


      var hiddenTicks = Object.values(computedValue).map(function (value) {
        return typeof value === 'number' ? (value - min) / step : undefined;
      }).filter(function (value) {
        return value !== undefined;
      });
      return React__default.createElement(ResizeAware__default, _extends({
        className: cn(styles$35['InputRange'], activeHandle === handles.START && dragging && styles$35['InputRange--dragging1'], activeHandle === handles.END && dragging && styles$35['InputRange--dragging2'], className),
        role: 'slider',
        'aria-valuemin': min,
        'aria-valuemax': max,
        'aria-valuetext': valueText,
        'aria-readonly': readOnly,
        'aria-disabled': disabled,
        'aria-orientation': 'horizontal',
        onResize: this.computeSizes
      }, props), React__default.createElement('div', {
        className: cn(styles$35['InputRange__track'], isGrayedOut && styles$35['InputRange__track--disabled']),
        ref: function ref(el) {
          return el !== null && (_this3.track = el);
        },
        onMouseDown: this.handleTrackMouseDown,
        'data-action': 'click-track'
      }, this.getSegments(isTwoHandled)), React__default.createElement(Handle, {
        value: computedValue[handles.START],
        name: hasName(name) ? nameStart : undefined,
        disabled: disabled,
        readOnly: readOnly,
        dragging: activeHandle === handles.START && dragging,
        onMouseDown: this.handleMouseDownStart,
        onKeyDown: this.handleKeyDown,
        offset: Math.round((computedValue[handles.START] - min) / (max - min) * this.state.width),
        onFocus: this.handleFocusStart,
        color: color2
      }), discrete && React__default.createElement(StepTicks, {
        step: step,
        min: min,
        max: max,
        hidden: hiddenTicks
      }), isTwoHandled && React__default.createElement(Handle, {
        value: computedValue[handles.END],
        name: hasName(name) ? nameEnd : undefined,
        disabled: disabled,
        readOnly: readOnly,
        dragging: activeHandle === handles.END && dragging,
        onMouseDown: this.handleMouseDownEnd,
        onKeyDown: this.handleKeyDown,
        offset: Math.round((computedValue[handles.END] - min) / (max - min) * this.state.width),
        onFocus: this.handleFocusEnd,
        color: color2
      }));
    }
  }, {
    key: 'onChange',
    get: function get$$1() {
      return this.props.onChange && (!isNaN(valueToObject(this.props.value)[handles.START]) || !isNaN(valueToObject(this.props.value)[handles.END])) ? this.controlledOnChange : this.uncontrolledOnChange;
    }
  }, {
    key: 'computedValue',
    get: function get$$1() {
      var _ref11;

      var _props2 = this.props,
          value = _props2.value,
          defaultValue = _props2.defaultValue,
          min = _props2.min,
          max = _props2.max;
      var stateValueObj = valueToObject(this.state.value);
      var propsValueObj = valueToObject(value);
      var defaultValueObj = valueToObject(defaultValue);
      var w3cDefaultValue = valueToObject(computeW3cDefaultValue(min, max)); // If it's a controlled input, use `value`
      // If there's already a `value` in state, use it
      // If it's an uncontrolled input, use `defaultValue` as initial value
      // If nothing is defined, we fallback to the default defined by W3C

      return _ref11 = {}, defineProperty(_ref11, handles.START, !isNaN(propsValueObj[handles.START]) ? propsValueObj[handles.START] : !isNaN(stateValueObj[handles.START]) ? stateValueObj[handles.START] : !isNaN(defaultValueObj[handles.START]) ? defaultValueObj[handles.START] : w3cDefaultValue[handles.START]), defineProperty(_ref11, handles.END, !isNaN(propsValueObj[handles.END]) ? propsValueObj[handles.END] : !isNaN(stateValueObj[handles.END]) ? stateValueObj[handles.END] : !isNaN(defaultValueObj[handles.END]) ? defaultValueObj[handles.END] : w3cDefaultValue[handles.END]), _ref11;
    } // start and end refer to the handle's name

  }]);
  return InputRange;
}(React.PureComponent);

InputRange.defaultProps = {
  color1: 'var(--trackBackground)',
  color2: 'var(--selected)',
  min: 0,
  max: 100,
  step: 1,
  readOnly: false,
  disabled: false,
  discrete: false
};
var color$1 = styles.color;
var WIDTH = 40;
var HEIGHT = 20;
var HANDLE_DIAMETER = 16;
var HANDLE_MARGIN = (HEIGHT - HANDLE_DIAMETER) / 2;
var SHADOW = Color(color$1.gray7).alpha(0.8).string();
var OUTLINE_ON = Color(color$1.selected).alpha(0.8).string();
var OUTLINE_OFF = Color(color$1.gray7).alpha(0.4).string();
var Container$1 =
/*#__PURE__*/
styled__default('label', {
  target: 'e5018kt0'
})('display:inline-block;position:relative;height:', HEIGHT, 'px;width:', WIDTH, 'px;');
var _ref$4 = 'opacity:0.4;';
var Slider =
/*#__PURE__*/
styled__default('div', {
  target: 'e5018kt1'
})('position:absolute;top:0;left:0;height:', HEIGHT, 'px;width:', WIDTH, 'px;border-radius:', HEIGHT, 'px;background-color:', color$1.gray2, ';transition:all 0.2s ease-in-out;', function (props) {
  return props.disabled &&
  /*#__PURE__*/
  styled.css(_ref$4);
});
var _ref2$3 = '&:hover{box-shadow:none;}';
var Handle$1 =
/*#__PURE__*/
styled__default('label', {
  target: 'e5018kt2'
})('position:absolute;top:', HANDLE_MARGIN, 'px;left:', HANDLE_MARGIN, 'px;width:', HANDLE_DIAMETER, 'px;height:', HANDLE_DIAMETER, 'px;border-radius:', HANDLE_DIAMETER, 'px;background-color:', color$1.white, ';transform:translateX(0px);transition:all 0.2s ease-in-out;&:hover{box-shadow:0 0 4px ', SHADOW, ';}', function (props) {
  return props.disabled &&
  /*#__PURE__*/
  styled.css(_ref2$3);
});
var Input =
/*#__PURE__*/
styled__default('input', {
  target: 'e5018kt3'
})('opacity:0;position:absolute;width:0;height:0;pointer-events:none;&:focus ~ ', Handle$1, '{outline:0;}&:focus-keyboard ~ ', Handle$1, '{box-shadow:0 0 2px 2px ', OUTLINE_OFF, ';}&:checked&:focus-keyboard ~ ', Handle$1, '{box-shadow:0 0 2px 2px ', OUTLINE_ON, ';}&:checked ~ ', Slider, '{background-color:', color$1.selected, ';}&:checked ~ ', Handle$1, '{transform:translateX(', WIDTH - HANDLE_DIAMETER - HANDLE_MARGIN * 2, 'px);}&:not(:disabled) ~ ', Handle$1, ':active{width:', HANDLE_DIAMETER * 1.25, 'px;}&:checked:not(:disabled) ~ ', Handle$1, ':active{margin-left:-', HANDLE_DIAMETER * 0.25, 'px;}'); // forceUpdate() in this component is used to
// make sure the component reflects the checkbox state
// after the component "grabs" the checkbox ref

var InputToggle = function (_Component) {
  inherits(InputToggle, _Component);

  function InputToggle() {
    var _ref3;

    var _temp, _this, _ret;

    classCallCheck(this, InputToggle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref3 = InputToggle.__proto__ || Object.getPrototypeOf(InputToggle)).call.apply(_ref3, [this].concat(args))), _this), _this.state = {
      id: 'quid-' + nanoid()
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(InputToggle, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          containerProps = _props.containerProps,
          props = objectWithoutProperties(_props, ['containerProps']);
      var isDisabled = this.props.disabled;
      return React__default.createElement(Container$1, containerProps, React__default.createElement(Input, _extends({}, props, {
        id: this.state.id,
        type: 'checkbox'
      })), React__default.createElement(Slider, {
        disabled: isDisabled
      }), React__default.createElement(Handle$1, {
        disabled: isDisabled,
        htmlFor: this.state.id
      }));
    }
  }]);
  return InputToggle;
}(React.Component);

var styles$36 = {
  "Label": "quid-react-components__src-components-Label-__Label",
  "Label--secondary": "quid-react-components__src-components-Label-__Label--secondary",
  "Label--disabled": "quid-react-components__src-components-Label-__Label--disabled",
  "Label--inline": "quid-react-components__src-components-Label-__Label--inline",
  "Label--noMargin": "quid-react-components__src-components-Label-__Label--noMargin",
  "Label__input": "quid-react-components__src-components-Label-__Label__input"
};
var INPUTS = [getName(InputCheckbox$1), getName(InputRadio$1)];

function enhanceIfLabel(child, key) {
  return !React.isValidElement(child) ? child : React.cloneElement(child, {
    key: key,
    className: INPUTS.includes(getName(child)) && styles$36.Label__input
  });
}

function Label(_ref) {
  var children = _ref.children,
      secondary = _ref.secondary,
      disabled = _ref.disabled,
      inline = _ref.inline,
      noMargin = _ref.noMargin,
      className = _ref.className,
      props = objectWithoutProperties(_ref, ['children', 'secondary', 'disabled', 'inline', 'noMargin', 'className']);
  return React__default.createElement('label', _extends({
    className: cn(styles$36['Label'], secondary && styles$36['Label--secondary'], disabled && styles$36['Label--disabled'], inline && styles$36['Label--inline'], noMargin && styles$36['Label--noMargin'], className)
  }, props), React.Children.map(children, enhanceIfLabel));
}

var path1 = '\
M276.5 99.2c0-6.1.2-6.6-6.1-6.6-7.7 0-8.6-.2-8.6-3.2 0-3.4 2.7-3.4 7.7-3.4 6.3 0 13.5-.2 \
19-.9l4.3-.4c1.6 0 2 1.1 2 2.7 0 .2-.4 8.4-.4 9.9 0 4.5-.2 9.9-.2 14.7v32.1c0 10.4 0 17.4 \
2.7 20.1 1.6 1.8 2.7 1.8 7.9 2.3 2.5 0 2.9 1.6 2.9 3.2 0 2.9-.7 3.4-4.3 3.4-5.9 0-6.8 0-11\
.5.2l-12.9 1.6c-2 0-2.7-.5-2.9-20.5-6.8 9.9-14.9 21.2-32.7 21.2-12.2 0-27.8-6.5-27.8-29.4 \
0-2 .5-18.7.7-22.8.2-5.4.7-14.9.9-23.9.2-6.3-.2-6.8-8.4-6.8-4.1 0-5.9 0-5.9-3.2 0-2.5 1.1-\
3.4 3.4-3.4 13.3 0 14.9-.4 24.8-1.1 2.3-.2 3.6-.2 3.6-.2 1.1 0 2 .2 2 1.8 0 .9-.7 8.4-.7 9\
.9-.7 9.5-2.3 30-2.3 46.7 0 18.5 5.6 24.2 15.1 24.2 16.5 0 24.8-16.5 26.2-24.4 1.1-6.3 1.4\
-21.9 1.4-29.1V99.2zm72.6-65c0 5.6-3.2 12.4-10.8 12.4-6.1 0-10.8-4.3-10.8-12.4 0-7 4.1-12 \
10.8-12 7.5 0 10.8 6.5 10.8 12m-.9 119.8c0 9.9 0 12.2 5.9 12.4 7.9.5 8.8.7 8.8 4.3 0 2.7-1\
.1 2.9-3.6 2.9-2.3 0-12.4-.7-17.6-.7-6.1 0-16.7.7-21.9.7-3.8 0-4.5-.7-4.5-3.2 0-3.4.9-3.6 \
9-4.1 7.2-.4 6.3-5.9 6.3-13.5v-49c0-9.3.2-11.3-4.7-11.3-6.1 0-9.9 1.1-9.9-3.2 0-2.7 2.3-3.\
4 4.3-3.4s9.7-.4 14.4-.9c6.1-.7 11.7-1.6 12.2-1.6 1.8 0 2.3 1.8 2.3 3.2 0 1.6-.7 9.3-.7 12\
.4 0 2.5-.2 8.6-.2 12v43zm92.6-42c0-11.3-5.2-23.9-23-23.9-21.9 0-28.2 23.2-28.2 39.7 0 20.\
8 6.6 39.5 26.9 39.5 10.8 0 19.6-6.3 22.1-14 2.3-6.8 2.3-16.7 2.3-19.6V112zm1.4-56.9c0-4.5\
.5-19-.5-22.3-.7-2.5-2.7-2.5-5-2.5-1.1 0-5.9.2-6.8 0-1.4-.2-2.3-.9-2.3-2.9 0-3.6 1.6-3.6 7\
.4-3.8 4.1-.2 15.8-1.8 20.5-2.7.7-.2 2-.4 2.9-.4 2.5 0 2.5 1.6 2.5 2.7s-1.1 25.7-1.1 30.5c\
0 5.9-.9 37-.9 41.3v47.4c0 22.8 1.1 23.5 9.3 23.5 2.7 0 4.1.4 4.1 3.6 0 2.9-.7 2.9-6.8 3.2\
-4.5.2-8.4.4-11.1.9-3.8.7-9.7 2-9.9 2-2.9 0-3.2-5.6-3.4-16.5-7.5 10.8-19.4 16.5-32.5 16.5-\
20.3 0-40.2-15.3-40.2-43.1 0-26 17.8-49.9 45.1-49.9 14.4 0 22.3 6.5 27.5 12.6l1.2-40.1zM95\
.3 8.1c34.7 0 68.4 16.3 68.4 83.6 0 67.6-33.7 83.6-68.4 83.6-33.8 0-67.5-16.3-67.5-83.6S60\
.9 8.1 95.3 8.1m.3-8.1C43 0 0 38.3 0 92.3c0 1.9.1 4.4.4 7.4.2 1.9.4 3.8.7 5.6.1.4.1.8.2 1.\
2.6 4 1.5 8 2.6 11.8 0 .2.1.3.1.5.1.4.3.8.4 1.3 5.6 18.4 18.3 40.4 46.1 53.3 13.3 6.7 28.6\
10.5 45.4 10.5 30.9 0 58.4-13.3 75.9-35.2 12-14.6 19.7-33.6 19.7-57.1C191.5 41.8 151.1 0 \
95.6 0M255 227.3c0-6.4-5.2-11.6-11.6-11.6-6.4 0-11.6 5.2-11.6 11.6 0 4.7 2.8 8.7 6.8 10.5\
-34.3 6.9-105.8-29-136.1-41.6-35.1-14.6-53-7.4-60.6 7-1 1.9-3 5.2-2.8 5.9 0 1.6 4.4 4.5 6\
.1 1.2 9-17.8 25.1-14.4 39.9-10.1 26.9 7.9 61.8 26.9 111.3 46.3 42.5 16.7 54.8-8.4 57.3-1\
3.9.8-1.7 1.3-3.4 1.3-5.3';
var path2 = '\
M111.2 140.3c-.8-1.3-1.5-2.4-3-2.3-1 .1-1.9.7-2.2 1.6v.1c-.9 4.5-7.8 41-49 51.6 0 0 14 4.3\
 18.3 2.1 42.6-22.3 38.3-49.2 35.9-53.1';
var DEFAULT_STYLE = {
  width: 57
};

function Logo(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? '#FFFFFF' : _ref$color,
      style = _ref.style,
      _ref$noDefaultStyle = _ref.noDefaultStyle,
      noDefaultStyle = _ref$noDefaultStyle === undefined ? false : _ref$noDefaultStyle,
      props = objectWithoutProperties(_ref, ['color', 'style', 'noDefaultStyle']);
  return React__default.createElement('svg', _extends({
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 472.4 252',
    alt: 'Quid',
    style: _extends({}, !noDefaultStyle ? DEFAULT_STYLE : {}, style)
  }, props), React__default.createElement('path', {
    fill: color,
    d: path1
  }), React__default.createElement('path', {
    fill: color,
    d: path2
  }));
}

var styles$37 = {
  "Margin": "quid-react-components__src-components-Margin-__Margin",
  "Margin__all": "quid-react-components__src-components-Margin-__Margin__all",
  "Margin__all--small": "quid-react-components__src-components-Margin-__Margin__all--small",
  "Margin__all--regular": "quid-react-components__src-components-Margin-__Margin__all--regular",
  "Margin__all--large": "quid-react-components__src-components-Margin-__Margin__all--large",
  "Margin__top": "quid-react-components__src-components-Margin-__Margin__top",
  "Margin__top--small": "quid-react-components__src-components-Margin-__Margin__top--small",
  "Margin__top--regular": "quid-react-components__src-components-Margin-__Margin__top--regular",
  "Margin__top--large": "quid-react-components__src-components-Margin-__Margin__top--large",
  "Margin__right": "quid-react-components__src-components-Margin-__Margin__right",
  "Margin__right--small": "quid-react-components__src-components-Margin-__Margin__right--small",
  "Margin__right--regular": "quid-react-components__src-components-Margin-__Margin__right--regular",
  "Margin__right--large": "quid-react-components__src-components-Margin-__Margin__right--large",
  "Margin__bottom": "quid-react-components__src-components-Margin-__Margin__bottom",
  "Margin__bottom--small": "quid-react-components__src-components-Margin-__Margin__bottom--small",
  "Margin__bottom--regular": "quid-react-components__src-components-Margin-__Margin__bottom--regular",
  "Margin__bottom--large": "quid-react-components__src-components-Margin-__Margin__bottom--large",
  "Margin__left": "quid-react-components__src-components-Margin-__Margin__left",
  "Margin__left--small": "quid-react-components__src-components-Margin-__Margin__left--small",
  "Margin__left--regular": "quid-react-components__src-components-Margin-__Margin__left--regular",
  "Margin__left--large": "quid-react-components__src-components-Margin-__Margin__left--large"
};

function getClassNames(prop, value) {
  return cn(!!value && styles$37['Margin__' + prop], !!value && styles$37['Margin__' + prop + '--' + value]);
}
/**
 * render prop pattern - AKA never write another HOC
 * https://www.youtube.com/watch?v=BcVAq3YFiuc
 * @component
 */


function Margin(_ref) {
  var all = _ref.all,
      top = _ref.top,
      right = _ref.right,
      bottom = _ref.bottom,
      left = _ref.left,
      children = _ref.children;
  var marginClassName = cn(getClassNames('all', all), getClassNames('top', top), getClassNames('right', right), getClassNames('bottom', bottom), getClassNames('left', left));
  return children(marginClassName);
} // HOC - Isn't needed, but if you really do...
// and anyway, it's written using a render prop 🤓


Margin.HOC = function MarginDiv(_ref2) {
  var all = _ref2.all,
      top = _ref2.top,
      right = _ref2.right,
      bottom = _ref2.bottom,
      left = _ref2.left,
      component = _ref2.component,
      className = _ref2.className,
      props = objectWithoutProperties(_ref2, ['all', 'top', 'right', 'bottom', 'left', 'component', 'className']);
  var Component = component || 'div';
  return React__default.createElement(Margin, {
    all: all,
    top: top,
    right: right,
    bottom: bottom,
    left: left
  }, function (marginClassName) {
    return React__default.createElement(Component, _extends({
      className: cn(marginClassName, className)
    }, props));
  });
};

var styles$38 = {
  "Markdown": "quid-react-components__src-components-Markdown-__Markdown",
  "Markdown__ul": "quid-react-components__src-components-Markdown-__Markdown__ul",
  "Markdown__ol": "quid-react-components__src-components-Markdown-__Markdown__ol"
};

function Markdown(_ref) {
  var _ref$serifStyle = _ref.serifStyle,
      serifStyle = _ref$serifStyle === undefined ? true : _ref$serifStyle,
      _ref$overrides = _ref.overrides,
      overrides = _ref$overrides === undefined ? {} : _ref$overrides,
      props = objectWithoutProperties(_ref, ['serifStyle', 'overrides']);
  var options = {
    forceBlock: true,
    overrides: _extends({
      h1: {
        component: Text,
        props: {
          tag: 'h1',
          type: cn(serifStyle ? 'title' : 'large', 'bold')
        }
      },
      a: {
        component: Text,
        props: {
          tag: 'a',
          type: cn(serifStyle && 'body', 'bold', 'link')
        }
      },
      strong: {
        component: Text,
        props: {
          tag: 'strong',
          type: cn(serifStyle && 'body', 'bold')
        }
      },
      em: {
        component: Text,
        props: {
          tag: 'em',
          type: cn(serifStyle && 'body', 'italic')
        }
      },
      hr: {
        component: Separator
      },
      p: {
        component: Text,
        props: {
          tag: 'p',
          type: cn(serifStyle && 'body')
        }
      },
      ul: {
        props: {
          className: styles$38.Markdown__ul
        }
      },
      ol: {
        props: {
          className: styles$38.Markdown__ol
        }
      },
      li: {
        component: Text,
        props: {
          tag: 'li',
          type: cn(serifStyle && 'body')
        }
      }
    }, overrides)
  };
  return React__default.createElement(MarkdownToJsx, _extends({}, props, {
    options: options
  }));
}

var styles$39 = {
  "Modal__centerer": "quid-react-components__src-components-Modal-__Modal__centerer",
  "Header__title": "quid-react-components__src-components-Modal-__Header__title",
  "Modal": "quid-react-components__src-components-Modal-__Modal",
  "Modal__overlay": "quid-react-components__src-components-Modal-__Modal__overlay",
  "Modal__content": "quid-react-components__src-components-Modal-__Modal__content",
  "Modal__content--standardSized": "quid-react-components__src-components-Modal-__Modal__content--standardSized",
  "Modal__centerer--padded": "quid-react-components__src-components-Modal-__Modal__centerer--padded",
  "Modal__centerer--centerVertically": "quid-react-components__src-components-Modal-__Modal__centerer--centerVertically",
  "Modal__main": "quid-react-components__src-components-Modal-__Modal__main",
  "Modal__action": "quid-react-components__src-components-Modal-__Modal__action",
  "Modal__side": "quid-react-components__src-components-Modal-__Modal__side",
  "Modal__side--left": "quid-react-components__src-components-Modal-__Modal__side--left",
  "Modal__side--right": "quid-react-components__src-components-Modal-__Modal__side--right",
  "Modal__button": "quid-react-components__src-components-Modal-__Modal__button",
  "Modal__button--first": "quid-react-components__src-components-Modal-__Modal__button--first",
  "Modal__button--last": "quid-react-components__src-components-Modal-__Modal__button--last",
  "Header": "quid-react-components__src-components-Modal-__Header",
  "Header--action": "quid-react-components__src-components-Modal-__Header--action",
  "Header--info": "quid-react-components__src-components-Modal-__Header--info",
  "Header--warning": "quid-react-components__src-components-Modal-__Header--warning",
  "Header__icon": "quid-react-components__src-components-Modal-__Header__icon"
};

function Header$2(_ref) {
  var title = _ref.title,
      icon = _ref.icon,
      importance = _ref.importance,
      className = _ref.className,
      props = objectWithoutProperties(_ref, ['title', 'icon', 'importance', 'className']);
  return React__default.createElement('header', _extends({
    className: cn(styles$39.Header, styles$39['Header--' + importance], className)
  }, props), React__default.createElement('h1', {
    className: styles$39.Header__title
  }, title), icon && React__default.createElement(Icon$1, {
    className: styles$39.Header__icon,
    name: icon
  }));
}

var ACTION = 'action';

function addMargin(list, styles$$1) {
  var len = list instanceof Array ? list.length - 1 : 0;
  return React.Children.map(list, function (element, index) {
    // If it's not a node, we can't add any class to it
    if (!React.isValidElement(element)) {
      return element;
    } // If it's a node, we add the classes needed to add padding


    return React.cloneElement(element, {
      className: cn(styles$$1.Modal__button, index === 0 && styles$$1['Modal__button--first'], index === len && styles$$1['Modal__button--last'])
    });
  });
}

var enhance$5 = recompose.compose(recompose.setDisplayName('Modal'), recompose.withPropsOnChange(['formTag'], function (props) {
  return {
    OptionalForm:
    /*#__PURE__*/
    styled__default(props.formTag || 'div', {
      target: 'em435ss0'
    })('flex:1;display:flex;flex-direction:column;overflow-y:auto;')
  };
}));

function Modal(_ref) {
  var title = _ref.title,
      alt = _ref.alt,
      icon = _ref.icon,
      _ref$noPadding = _ref.noPadding,
      noPadding = _ref$noPadding === undefined ? false : _ref$noPadding,
      _ref$importance = _ref.importance,
      importance = _ref$importance === undefined ? ACTION : _ref$importance,
      _ref$ignoreHeightLimi = _ref.ignoreHeightLimits,
      ignoreHeightLimits = _ref$ignoreHeightLimi === undefined ? false : _ref$ignoreHeightLimi,
      _ref$centerVertically = _ref.centerVertically,
      centerVertically = _ref$centerVertically === undefined ? false : _ref$centerVertically,
      children = _ref.children,
      action = _ref.action,
      actionRight = _ref.actionRight,
      actionLeft = _ref.actionLeft,
      overlayClassName = _ref.overlayClassName,
      _ref$styles = _ref.styles,
      styles$$1 = _ref$styles === undefined ? styles$39 : _ref$styles,
      _ref$ariaHideApp = _ref.ariaHideApp,
      ariaHideApp = _ref$ariaHideApp === undefined ? false : _ref$ariaHideApp,
      className = _ref.className,
      formProps = _ref.formProps,
      OptionalForm = _ref.OptionalForm,
      props = objectWithoutProperties(_ref, ['title', 'alt', 'icon', 'noPadding', 'importance', 'ignoreHeightLimits', 'centerVertically', 'children', 'action', 'actionRight', 'actionLeft', 'overlayClassName', 'styles', 'ariaHideApp', 'className', 'formProps', 'OptionalForm']);

  if (title && typeof title !== 'string' && !alt) {
    throw new Error('`alt` property is required when `title` isn\'t a string!');
  }

  var actionBar = React__default.createElement('div', {
    className: styles$$1.Modal__action
  }, actionLeft && React__default.createElement('div', {
    className: cn(styles$$1.Modal__side, styles$$1['Modal__side--left'])
  }, addMargin(actionLeft, styles$$1)), action, actionRight && React__default.createElement('div', {
    className: cn(styles$$1.Modal__side, styles$$1['Modal__side--right'])
  }, addMargin(actionRight, styles$$1)));
  return React__default.createElement(ReactModal, _extends({
    className: cn(styles$$1.Modal__content, !ignoreHeightLimits && styles$$1['Modal__content--standardSized'], className),
    overlayClassName: cn(styles$$1.Modal__overlay, overlayClassName),
    contentLabel: alt || title,
    ariaHideApp: ariaHideApp // this can be overridden by the consumer to improve accessibility

  }, props), React__default.createElement(OptionalForm, formProps, !!title && React__default.createElement(Header$2, {
    title: title,
    icon: icon,
    importance: importance
  }), React__default.createElement('div', {
    className: cn(styles$$1.Modal__centerer, !noPadding && styles$$1['Modal__centerer--padded'], centerVertically && styles$$1['Modal__centerer--centerVertically'])
  }, React__default.createElement('div', {
    className: styles$$1.Modal__main
  }, children)), actionBar));
}

var index$1 = enhance$5(Modal);
var styles$40 = {
  "Navbar": "quid-react-components__src-components-Navbar-__Navbar",
  "Navbar__logo": "quid-react-components__src-components-Navbar-__Navbar__logo",
  "Navbar__breadcrumb": "quid-react-components__src-components-Navbar-__Navbar__breadcrumb",
  "Navbar__tools": "quid-react-components__src-components-Navbar-__Navbar__tools"
};

function Navbar$1(_ref) {
  var logo = _ref.logo,
      breadcrumb = _ref.breadcrumb,
      tools = _ref.tools,
      className = _ref.className,
      props = objectWithoutProperties(_ref, ['logo', 'breadcrumb', 'tools', 'className']);
  return React__default.createElement('nav', _extends({
    className: cn(styles$40.Navbar, className)
  }, props), React__default.createElement('div', {
    className: styles$40.Navbar__logo
  }, logo), React__default.createElement('div', {
    className: styles$40.Navbar__breadcrumb
  }, breadcrumb), React__default.createElement('div', {
    className: styles$40.Navbar__tools
  }, tools));
}

var styles$41 = {
  "Panel": "quid-react-components__src-components-Panel-__Panel",
  "Panel--collapsed": "quid-react-components__src-components-Panel-__Panel--collapsed",
  "Panel__title": "quid-react-components__src-components-Panel-__Panel__title",
  "Panel__toggle": "quid-react-components__src-components-Panel-__Panel__toggle",
  "Panel__content": "quid-react-components__src-components-Panel-__Panel__content",
  "Panel__header": "quid-react-components__src-components-Panel-__Panel__header",
  "Panel__header--rightAlign": "quid-react-components__src-components-Panel-__Panel__header--rightAlign",
  "Panel__header--noMarginBottom": "quid-react-components__src-components-Panel-__Panel__header--noMarginBottom",
  "Panel__titleAnimator": "quid-react-components__src-components-Panel-__Panel__titleAnimator",
  "Panel__contentAnimator": "quid-react-components__src-components-Panel-__Panel__contentAnimator",
  "Panel__title--entering": "quid-react-components__src-components-Panel-__Panel__title--entering",
  "Panel__content--entering": "quid-react-components__src-components-Panel-__Panel__content--entering",
  "Panel__title--entered": "quid-react-components__src-components-Panel-__Panel__title--entered",
  "Panel__content--entered": "quid-react-components__src-components-Panel-__Panel__content--entered",
  "Panel__title--exiting": "quid-react-components__src-components-Panel-__Panel__title--exiting",
  "Panel__content--exiting": "quid-react-components__src-components-Panel-__Panel__content--exiting",
  "Panel__title--exited": "quid-react-components__src-components-Panel-__Panel__title--exited",
  "Panel__content--exited": "quid-react-components__src-components-Panel-__Panel__content--exited"
};
var styles$42 = {
  "PanelTitle": "quid-react-components__src-components-Panel-Title-__PanelTitle",
  "PanelTitle--padded": "quid-react-components__src-components-Panel-Title-__PanelTitle--padded",
  "PanelTitle__trimmer": "quid-react-components__src-components-Panel-Title-__PanelTitle__trimmer"
};

function PanelTitle(_ref) {
  var children = _ref.children,
      text = _ref.text,
      className = _ref.className,
      props = objectWithoutProperties(_ref, ['children', 'text', 'className']);
  return React__default.createElement('div', _extends({
    className: cn(styles$42.PanelTitle, !!text && styles$42['PanelTitle--padded'], className)
  }, props), text ? React__default.createElement('span', {
    className: styles$42.PanelTitle__trimmer
  }, text) : children);
}

var styles$43 = {
  "PanelToggle": "quid-react-components__src-components-Panel-Toggle-__PanelToggle",
  "PanelToggle__button": "quid-react-components__src-components-Panel-Toggle-__PanelToggle__button",
  "PanelToggle__icon": "quid-react-components__src-components-Panel-Toggle-__PanelToggle__icon"
};

function PanelToggle(_ref) {
  var icon = _ref.icon,
      onClick = _ref.onClick,
      className = _ref.className,
      props = objectWithoutProperties(_ref, ['icon', 'onClick', 'className']);
  return React__default.createElement('div', _extends({
    className: cn(styles$43.PanelToggle, className)
  }, props), React__default.createElement(Button$1, {
    className: styles$43.PanelToggle__button,
    importance: 'secondary',
    transparent: true,
    onClick: onClick,
    'data-action': 'toggle'
  }, React__default.createElement(Icon$1, {
    className: styles$43.PanelToggle__icon,
    name: icon
  })));
}

function handleToggle(onToggle, isOpen) {
  return onToggle && onToggle(!isOpen);
}

function Panel$1(_ref) {
  var children = _ref.children,
      headerContent = _ref.headerContent,
      headerText = _ref.headerText,
      icon = _ref.icon,
      onToggle = _ref.onToggle,
      isOpen = _ref.isOpen,
      rightAlign = _ref.rightAlign,
      _ref$hideHeader = _ref.hideHeader,
      hideHeader = _ref$hideHeader === undefined ? false : _ref$hideHeader,
      className = _ref.className,
      contentClassName = _ref.contentClassName,
      props = objectWithoutProperties(_ref, ['children', 'headerContent', 'headerText', 'icon', 'onToggle', 'isOpen', 'rightAlign', 'hideHeader', 'className', 'contentClassName']);
  var body = children && React__default.createElement(Transition, {
    className: styles$41.Panel__contentAnimator,
    'in': children && isOpen,
    timeout: 200
  }, function (state) {
    return React__default.createElement('div', {
      className: cn(styles$41.Panel__content, styles$41['Panel__content--' + state], contentClassName)
    }, children);
  });
  return React__default.createElement('aside', _extends({
    className: cn(styles$41.Panel, !isOpen && styles$41['Panel--collapsed'], className)
  }, props), !hideHeader && React__default.createElement('header', {
    className: cn(styles$41['Panel__header'], rightAlign && styles$41['Panel__header--rightAlign'], !children && styles$41['Panel__header--noMarginBottom'])
  }, React__default.createElement(PanelToggle, {
    className: styles$41.Panel__toggle,
    onClick: function onClick() {
      return handleToggle(onToggle, isOpen);
    },
    icon: icon
  }), React__default.createElement(Transition, {
    'in': isOpen,
    className: styles$41.Panel__titleAnimator,
    timeout: 200
  }, function (state) {
    return React__default.createElement(PanelTitle, {
      className: cn(styles$41.Panel__title, styles$41['Panel__title--' + state]),
      text: headerText
    }, headerContent);
  })), body);
}

Panel$1.Title = PanelTitle;
Panel$1.Toggle = PanelToggle;
var styles$44 = {
  "PillList": "quid-react-components__src-components-PillList-__PillList",
  "PillList__header": "quid-react-components__src-components-PillList-__PillList__header",
  "PillList__addButton": "quid-react-components__src-components-PillList-__PillList__addButton",
  "PillList__addIcon": "quid-react-components__src-components-PillList-__PillList__addIcon",
  "PillList__noPills": "quid-react-components__src-components-PillList-__PillList__noPills",
  "PillList__pills": "quid-react-components__src-components-PillList-__PillList__pills",
  "PillList__pill": "quid-react-components__src-components-PillList-__PillList__pill"
};
var styles$45 = {
  "Pill": "quid-react-components__src-components-PillList-Pill-__Pill",
  "Pill--disabled": "quid-react-components__src-components-PillList-Pill-__Pill--disabled",
  "Pill__counter": "quid-react-components__src-components-PillList-Pill-__Pill__counter",
  "Pill--highlighted": "quid-react-components__src-components-PillList-Pill-__Pill--highlighted",
  "Pill__input": "quid-react-components__src-components-PillList-Pill-__Pill__input",
  "Pill__input--button": "quid-react-components__src-components-PillList-Pill-__Pill__input--button",
  "Pill__delete": "quid-react-components__src-components-PillList-Pill-__Pill__delete"
};
var ENTER$1 = 13;
var ESC$1 = 27;

function handleKeyDown$1(evt, onEnter, onBlur) {
  if (evt.which === ENTER$1) {
    onEnter && onEnter(evt);
  }

  if (evt.which === ESC$1) {
    onBlur && onBlur(evt);
  }
}

function Pill(_ref) {
  var children = _ref.children,
      count = _ref.count,
      readOnly = _ref.readOnly,
      onBlur = _ref.onBlur,
      _ref$highlighted = _ref.highlighted,
      highlighted = _ref$highlighted === undefined ? false : _ref$highlighted,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === undefined ? false : _ref$disabled,
      onDelete = _ref.onDelete,
      onSelect = _ref.onSelect,
      onEnter = _ref.onEnter,
      _ref$maxLength = _ref.maxLength,
      maxLength = _ref$maxLength === undefined ? 28 : _ref$maxLength,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === undefined ? 200 : _ref$maxWidth,
      className = _ref.className,
      props = objectWithoutProperties(_ref, ['children', 'count', 'readOnly', 'onBlur', 'highlighted', 'disabled', 'onDelete', 'onSelect', 'onEnter', 'maxLength', 'maxWidth', 'className']);
  var Tag = readOnly ? 'button' : InputAutosize;
  var mainProps = readOnly ? {
    children: children,
    disabled: !onSelect,
    onClick: onSelect
  } : {
    autoFocus: true,
    maxLength: maxLength,
    defaultValue: children,
    onBlur: onBlur,
    placeholder: '...',
    onKeyDown: function onKeyDown(evt) {
      return handleKeyDown$1(evt, onEnter, onBlur);
    }
  };
  return React__default.createElement('li', _extends({
    className: cn(styles$45.Pill, highlighted && styles$45['Pill--highlighted'], disabled && styles$45['Pill--disabled'], className)
  }, props), React__default.createElement(Tag, _extends({
    className: cn(styles$45['Pill__input'], readOnly && styles$45['Pill__input--button']),
    style: {
      maxWidth: maxWidth
    }
  }, mainProps)), !!count && React__default.createElement('div', {
    className: styles$45.Pill__counter
  }, count), !!onDelete && React__default.createElement('button', {
    className: styles$45.Pill__delete,
    onClick: onDelete,
    'data-action': 'delete-pill'
  }, React__default.createElement(Icon$1, {
    name: 'times'
  })));
}

function getVisiblePills(pills, paginate, page, firstPageItems, restPageItems) {
  if (paginate) {
    var visiblePillCount = firstPageItems + page * restPageItems;
    return pills.slice(0, visiblePillCount);
  }

  return pills;
}

var PillList = function (_Component) {
  inherits(PillList, _Component);

  function PillList() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, PillList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = PillList.__proto__ || Object.getPrototypeOf(PillList)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      page: 0
    }, _this.handlePaginate = function () {
      return _this.setState(function (prevState) {
        return {
          page: prevState.page + 1
        };
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(PillList, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          pills = _props.pills,
          onAbort = _props.onAbort,
          onConfirm = _props.onConfirm,
          onDelete = _props.onDelete,
          onSelect = _props.onSelect,
          _props$maxLength = _props.maxLength,
          maxLength = _props$maxLength === undefined ? 28 : _props$maxLength,
          _props$placeholder = _props.placeholder,
          placeholder = _props$placeholder === undefined ? 'There are no pills' : _props$placeholder,
          _props$paginate = _props.paginate,
          paginate = _props$paginate === undefined ? false : _props$paginate,
          _props$firstPageItems = _props.firstPageItems,
          firstPageItems = _props$firstPageItems === undefined ? 100 : _props$firstPageItems,
          _props$restPageItems = _props.restPageItems,
          restPageItems = _props$restPageItems === undefined ? 25 : _props$restPageItems,
          _props$PillComponent = _props.PillComponent,
          PillComponent = _props$PillComponent === undefined ? Pill : _props$PillComponent,
          className = _props.className,
          props = objectWithoutProperties(_props, ['pills', 'onAbort', 'onConfirm', 'onDelete', 'onSelect', 'maxLength', 'placeholder', 'paginate', 'firstPageItems', 'restPageItems', 'PillComponent', 'className']);
      var page = this.state.page;
      var noPills = React__default.createElement('div', {
        className: styles$44.PillList__noPills
      }, placeholder);
      var visiblePills = getVisiblePills(pills, paginate, page, firstPageItems, restPageItems).map(function (pill) {
        var label = pill.label,
            id = pill.id,
            editing = pill.editing,
            creating = pill.creating,
            className = pill.className,
            pillProps = objectWithoutProperties(pill, ['label', 'id', 'editing', 'creating', 'className']);
        return React__default.createElement(PillComponent, _extends({
          className: cn(styles$44.PillList__pill, className),
          key: id
        }, pillProps, {
          maxLength: maxLength,
          readOnly: !editing && !creating,
          onBlur: function onBlur() {
            return onAbort && onAbort(pill);
          },
          onEnter: function onEnter(_ref2) {
            var label = _ref2.target.value;
            return onConfirm && onConfirm(_extends({}, pill, {
              label: label
            }));
          },
          onSelect: onSelect ? function (evt) {
            return onSelect && onSelect(pill, evt);
          } : undefined,
          onDelete: onDelete ? function (evt) {
            return onDelete && onDelete(pill, evt);
          } : undefined
        }), label);
      });

      if (visiblePills.length < pills.length) {
        visiblePills.push(React__default.createElement(PillComponent, {
          className: styles$44.PillList__pill,
          key: 'more',
          readOnly: true,
          onSelect: this.handlePaginate
        }, 'More'));
      }

      return React__default.createElement('ul', _extends({
        className: cn(styles$44.PillList__pills, className)
      }, props), !pills.length ? noPills : visiblePills);
    }
  }]);
  return PillList;
}(React.Component);

function PointerEvents(_ref) {
  var none = _ref.none,
      children = _ref.children,
      style = _ref.style;

  if (!children) {
    return null;
  }

  var child = React.Children.only(children);
  return React__default.cloneElement(child, {
    style: _extends({}, style, {
      pointerEvents: none ? 'none' : 'auto'
    })
  });
}

var styles$46 = {
  "QuadrantTab": "quid-react-components__src-components-QuadrantTab-__QuadrantTab",
  "QuadrantTab__header": "quid-react-components__src-components-QuadrantTab-__QuadrantTab__header",
  "QuadrantTab__main": "quid-react-components__src-components-QuadrantTab-__QuadrantTab__main",
  "QuadrantTab__column": "quid-react-components__src-components-QuadrantTab-__QuadrantTab__column",
  "QuadrantTab__button": "quid-react-components__src-components-QuadrantTab-__QuadrantTab__button"
};
var styles$47 = {
  "Quadrant": "quid-react-components__src-components-QuadrantTab-Quadrant-__Quadrant",
  "Quadrant--noShrink": "quid-react-components__src-components-QuadrantTab-Quadrant-__Quadrant--noShrink"
};

function Quadrant(_ref) {
  var height = _ref.height,
      getRef = _ref.getRef,
      parentHeight = _ref.parentHeight,
      className = _ref.className,
      props = objectWithoutProperties(_ref, ['height', 'getRef', 'parentHeight', 'className']);
  var noShrink = height <= parentHeight / 2;
  return React__default.createElement('div', _extends({
    ref: getRef,
    className: cn(styles$47.Quadrant, noShrink && styles$47['Quadrant--noShrink'], className)
  }, props));
}

var Quadrant$1 = ResizeAware.makeResizeAware(Quadrant);

var QuadrantTab = function (_Component) {
  inherits(QuadrantTab, _Component);

  function QuadrantTab() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, QuadrantTab);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = QuadrantTab.__proto__ || Object.getPrototypeOf(QuadrantTab)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      height: undefined
    }, _this.handleResize = function (_ref2) {
      var height = _ref2.height;
      return _this.setState({
        height: height
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(QuadrantTab, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          quadrants = _props.quadrants,
          onToggle = _props.onToggle,
          className = _props.className,
          props = objectWithoutProperties(_props, ['quadrants', 'onToggle', 'className']);

      if (quadrants.length > 4) {
        throw new Error('QuadrantTab accepts no more than 4 quadrants');
      }

      var quadrantItems = quadrants.filter(function (_ref3) {
        var isOpen = _ref3.isOpen;
        return isOpen;
      }).map(function (quadrant) {
        return React__default.createElement(Quadrant$1, {
          key: quadrant.id,
          parentHeight: _this2.state.height
        }, quadrant.content);
      });
      var half = quadrantItems.length / 2;
      var whole = quadrantItems.length;
      var buttonsState = quadrants.map(function (_ref4) {
        var name = _ref4.id,
            isActive = _ref4.isOpen;
        return {
          name: name,
          isActive: isActive
        };
      });
      return React__default.createElement('div', _extends({
        className: cn(styles$46.QuadrantTab, className)
      }, props), React__default.createElement(ButtonGroup, {
        className: styles$46.QuadrantTab__header,
        buttonsState: buttonsState,
        onToggle: onToggle
      }, quadrants.map(function (quadrant) {
        return React__default.createElement(Button$1, {
          key: quadrant.id,
          name: quadrant.id,
          className: styles$46.QuadrantTab__button,
          'data-context': quadrant.id,
          'data-action': 'toggle-quadrant',
          'data-value': quadrant.isOpen ? 'closed' : 'open'
        }, React__default.createElement(Icon$1, {
          name: quadrant.icon
        }));
      })), React__default.createElement(ResizeAware__default, {
        onlyEvent: true,
        className: styles$46.QuadrantTab__main,
        onResize: this.handleResize
      }, React__default.createElement('div', {
        className: styles$46.QuadrantTab__column
      }, quadrantItems.slice(0, half)), React__default.createElement('div', {
        className: styles$46.QuadrantTab__column
      }, quadrantItems.slice(half, whole))));
    }
  }]);
  return QuadrantTab;
}(React.Component);

var styles$48 = {
  "RadialGaugeChart": "quid-react-components__src-components-RadialGaugeChart-__RadialGaugeChart",
  "RadialGaugeChart__chart": "quid-react-components__src-components-RadialGaugeChart-__RadialGaugeChart__chart",
  "RadialGaugeChart__labelBox": "quid-react-components__src-components-RadialGaugeChart-__RadialGaugeChart__labelBox",
  "RadialGaugeChart__label": "quid-react-components__src-components-RadialGaugeChart-__RadialGaugeChart__label"
};

function RadialGaugeChart(_ref) {
  var _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === undefined ? 'var(--gray1)' : _ref$backgroundColor,
      _ref$foregroundColor = _ref.foregroundColor,
      foregroundColor = _ref$foregroundColor === undefined ? 'var(--selected)' : _ref$foregroundColor,
      _ref$radius = _ref.radius,
      radius = _ref$radius === undefined ? 50 : _ref$radius,
      percentage = _ref.percentage;

  if (percentage < 0 || percentage > 100) {
    throw new Error('RadialGaugeChart expects `percentage` to be a number included within 0 and 100');
  }

  return React__default.createElement('div', {
    className: styles$48.RadialGaugeChart
  }, React__default.createElement('svg', {
    xmlns: 'http://www.w3.org/2000/svg',
    version: '1.1',
    viewBox: '0 0 36 36',
    width: radius,
    height: radius,
    className: styles$48.RadialGaugeChart__chart
  }, React__default.createElement('circle', {
    cx: '18',
    cy: '18',
    r: '15.91549430918954',
    stroke: backgroundColor,
    strokeWidth: '4',
    fill: 'transparent'
  }), React__default.createElement('circle', {
    cx: '18',
    cy: '18',
    r: '15.91549430918954',
    stroke: foregroundColor,
    strokeWidth: '4',
    strokeDasharray: percentage + ' ' + (100 - percentage),
    fill: 'transparent'
  })), React__default.createElement('div', {
    className: styles$48.RadialGaugeChart__labelBox,
    style: {
      fontSize: radius + 'px'
    }
  }, React__default.createElement('div', {
    className: styles$48.RadialGaugeChart__label
  }, percentage + '%')));
}

var styles$49 = {
  "SegmentBarChart": "quid-react-components__src-components-SegmentBarChart-__SegmentBarChart"
};

function genGradientSegments(segments, total) {
  var totalPercentage = 0;
  return segments.map(function (_ref, index) {
    var color = _ref.color,
        value = _ref.value;
    var percentage = 100 / total * value;
    var segment = '\n        ' + color + ' ' + totalPercentage + '%,\n        ' + color + ' ' + (totalPercentage + percentage) + '%\n      ';
    totalPercentage += percentage;
    return segment;
  }).join(',');
}

function SegmentBarChart(_ref2) {
  var segments = _ref2.segments,
      className = _ref2.className,
      props = objectWithoutProperties(_ref2, ['segments', 'className']);
  var total = segments.reduce(function (tot, _ref3) {
    var value = _ref3.value;
    return tot += value;
  }, 0);
  var backgroundImage = 'linear-gradient(\n    to right,\n    ' + genGradientSegments(segments, total) + '\n  )';
  return React__default.createElement('div', _extends({
    className: cn(styles$49.SegmentBarChart, className),
    style: {
      backgroundImage: backgroundImage
    }
  }, props));
}

var fakePropType = function fakePropType() {
  return null;
};

fakePropType.isRequired = function () {
  return null;
};

var styles$50 = {
  "Snackbar__bar": "quid-react-components__src-components-Snackbar-__Snackbar__bar",
  "Snackbar__bar--warning": "quid-react-components__src-components-Snackbar-__Snackbar__bar--warning",
  "Snackbar": "quid-react-components__src-components-Snackbar-__Snackbar",
  "Snackbar--stacked": "quid-react-components__src-components-Snackbar-__Snackbar--stacked",
  "Snackbar--entered": "quid-react-components__src-components-Snackbar-__Snackbar--entered",
  "Snackbar--entering": "quid-react-components__src-components-Snackbar-__Snackbar--entering",
  "Snackbar--exiting": "quid-react-components__src-components-Snackbar-__Snackbar--exiting",
  "Snackbar--exited": "quid-react-components__src-components-Snackbar-__Snackbar--exited",
  "Snackbar__bar--action": "quid-react-components__src-components-Snackbar-__Snackbar__bar--action",
  "Snackbar__text": "quid-react-components__src-components-Snackbar-__Snackbar__text",
  "Snackbar__action": "quid-react-components__src-components-Snackbar-__Snackbar__action"
};
var enhance$6 = recompose.compose(recompose.setDisplayName('Snackbar'), recompose.defaultProps({
  timeout: 5000,
  importance: 'action',
  theme: 'light',
  stacked: false
}), recompose.withState('_timestamp', '_setTimestamp', String(Date.now())), recompose.withState('_timeoutId', '_setTimeoutId', null), recompose.withState('_mountAnimation', '_setMountAnimation', true), recompose.withState('_id', '_setId', null), recompose.getContext({
  _registerSnackbar: fakePropType,
  _visibleSnackbars: fakePropType
}), recompose.withHandlers(function (props) {
  return {
    _clearTimeout: function _clearTimeout(props) {
      return function () {
        return props._setTimeoutId(clearTimeout(props._timeoutId));
      };
    },
    _setTimeout: function _setTimeout(props) {
      return function () {
        return props._setTimeoutId(setTimeout(props.onTimeout, props.timeout));
      };
    },
    _updateTimestamp: function _updateTimestamp(props) {
      return function (id) {
        var timestamp = String(Date.now());

        props._setTimestamp(timestamp);

        props._registerSnackbar && props._registerSnackbar({
          id: id,
          timestamp: timestamp
        });
      };
    },
    _unregister: function _unregister(props) {
      return function (id) {
        return props._registerSnackbar && props._registerSnackbar({
          id: id,
          timestamp: null
        });
      };
    }
  };
}), recompose.lifecycle({
  componentWillMount: function componentWillMount() {
    // use `this` because we need the value to be istantly stored
    // in the component, we keep the `_id` prop to pass the value down
    this.id = nanoid();

    this.props._setId(this.id);
  },
  componentDidMount: function componentDidMount() {
    // Set to false as soon is mounted so that the explicit `open`
    // property begins to take precedence
    this.props._setMountAnimation(false);

    if (this.props.open) {
      this.props._updateTimestamp(this.id);

      this.props._setTimeout();
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    this.props._clearTimeout();

    this.props._unregister(this.id);
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    if (!this.props.open && nextProps.open) {
      // is opening
      this.props._updateTimestamp(this.id);

      this.props._setTimeout();
    } else if (this.props.open && !nextProps.open) {
      // is closing
      this.props._clearTimeout();

      this.props._unregister(this.id);
    }
  }
}), omitProps(['_updateTimestamp', '_setId', '_setTimestamp', '_setMountAnimation', '_setTimeoutId', '_clearTimeout', '_setTimeout', '_timeoutId', '_registerSnackbar', '_unregister']));

function Snackbar(_ref) {
  var open = _ref.open,
      children = _ref.children,
      renderAction = _ref.renderAction,
      importance = _ref.importance,
      theme = _ref.theme,
      className = _ref.className,
      stacked = _ref.stacked,
      _visibleSnackbars = _ref._visibleSnackbars,
      onTimeout = _ref.onTimeout,
      _timestamp = _ref._timestamp,
      _id = _ref._id,
      _mountAnimation = _ref._mountAnimation,
      props = objectWithoutProperties(_ref, ['open', 'children', 'renderAction', 'importance', 'theme', 'className', 'stacked', '_visibleSnackbars', 'onTimeout', '_timestamp', '_id', '_mountAnimation']);
  var shouldBeHidden = _visibleSnackbars && !_visibleSnackbars.includes(_id);
  var isOpen = shouldBeHidden || _mountAnimation ? false : open;
  return React__default.createElement(reactTransitionGroup.TransitionGroup, {
    style: {
      position: 'relative',
      order: _timestamp.substr(5),
      zIndex: _timestamp.substr(5)
    }
  }, isOpen && React__default.createElement(reactTransitionGroup.Transition, {
    'in': open,
    timeout: 200
  }, function (state) {
    return React__default.createElement('div', _extends({
      className: cn(styles$50.Snackbar, styles$50['Snackbar--' + state], stacked && styles$50['Snackbar--stacked'], className),
      'data-theme': theme
    }, props), React__default.createElement(PointerEvents, null, React__default.createElement('div', {
      className: cn(styles$50['Snackbar__bar'], styles$50['Snackbar__bar--' + importance])
    }, React__default.createElement('div', {
      className: styles$50.Snackbar__text
    }, children), React__default.createElement('div', {
      className: styles$50.Snackbar__action
    }, renderAction))));
  }));
}

var index$2 = enhance$6(Snackbar);
var styles$51 = {
  "SnackbarStack": "quid-react-components__src-components-SnackbarStack-__SnackbarStack"
};
var enhance$7 = recompose.compose(recompose.defaultProps({
  maxOpenSnackbars: 3
}), recompose.withState('_registeredSnackbars', '_setRegisteredSnackbars', {}), recompose.withState('_visibleSnackbars', '_setVisibleSnackbars', []), recompose.withHandlers({
  _registerSnackbar: function _registerSnackbar(props) {
    return function (snackbar) {
      var registeredSnackbars = void 0;

      props._setRegisteredSnackbars(function (_registeredSnackbars) {
        // Add snackbar to hashmap
        registeredSnackbars = _extends({}, _registeredSnackbars, defineProperty({}, snackbar.id, snackbar.timestamp));
        return registeredSnackbars;
      }, function () {
        props._setVisibleSnackbars(function () {
          return Object.keys(registeredSnackbars) // Get rid of unregistered snackbars
          .filter(function (id) {
            return registeredSnackbars[id] != null;
          }) // Sort snackbars by most recent
          .sort(function (a, b) {
            return registeredSnackbars[b] - registeredSnackbars[a];
          }) // Keep only first N snackbars
          .slice(0, props.maxOpenSnackbars);
        });
      });
    };
  }
}), recompose.withContext({
  _registerSnackbar: fakePropType,
  _visibleSnackbars: fakePropType
}, function (props) {
  return {
    _visibleSnackbars: props._visibleSnackbars,
    _registerSnackbar: props._registerSnackbar
  };
}), omitProps(['_registeredSnackbars', '_setRegisteredSnackbars', '_registerSnackbar', '_setVisibleSnackbars', '_visibleSnackbars', 'maxOpenSnackbars']));

function SnackbarStack(_ref) {
  var children = _ref.children,
      props = objectWithoutProperties(_ref, ['children']);
  return React__default.createElement(PointerEvents, {
    none: true
  }, React__default.createElement('div', _extends({
    className: styles$51.SnackbarStack
  }, props), children));
}

var index$3 = enhance$7(SnackbarStack);
var styles$52 = {
  "Spinner": "quid-react-components__src-components-Spinner-__Spinner"
};
var defaultSpinner = "\n<svg viewBox=\"0 0 40 40\" xmlns=\"http://www.w3.org/2000/svg\">\n  <style>\n    .spinner {\n      width: 40px;\n      height: 40px;\n      fill: transparent\n    }\n\n    .double-bounce1, .double-bounce2 {\n      width: 100%;\n      height: 100%;\n      border-radius: 50%;\n      fill: var(--spinnerColor);\n      opacity: 0.6;\n      position: absolute;\n      top: 0;\n      left: 0;\n      transform-origin: center;\n\n      -webkit-animation: sk-bounce 2.0s infinite ease-in-out;\n      animation: sk-bounce 2.0s infinite ease-in-out\n    }\n\n\n    .double-bounce2 {\n      -webkit-animation-delay: -1.0s;\n      animation-delay: -1.0s\n    }\n\n    @-webkit-keyframes sk-bounce {\n      0%, 100% {\n        -webkit-transform: scale(0.0);\n        transform: scale(0.0)\n      }\n      50% {\n        -webkit-transform: scale(1.0);\n        transform: scale(1.0)\n      }\n    }\n\n    @keyframes sk-bounce {\n      0%, 100% {\n        -webkit-transform: scale(0.0);\n        transform: scale(0.0)\n      }\n      50% {\n        -webkit-transform: scale(1.0);\n        transform: scale(1.0)\n      }\n    }\n  </style>\n  <g class=\"spinner\">\n    <circle class=\"double-bounce1\" cx=\"20\" cy=\"20\" r=\"20\"/>\n    <circle class=\"double-bounce2\" cx=\"20\" cy=\"20\" r=\"20\"/>\n  </g>\n</svg>\n";

function Spinner(_ref) {
  var _ref$spinner = _ref.spinner,
      spinner = _ref$spinner === undefined ? defaultSpinner : _ref$spinner,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? '#fff' : _ref$color,
      className = _ref.className,
      props = objectWithoutProperties(_ref, ['spinner', 'color', 'className']);
  var svg = {
    __html: spinner
  };
  return React__default.createElement('div', _extends({
    className: cn(styles$52.Spinner, className),
    ref: function ref(el) {
      return el && el.style.setProperty('--spinnerColor', color);
    }
  }, props), React__default.createElement('div', {
    dangerouslySetInnerHTML: svg
  }));
}

var styles$53 = {
  "Tabs__tab": "quid-react-components__src-components-Tabs-__Tabs__tab",
  "Tabs": "quid-react-components__src-components-Tabs-__Tabs",
  "Tabs__list": "quid-react-components__src-components-Tabs-__Tabs__list",
  "Tabs__listItem": "quid-react-components__src-components-Tabs-__Tabs__listItem",
  "Tabs__tab--active": "quid-react-components__src-components-Tabs-__Tabs__tab--active",
  "Tabs__panels": "quid-react-components__src-components-Tabs-__Tabs__panels",
  "Tabs__panel": "quid-react-components__src-components-Tabs-__Tabs__panel",
  "Tabs__panel--leave": "quid-react-components__src-components-Tabs-__Tabs__panel--leave",
  "Tabs__panel--leaveActive": "quid-react-components__src-components-Tabs-__Tabs__panel--leaveActive",
  "Tabs__panel--enter": "quid-react-components__src-components-Tabs-__Tabs__panel--enter",
  "Tabs__panel--enterActive": "quid-react-components__src-components-Tabs-__Tabs__panel--enterActive"
};

function TabPanel$2(_ref) {
  var label = _ref.label,
      id = _ref.id,
      className = _ref.className,
      isLeaving = _ref.isLeaving,
      props = objectWithoutProperties(_ref, ['label', 'id', 'className', 'isLeaving']);
  return React__default.createElement('div', _extends({
    id: id + '_panel',
    className: cn(styles$53.Tabs__panel, className),
    'aria-labelledby': id + '_tab'
  }, props));
}

function TabPanel$3(_ref) {
  var isActive = _ref.isActive,
      id = _ref.id,
      onClick = _ref.onClick,
      children = _ref.children,
      props = objectWithoutProperties(_ref, ['isActive', 'id', 'onClick', 'children']);
  return React__default.createElement('li', {
    className: styles$53.Tabs__listItem
  }, React__default.createElement('button', {
    className: cn(styles$53.Tabs__tab, isActive && styles$53['Tabs__tab--active']),
    id: id + '_tab',
    'aria-controls': id + '_panel',
    'aria-selected': isActive,
    role: 'tab',
    onClick: onClick
  }, children));
}

var Tabs$1 = function (_Component) {
  inherits(Tabs, _Component);

  function Tabs() {
    classCallCheck(this, Tabs);
    return possibleConstructorReturn(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).apply(this, arguments));
  }

  createClass(Tabs, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          id = _props.id,
          children = _props.children,
          activeTab = _props.activeTab,
          sideTabsContent = _props.sideTabsContent,
          onChange = _props.onChange,
          className = _props.className,
          props = objectWithoutProperties(_props, ['id', 'children', 'activeTab', 'sideTabsContent', 'onChange', 'className']);
      var activePanel = React.Children.map(children, function (child, index) {
        return child.props.name === activeTab ? React.cloneElement(child, {
          id: '' + id + index,
          key: index
        }) : undefined;
      }).filter(function (c) {
        return c;
      })[0];
      return React__default.createElement('div', _extends({
        className: cn(styles$53.Tabs, className)
      }, props), React__default.createElement('ul', {
        className: styles$53.Tabs__list,
        role: 'tablist'
      }, React.Children.map(children, function (child, index) {
        var isActive = child.props.name === activeTab;
        return React__default.createElement(TabPanel$3, {
          key: index,
          id: '' + id + index,
          isActive: isActive,
          onClick: function onClick() {
            return onChange(child.props.name);
          }
        }, child.props.label);
      }), sideTabsContent), React__default.createElement('div', {
        className: styles$53.Tabs__panels
      }, activePanel));
    }
  }]);
  return Tabs;
}(React.Component);

Tabs$1.TabPanel = TabPanel$2;
Tabs$1.Tab = TabPanel$3;
var styles$54 = {
  "TextArea": "quid-react-components__src-components-TextArea-__TextArea",
  "TextArea--invalid": "quid-react-components__src-components-TextArea-__TextArea--invalid"
};

function TextArea(_ref) {
  var _ref$focus = _ref.focus,
      focus = _ref$focus === undefined ? false : _ref$focus,
      className = _ref.className,
      _invalid = _ref._invalid,
      _setInvalid = _ref._setInvalid,
      _handleChange = _ref._handleChange,
      props = objectWithoutProperties(_ref, ['focus', 'className', '_invalid', '_setInvalid', '_handleChange']);
  return React__default.createElement(Text, _extends({
    tag: 'textarea',
    className: cn(styles$54.TextArea, focus && styles$54['TextArea--focus'], _invalid && styles$54['TextArea--invalid'], className)
  }, props, {
    onInvalid: _setInvalid,
    onChange: _handleChange
  }));
}

var index$4 = withInvalidHandler(TextArea);
var styles$55 = {
  "Action": "quid-react-components__src-components-Thumbnail-Action-__Action",
  "Action--small": "quid-react-components__src-components-Thumbnail-Action-__Action--small",
  "Action__center": "quid-react-components__src-components-Thumbnail-Action-__Action__center",
  "Action__bottom": "quid-react-components__src-components-Thumbnail-Action-__Action__bottom",
  "Action__left": "quid-react-components__src-components-Thumbnail-Action-__Action__left",
  "Action__right": "quid-react-components__src-components-Thumbnail-Action-__Action__right"
};

function Action(_ref) {
  var renderCenter = _ref.renderCenter,
      renderRight = _ref.renderRight,
      renderLeft = _ref.renderLeft,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 'regular' : _ref$size,
      className = _ref.className,
      props = objectWithoutProperties(_ref, ['renderCenter', 'renderRight', 'renderLeft', 'size', 'className']);
  return React__default.createElement('div', _extends({
    className: cn(styles$55.Action, size === 'small' && styles$55['Action--small'], className)
  }, props), React__default.createElement('div', {
    className: styles$55.Action__center
  }, renderCenter), React__default.createElement('div', {
    className: styles$55.Action__bottom
  }, React__default.createElement('div', {
    className: styles$55.Action__left
  }, renderLeft), React__default.createElement('div', {
    className: styles$55.Action__right
  }, renderRight)));
}

var styles$56 = {
  "Skeleton": "quid-react-components__src-components-Thumbnail-Skeleton-__Skeleton",
  "Skeleton--small": "quid-react-components__src-components-Thumbnail-Skeleton-__Skeleton--small",
  "Skeleton__action": "quid-react-components__src-components-Thumbnail-Skeleton-__Skeleton__action",
  "Skeleton__action--small": "quid-react-components__src-components-Thumbnail-Skeleton-__Skeleton__action--small",
  "Skeleton__title": "quid-react-components__src-components-Thumbnail-Skeleton-__Skeleton__title"
};
var SIZE_REGULAR = 'regular';
var SIZE_SMALL$1 = 'small';

function Skeleton(_ref) {
  var size = _ref.size,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? 'Loading ...' : _ref$title;
  return React__default.createElement('div', {
    className: cn(styles$56.Skeleton, size === SIZE_SMALL$1 && styles$56['Skeleton--small'])
  }, React__default.createElement('div', {
    className: cn(styles$56.Skeleton__action, size === SIZE_SMALL$1 && styles$56['Skeleton__action--small'])
  }), React__default.createElement('div', {
    className: styles$56.Skeleton__title
  }, React__default.createElement(Text.Skeleton.H1, null, title)));
}

var styles$57 = {
  "Thumbnail__titleText": "quid-react-components__src-components-Thumbnail-__Thumbnail__titleText",
  "Thumbnail__date": "quid-react-components__src-components-Thumbnail-__Thumbnail__date",
  "Thumbnail": "quid-react-components__src-components-Thumbnail-__Thumbnail",
  "Thumbnail--dragging": "quid-react-components__src-components-Thumbnail-__Thumbnail--dragging",
  "Thumbnail--disabled": "quid-react-components__src-components-Thumbnail-__Thumbnail--disabled",
  "Thumbnail__image": "quid-react-components__src-components-Thumbnail-__Thumbnail__image",
  "Thumbnail__title": "quid-react-components__src-components-Thumbnail-__Thumbnail__title",
  "Thumbnail__action": "quid-react-components__src-components-Thumbnail-__Thumbnail__action",
  "Thumbnail--small": "quid-react-components__src-components-Thumbnail-__Thumbnail--small",
  "Thumbnail__image--fullRounded": "quid-react-components__src-components-Thumbnail-__Thumbnail__image--fullRounded",
  "Thumbnail__caption": "quid-react-components__src-components-Thumbnail-__Thumbnail__caption",
  "Thumbnail__titleText--wrap": "quid-react-components__src-components-Thumbnail-__Thumbnail__titleText--wrap",
  "Thumbnail__date--wrap": "quid-react-components__src-components-Thumbnail-__Thumbnail__date--wrap",
  "Thumbnail__top": "quid-react-components__src-components-Thumbnail-__Thumbnail__top",
  "Thumbnail__action--fullRounded": "quid-react-components__src-components-Thumbnail-__Thumbnail__action--fullRounded",
  "Thumbnail__action--visible": "quid-react-components__src-components-Thumbnail-__Thumbnail__action--visible",
  "Thumbnail__separator": "quid-react-components__src-components-Thumbnail-__Thumbnail__separator"
};

var Thumbnail = function (_PureComponent) {
  inherits(Thumbnail, _PureComponent);

  function Thumbnail() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Thumbnail);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Thumbnail.__proto__ || Object.getPrototypeOf(Thumbnail)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isHoverVisible: false,
      editing: false
    }, _this.showHover = function () {
      return !!_this.props.children && _this.setState({
        isHoverVisible: true
      });
    }, _this.hideHover = function () {
      return !!_this.props.children && _this.setState({
        isHoverVisible: false
      });
    }, _this.startEditing = function () {
      return _this.setState({
        editing: true
      });
    }, _this.stopEditing = function (newTitle) {
      _this.setState({
        editing: false
      }, function () {
        return newTitle !== undefined && _this.props.onTitleChange && _this.props.onTitleChange(newTitle);
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Thumbnail, [{
    key: 'render',
    value: function render() {
      /* istanbul ignore next */
      var _props = this.props,
          img = _props.img,
          imgComponent = _props.imgComponent,
          alt = _props.alt,
          title = _props.title,
          date = _props.date,
          footer = _props.footer,
          titleWrap = _props.titleWrap,
          dateWrap = _props.dateWrap,
          disabled = _props.disabled,
          dragging = _props.dragging,
          size = _props.size,
          children = _props.children,
          onTitleChange = _props.onTitleChange,
          className = _props.className,
          hoverVisible = _props.hoverVisible,
          props = objectWithoutProperties(_props, ['img', 'imgComponent', 'alt', 'title', 'date', 'footer', 'titleWrap', 'dateWrap', 'disabled', 'dragging', 'size', 'children', 'onTitleChange', 'className', 'hoverVisible']);
      var editing = this.state.editing;
      var isHoverVisible = hoverVisible != null ? hoverVisible : this.state.isHoverVisible;
      var noCaption = !(typeof title === 'string' || typeof date === 'string' || !!footer);
      var focusable = children && !disabled;
      return React__default.createElement('figure', _extends({
        'data-context': 'thumbnail',
        'data-value': title,
        className: cn(styles$57['Thumbnail'], disabled && styles$57['Thumbnail--disabled'], dragging && styles$57['Thumbnail--dragging'], size === SIZE_SMALL$1 && styles$57['Thumbnail--small'], className)
      }, props), React__default.createElement('div', {
        className: styles$57.Thumbnail__top,
        tabIndex: !focusable ? -1 : 0,
        onFocus: this.showHover,
        onMouseEnter: this.showHover,
        onBlur: this.hideHover,
        onMouseLeave: this.hideHover,
        'aria-hidden': !isHoverVisible
      }, imgComponent ? React__default.createElement('div', {
        className: cn(styles$57['Thumbnail__image'], noCaption && styles$57['Thumbnail__image--fullRounded'])
      }, imgComponent) : React__default.createElement('img', {
        className: cn(styles$57['Thumbnail__image'], noCaption && styles$57['Thumbnail__image--fullRounded']),
        src: img,
        alt: alt
      }), children && React__default.createElement('div', {
        className: cn(styles$57['Thumbnail__action'], isHoverVisible && styles$57['Thumbnail__action--visible'], noCaption && styles$57['Thumbnail__action--fullRounded'])
      }, children)), !noCaption && React__default.createElement('figcaption', {
        className: styles$57.Thumbnail__caption
      }, typeof title === 'string' && React__default.createElement(EditableTitle, {
        wrap: titleWrap,
        className: styles$57.Thumbnail__title,
        innerClassName: cn(styles$57.Thumbnail__titleText, titleWrap && styles$57['Thumbnail__titleText--wrap']),
        onEditBegin: !disabled && onTitleChange ? this.startEditing : undefined,
        onSave: this.stopEditing,
        onCancel: this.stopEditing,
        editing: editing,
        value: title
      }), typeof date === 'string' && React__default.createElement('p', {
        className: cn(styles$57.Thumbnail__date, dateWrap && styles$57['Thumbnail__date--wrap'])
      }, date), !!footer && React__default.createElement(Separator, {
        className: styles$57.Thumbnail__separator
      }), footer));
    }
  }]);
  return Thumbnail;
}(React.PureComponent);

Thumbnail.defaultProps = {
  titleWrap: false,
  dateWrap: false,
  disabled: false,
  dragging: false,
  size: SIZE_REGULAR
};
Thumbnail.Skeleton = Skeleton;
Thumbnail.Action = Action;
var styles$58 = {
  "TimelineChart": "quid-react-components__src-components-TimelineChart-__TimelineChart",
  "TimelineChart__chart": "quid-react-components__src-components-TimelineChart-__TimelineChart__chart",
  "TimelineChart__labels": "quid-react-components__src-components-TimelineChart-__TimelineChart__labels"
};
var styles$59 = {
  "Bar": "quid-react-components__src-components-TimelineChart-Bar-__Bar"
};

function Bar(_ref) {
  var total = _ref.total,
      active = _ref.active,
      color = _ref.color,
      className = _ref.className,
      props = objectWithoutProperties(_ref, ['total', 'active', 'color', 'className']);
  var backgroundImage = '\n    linear-gradient(to top, ' + color + ' ' + active + '%, transparent ' + active + '%),\n    linear-gradient(to top, currentColor ' + total + '%, transparent ' + total + '%)\n  ';
  return React__default.createElement('div', _extends({
    className: cn(styles$59.Bar, className),
    style: {
      backgroundImage: backgroundImage
    }
  }, props));
}

function getPercentage(value, max) {
  return 100 / max * value;
}

function TimelineChart(_ref) {
  var data = _ref.data,
      max = _ref.max,
      labelLeft = _ref.labelLeft,
      labelRight = _ref.labelRight,
      className = _ref.className,
      props = objectWithoutProperties(_ref, ['data', 'max', 'labelLeft', 'labelRight', 'className']);
  return React__default.createElement('div', _extends({
    className: cn(styles$58.TimelineChart, className)
  }, props), React__default.createElement('div', {
    className: styles$58.TimelineChart__chart
  }, data.map(function (_ref2, key) {
    var total = _ref2.total,
        active = _ref2.active,
        color = _ref2.color;
    var totalPerc = getPercentage(total, max);
    var activePerc = getPercentage(active, max);
    return React__default.createElement(Bar, {
      key: key,
      total: totalPerc,
      active: activePerc,
      color: color
    });
  })), React__default.createElement('div', {
    className: styles$58.TimelineChart__labels
  }, React__default.createElement(Label, {
    secondary: true,
    noMargin: true
  }, labelLeft), React__default.createElement(Label, {
    secondary: true,
    noMargin: true
  }, labelRight)));
}

var styles$60 = {
  "ToggleableSection__content": "quid-react-components__src-components-ToggleableSection-__ToggleableSection__content",
  "ToggleableSection": "quid-react-components__src-components-ToggleableSection-__ToggleableSection",
  "ToggleableSection__header": "quid-react-components__src-components-ToggleableSection-__ToggleableSection__header",
  "ToggleableSection__header--clickable": "quid-react-components__src-components-ToggleableSection-__ToggleableSection__header--clickable",
  "ToggleableSection__toggle": "quid-react-components__src-components-ToggleableSection-__ToggleableSection__toggle",
  "ToggleableSection__icon": "quid-react-components__src-components-ToggleableSection-__ToggleableSection__icon",
  "ToggleableSection__icon--open": "quid-react-components__src-components-ToggleableSection-__ToggleableSection__icon--open",
  "ToggleableSection__animateHeight": "quid-react-components__src-components-ToggleableSection-__ToggleableSection__animateHeight"
};

function ToggleableSection(_ref) {
  var _ref$duration = _ref.duration,
      duration = _ref$duration === undefined ? 500 : _ref$duration,
      title = _ref.title,
      isOpen = _ref.isOpen,
      onToggle = _ref.onToggle,
      children = _ref.children,
      _ref$readOnly = _ref.readOnly,
      readOnly = _ref$readOnly === undefined ? false : _ref$readOnly,
      contentClassName = _ref.contentClassName,
      height = _ref.height,
      className = _ref.className,
      props = objectWithoutProperties(_ref, ['duration', 'title', 'isOpen', 'onToggle', 'children', 'readOnly', 'contentClassName', 'height', 'className']);
  var computedHeight = height !== undefined ? height : isOpen ? 'auto' : 0;

  var handleToggle = function handleToggle(evt) {
    evt.stopPropagation();
    onToggle && !readOnly && onToggle(!isOpen);
  };

  var dataAction = 'toggle-' + kebabCase(title) + '-section';
  var dataValue = isOpen ? 'closed' : 'open';
  return React__default.createElement('section', _extends({
    className: cn(styles$60.ToggleableSection, className)
  }, props), React__default.createElement('header', {
    'data-action': dataAction,
    'data-value': dataValue,
    onClick: handleToggle,
    className: cn(styles$60.ToggleableSection__header, !readOnly && styles$60['ToggleableSection__header--clickable']),
    tabIndex: !readOnly ? -1 : undefined
  }, React__default.createElement(Text, null, title), !readOnly && React__default.createElement(Button$1, {
    className: styles$60.ToggleableSection__toggle,
    size: 'small',
    onClick: handleToggle,
    'data-action': dataAction,
    'data-value': dataValue
  }, React__default.createElement(Icon$1, {
    name: 'chevron_right',
    className: cn(styles$60['ToggleableSection__icon'], isOpen && styles$60['ToggleableSection__icon--open'])
  }))), React__default.createElement(AnimateHeight, {
    className: styles$60.ToggleableSection__animateHeight,
    contentClassName: cn(styles$60.ToggleableSection__content, contentClassName),
    height: computedHeight,
    duration: duration
  }, children));
}

var styles$61 = {
  "Typeahead": "quid-react-components__src-components-Typeahead-__Typeahead",
  "Typeahead__dropdown": "quid-react-components__src-components-Typeahead-__Typeahead__dropdown",
  "Typeahead__input": "quid-react-components__src-components-Typeahead-__Typeahead__input",
  "Typeahead__input--focus": "quid-react-components__src-components-Typeahead-__Typeahead__input--focus",
  "Typeahead__caret": "quid-react-components__src-components-Typeahead-__Typeahead__caret",
  "Typeahead--disabled": "quid-react-components__src-components-Typeahead-__Typeahead--disabled",
  "Typeahead__transitionGroup": "quid-react-components__src-components-Typeahead-__Typeahead__transitionGroup",
  "Typeahead__dropdownAnimation": "quid-react-components__src-components-Typeahead-__Typeahead__dropdownAnimation",
  "Typeahead__dropdownAnimation--entering": "quid-react-components__src-components-Typeahead-__Typeahead__dropdownAnimation--entering",
  "Typeahead__dropdownAnimation--entered": "quid-react-components__src-components-Typeahead-__Typeahead__dropdownAnimation--entered",
  "Typeahead__dropdownAnimation--exiting": "quid-react-components__src-components-Typeahead-__Typeahead__dropdownAnimation--exiting",
  "Typeahead__dropdownAnimation--exited": "quid-react-components__src-components-Typeahead-__Typeahead__dropdownAnimation--exited"
};
var styles$62 = {
  "Item": "quid-react-components__src-components-Typeahead-Item-__Item",
  "Item__option": "quid-react-components__src-components-Typeahead-Item-__Item__option",
  "Item__option--focus": "quid-react-components__src-components-Typeahead-Item-__Item__option--focus",
  "Item__option--active": "quid-react-components__src-components-Typeahead-Item-__Item__option--active",
  "Item__heading": "quid-react-components__src-components-Typeahead-Item-__Item__heading",
  "Item__divider": "quid-react-components__src-components-Typeahead-Item-__Item__divider",
  "Item__button": "quid-react-components__src-components-Typeahead-Item-__Item__button"
};
var SEPARATOR = 'separator';
var HEADING = 'heading';
var BUTTON = 'button';

var Item$3 = function (_Component) {
  inherits(Item, _Component);

  function Item() {
    classCallCheck(this, Item);
    return possibleConstructorReturn(this, (Item.__proto__ || Object.getPrototypeOf(Item)).apply(this, arguments));
  }

  createClass(Item, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          type = _props.type,
          label = _props.label,
          isActive = _props.isActive,
          isFocused = _props.isFocused,
          onKeyDown = _props.onKeyDown,
          onClick = _props.onClick,
          reFocus = _props.reFocus,
          className = _props.className,
          props = objectWithoutProperties(_props, ['type', 'label', 'isActive', 'isFocused', 'onKeyDown', 'onClick', 'reFocus', 'className']);
      var item = void 0;

      switch (type) {
        case SEPARATOR:
          item = React__default.createElement('hr', {
            onClick: reFocus,
            className: styles$62.Item__divider
          });
          break;

        case HEADING:
          item = React__default.createElement('span', {
            onClick: reFocus,
            className: styles$62.Item__heading
          }, label);
          break;

        case BUTTON:
          item = React__default.createElement(Button$1, {
            className: styles$62.Item__button,
            size: 'small',
            tabIndex: -1,
            onKeyDown: onKeyDown,
            onClick: onClick,
            getRef: function getRef(el) {
              return el !== null && (_this2.focusTarget = el);
            },
            'data-action': 'select',
            'data-value': label && kebabCase(label)
          }, label);
          break;

        default:
          item = React__default.createElement('button', {
            className: cn(styles$62.Item__option, !!isActive && styles$62['Item__option--active'], !!isFocused && styles$62['Item__option--focus']),
            type: 'button',
            tabIndex: -1,
            onKeyDown: onKeyDown,
            onClick: onClick,
            ref: function ref(el) {
              return el !== null && (_this2.focusTarget = el);
            },
            'data-action': 'select',
            'data-value': label && kebabCase(label)
          }, label);
      }

      return React__default.createElement('li', _extends({
        className: cn(styles$62.Item, className),
        tabIndex: -1,
        onClick: reFocus
      }, props), item);
    }
  }]);
  return Item;
}(React.Component);

var ENTER$2 = 13;
var UP$1 = 38;
var DOWN$1 = 40;
var ESC$2 = 27;

var ConditionalPortal = function ConditionalPortal(_ref) {
  var children = _ref.children,
      target = _ref.target,
      enabled = _ref.enabled;
  return enabled && target instanceof HTMLElement ? reactDom.createPortal(children, target) : children;
};

function getHTMLInputRef(input) {
  var el = reactDom.findDOMNode(input);
  return el instanceof HTMLInputElement ? el : undefined;
} // Detect if the current item is focusable


function isFocusable(type) {
  return ![SEPARATOR, HEADING].includes(type);
} // Used to filter the items based on the current value
// can be overridden defining a custom `filter` prop


function defaultFilter(items, value) {
  if (!value) {
    return items;
  }

  return items.filter(function (_ref2) {
    var label = _ref2.label,
        type = _ref2.type;

    if ([SEPARATOR, HEADING, BUTTON].includes(type)) {
      return false;
    }

    return !!label && label.toLowerCase().includes(value.toLowerCase());
  });
}

function findItemByLabel(label, items) {
  return items.filter(function (_ref3) {
    var type = _ref3.type;
    return isFocusable(type);
  }).find(function (item) {
    return item.label === label;
  });
}

function moveIndex(which, index, items) {
  var max = items.length - 1;
  var newIndex = index;

  if (which === UP$1) {
    newIndex = Math.max(index - 1, 0);
  } else {
    newIndex = Math.min(index + 1, max);
  }

  if (isFocusable(items[newIndex].type)) {
    return newIndex;
  }

  return moveIndex(which, newIndex, items);
} // $FlowFixMe There are problems with the seperator item, we'll refactor this once we move to Emotion


var Typeahead = function (_Component) {
  inherits(Typeahead, _Component);

  function Typeahead() {
    var _ref4;

    var _temp, _this, _ret;

    classCallCheck(this, Typeahead);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref4 = Typeahead.__proto__ || Object.getPrototypeOf(Typeahead)).call.apply(_ref4, [this].concat(args))), _this), _this.state = {
      value: _this.props.activeItem.label,
      focusedIndex: -1
    }, _this.focusableItems = [], _this.handleFocus = function (evt) {
      var el = reactDom.findDOMNode(_this);

      if (el && !el.contains(evt.relatedTarget)) {
        _this.setState({
          value: '',
          focusedIndex: 0
        });
      }

      _this.props.onFocus(evt);
    }, _this.handleChange = function (evt) {
      _this.setState({
        value: evt.target.value
      });
    }, _this.handleBlur = function (evt) {
      var el = reactDom.findDOMNode(_this);
      var relatedTarget = evt.relatedTarget,
          target = evt.target;

      if (!_this.props.isOpen) {
        return;
      }

      if (el && el.contains(relatedTarget)) {
        return;
      }

      if (_this.portalNode && _this.portalNode.contains(relatedTarget || target)) {
        return;
      }

      var _this$props = _this.props,
          items = _this$props.items,
          onBlur = _this$props.onBlur,
          activeItem = _this$props.activeItem;
      var matchingItem = findItemByLabel(target.value, items); // If no item matches, restore the input value to
      // the label of the active item

      if (!matchingItem) {
        _this.setState({
          value: activeItem.label
        });
      } // When we blur, we set this to -1 to avoid the component
      //  to capture the focus again


      _this.setState({
        focusedIndex: -1
      }); // Send an onBlur event passing the original event


      onBlur(evt);
    }, _this.handleSelect = function (evt, item) {
      evt.persist();

      _this.setState({
        value: item.label,
        focusedIndex: -1
      }, function () {
        _this.props.onSelect(item);

        _this.props.onBlur(evt);

        evt.target.blur();
      });
    }, _this.reFocus = function () {
      return _this.setState(function (_ref5) {
        var focusedIndex = _ref5.focusedIndex;
        return {
          focusedIndex: focusedIndex
        };
      });
    }, _this.handleKeyDown = function (evt, item) {
      evt.persist();
      var which = evt.which; // On enter on type BUTTON, let it handle the event

      if (which === ENTER$2 && item && item.type === BUTTON) {
        return;
      } // On enter, select the currently focused element or try to find a matching
      // element using the value of the input field


      if (which === ENTER$2) {
        if (item) {
          return _this.handleSelect(evt, item);
        }

        evt.target.blur();
        return _this.handleBlur(evt);
      } // On press UP or DOWN, move the focused index by 1


      if (which === UP$1 || which === DOWN$1) {
        _this.setState(function (_ref6) {
          var focusedIndex = _ref6.focusedIndex;
          evt.preventDefault();

          var filteredItems = _this.props.filter(_this.props.items, _this.state.value);

          var nextFocusedIndex = moveIndex(which, focusedIndex, [{}].concat(toConsumableArray(filteredItems)));
          return {
            focusedIndex: nextFocusedIndex
          };
        });

        return;
      } // If press ESC, close the dropdown and lose focus


      if (which === ESC$2) {
        _this.handleBlur(evt);

        document.activeElement && document.activeElement.blur();
        return;
      } // If any other key is pressed, redirect it to the input field to let
      // the user write in it without having to focus it manually


      _this.setState({
        focusedIndex: 0
      });
    }, _this.focusElement = function (index, el) {
      if (!!el && index === _this.state.focusedIndex) {
        // If a focusTarget prop is defined on the child element
        // focus it, otherwise focus directly the given element
        var node = reactDom.findDOMNode(el.focusTarget || el);
        node instanceof HTMLElement && node.focus();
      }
    }, _this.focusActiveElement = function (items, activeItem) {
      var activeIndex = items.findIndex(function (_ref7) {
        var value = _ref7.value;
        return value === activeItem.value;
      });

      _this.setState({
        focusedIndex: activeIndex + 1
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  } // This is called when the focus goes to any element outside
  // of this component
  // This is called when the user clicks on one of the dropdown options
  // Refresh focus to make sure the focused element stays focused
  // useful when user clicks on heading elements


  createClass(Typeahead, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // If activeItem changes, update the input value
      if (nextProps.activeItem.label !== this.props.activeItem.label) {
        this.setState({
          value: nextProps.activeItem.label
        });
      } // If dropdown is opening, focus the active element


      if (nextProps.isOpen === true && nextProps.isOpen !== this.props.isOpen) {
        this.focusActiveElement(nextProps.items, nextProps.activeItem);
      }
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var renderOnElement = this.props.renderOnElement; // We need to append to the DOM a div of which we'll keep reference
      // so that we can detect if a blur or mouse event targets an element
      // outside of this component's elements

      if (renderOnElement) {
        this.portalNode = document.createElement('div');
        var renderTargetNode = document.querySelector(renderOnElement); // Else ignored from coverage because it's just for type safety

        /* istanbul ignore else */

        if (renderTargetNode && this.portalNode) {
          renderTargetNode.appendChild(this.portalNode);
        }
      }

      if (this.props.isOpen) {
        this.focusActiveElement(this.props.items, this.props.activeItem);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var renderOnElement = this.props.renderOnElement;

      if (renderOnElement) {
        var renderTargetNode = document.querySelector(renderOnElement); // Else ignored from coverage because it's just for type safety

        /* istanbul ignore else */

        if (renderTargetNode && this.portalNode) {
          renderTargetNode.removeChild(this.portalNode);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          width = _props.width,
          isOpen = _props.isOpen,
          filter = _props.filter,
          items = _props.items,
          activeItem = _props.activeItem,
          disabled = _props.disabled,
          renderOnElement = _props.renderOnElement,
          _props$theme = _props.theme,
          theme = _props$theme === undefined ? 'dark' : _props$theme,
          _props$placement = _props.placement,
          placement = _props$placement === undefined ? 'bottom' : _props$placement,
          _props$popperModifier = _props.popperModifiers,
          popperModifiers = _props$popperModifier === undefined ? {} : _props$popperModifier,
          dataContext = _props['data-context'];
      var _state = this.state,
          value = _state.value,
          focusedIndex = _state.focusedIndex;
      var isReallyOpen = isOpen && !disabled;
      var itemElements = filter(items, value).map(function (item, index) {
        return React__default.createElement(Item$3, _extends({
          onClick: function onClick(evt) {
            return _this2.handleSelect(evt, item);
          },
          key: index,
          onBlur: _this2.handleBlur,
          onKeyDown: function onKeyDown(evt) {
            return _this2.handleKeyDown(evt, item);
          },
          ref: function ref(el) {
            return _this2.focusElement(index + 1, el);
          },
          isActive: item.value === activeItem.value,
          isFocused: focusedIndex - 1 === index,
          reFocus: _this2.reFocus
        }, item));
      });
      var target = React__default.createElement(reactPopper.Target, {
        className: cn(styles$61.Typeahead__input, isReallyOpen && styles$61['Typeahead__input--focus']),
        component: 'input',
        onBlur: this.handleBlur,
        type: 'text',
        value: value,
        placeholder: activeItem.label,
        onChange: !disabled ? this.handleChange : undefined,
        onFocus: !disabled ? this.handleFocus : undefined,
        style: {
          width: width
        },
        onKeyDown: !disabled ? function (evt) {
          return _this2.handleKeyDown(evt, findItemByLabel(value, items));
        } : undefined,
        innerRef: !disabled ? function (el) {
          return (_this2.input = getHTMLInputRef(el)) && _this2.focusElement(0, el);
        } : undefined,
        disabled: disabled
      });
      var caret = !isOpen && React__default.createElement('div', {
        className: styles$61.Typeahead__caret
      }, React__default.createElement(Icon$1, {
        name: 'caret_down'
      }));
      this.focusableItems = [target].concat(itemElements);
      return React__default.createElement(MouseOutside, {
        onClickOutside: this.handleBlur
      }, React__default.createElement(reactPopper.Manager, {
        className: cn(styles$61.Typeahead, disabled && styles$61['Typeahead--disabled'])
      }, target, caret, isReallyOpen && React__default.createElement(ConditionalPortal, {
        target: this.portalNode,
        enabled: renderOnElement != null
      }, React__default.createElement(reactPopper.Popper, {
        component: 'nav',
        className: styles$61.Typeahead__dropdown,
        style: {
          width: width
        },
        'data-theme': theme,
        'data-context': dataContext,
        modifiers: _extends({
          preventOverflow: {
            padding: 0
          }
        }, popperModifiers),
        placement: placement
      }, React__default.createElement('ul', null, itemElements)))));
    }
  }]);
  return Typeahead;
}(React.Component);

Typeahead.defaultProps = {
  width: '100%',
  filter: defaultFilter,
  isOpen: false,
  disabled: false
}; // THIS FILE WAS AUTOGENERATED BY REACT-COMPONENTS, DO NOT EDIT IT MANUALLY

exports.BasicPanel = BasicPanel;
exports.Breadcrumb = Breadcrumb;
exports.Button = Button$1;
exports.ButtonGroup = ButtonGroup;
exports.ButtonMenu = ButtonMenu;
exports.Calendar = Calendar;
exports.Card = Card;
exports.Carousel = Carousel;
exports.CircularMetricPoint = CircularMetricPoint;
exports.ClickOutside = ClickOutside;
exports.ColorPalettePicker = ColorPalettePicker;
exports.ContextMenu = ContextMenu$1;
exports.Dropdown = Dropdown;
exports.EditableTitle = EditableTitle;
exports.Ellipsis = Ellipsis;
exports.EntityList = EntityList;
exports.ExpandableTable = ExpandableTable;
exports.Filmstrip = Filmstrip;
exports.FilterMenu = FilterMenu;
exports.Footer = Footer;
exports.HeapAnalyticsWrapper = HeapAnalyticsWrapper;
exports.Heatmap = Heatmap;
exports.HorizontalSpinner = HorizontalSpinner;
exports.Icon = Icon$1;
exports.InfoPanel = InfoPanel;
exports.InputAutosize = InputAutosize;
exports.InputCheckbox = InputCheckbox$1;
exports.InputColor = InputColor;
exports.InputDate = InputDate;
exports.InputFile = index;
exports.InputGroup = InputGroup;
exports.InputNumber = InputNumber;
exports.InputRadio = InputRadio$1;
exports.InputRange = InputRange;
exports.InputText = InputText$1;
exports.InputToggle = InputToggle;
exports.Label = Label;
exports.Logo = Logo;
exports.Margin = Margin;
exports.Markdown = Markdown;
exports.Modal = index$1;
exports.MouseOutside = MouseOutside;
exports.Navbar = Navbar$1;
exports.Panel = Panel$1;
exports.PillList = PillList;
exports.PointerEvents = PointerEvents;
exports.Popover = Popover;
exports.QuadrantTab = QuadrantTab;
exports.RadialGaugeChart = RadialGaugeChart;
exports.Scroller = Scroller;
exports.SegmentBarChart = SegmentBarChart;
exports.Separator = Separator;
exports.Snackbar = index$2;
exports.SnackbarStack = index$3;
exports.Spinner = Spinner;
exports.Tabs = Tabs$1;
exports.TabsProvider = TabsProvider;
exports.Text = Text;
exports.TextArea = index$4;
exports.Thumbnail = Thumbnail;
exports.TimelineChart = TimelineChart;
exports.ToggleableSection = ToggleableSection;
exports.Tooltip = Tooltip;
exports.Typeahead = Typeahead;
exports.VirtualList = VirtualList$1;